{
  "ASPxReportsStringId.DocumentViewer_ExternalRibbonNotFound_Error": "Cannot find a toolbar control with the specified name: '{0}'.",
  "ASPxReportsStringId.DocumentViewer_NoRemoteDocumentInformation_Error": "This command cannot be executed because a document has not yet been generated.",
  "ASPxReportsStringId.DocumentViewer_RemoteAuthenticatorCredential_Error": "The user credentials cannot be empty.",
  "ASPxReportsStringId.DocumentViewer_RemoteAuthenticatorLogin_Error": "Failed to log in with the specified user credentials.",
  "ASPxReportsStringId.DocumentViewer_RemotePageByPage_Error": "To view a remote report, enable the PageByPage property of the SettingsReportViewer.",
  "ASPxReportsStringId.DocumentViewer_RemoteSourceConnection_Error": "The specified Report Service has not been found.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_DocumentMap": "Document Map",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_FindText": "Find Text",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_FirstPage": "First Page",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_LastPage": "Last Page",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_NextPage": "Next Page",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_ParametersPanel": "Parameters Panel",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_PreviousPage": "Previous Page",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_PrintPage": "Print Page",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_PrintReport": "Print Report",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_SaveToFile": "Save To File",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_SaveToWindow": "Save To Window",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_DocumentMap": "Navigate through the report's hierarchy of bookmarks.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_FindText": "Find text in the document.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_FirstPage": "Display the first document page.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_LastPage": "Display the last document page.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_NextPage": "Display the next document page.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_ParametersPanel": "Access and modify the report parameter values.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_PreviousPage": "Display the previous document page.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_PrintPage": "Specify the print settings and print the current page.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_PrintReport": "Specify the print settings and print the document.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_SaveToFile": "Save the document to a file in a specified format.",
  "ASPxReportsStringId.DocumentViewer_RibbonCurrentPageText": "Current Page",
  "ASPxReportsStringId.DocumentViewer_RibbonCurrentPageToolTip": "Display the specified page.",
  "ASPxReportsStringId.DocumentViewer_RibbonExportGroupText": "Export",
  "ASPxReportsStringId.DocumentViewer_RibbonHomeTabText": "Home",
  "ASPxReportsStringId.DocumentViewer_RibbonNavigationGroupText": "Navigation",
  "ASPxReportsStringId.DocumentViewer_RibbonPageCountText": "Page Count:",
  "ASPxReportsStringId.DocumentViewer_RibbonPrintGroupText": "Print",
  "ASPxReportsStringId.DocumentViewer_RibbonReportGroupText": "Report",
  "ASPxReportsStringId.ExportName_csv": "CSV",
  "ASPxReportsStringId.ExportName_docx": "DOCX",
  "ASPxReportsStringId.ExportName_html": "HTML",
  "ASPxReportsStringId.ExportName_mht": "MHT",
  "ASPxReportsStringId.ExportName_pdf": "PDF",
  "ASPxReportsStringId.ExportName_png": "Image",
  "ASPxReportsStringId.ExportName_rtf": "RTF",
  "ASPxReportsStringId.ExportName_txt": "Text",
  "ASPxReportsStringId.ExportName_xls": "XLS",
  "ASPxReportsStringId.ExportName_xlsx": "XLSX",
  "ASPxReportsStringId.List_More": "More",
  "ASPxReportsStringId.ParametersPanel_False": "No",
  "ASPxReportsStringId.ParametersPanel_GenericRegexValidationError": "The value is not valid.",
  "ASPxReportsStringId.ParametersPanel_Reset": "Reset",
  "ASPxReportsStringId.ParametersPanel_Submit": "Submit",
  "ASPxReportsStringId.ParametersPanel_True": "Yes",
  "ASPxReportsStringId.ReportDesigner_FieldListActions_Rename": "Rename",
  "ASPxReportsStringId.ReportDesigner_FontOptions_Unit_Document": "Document",
  "ASPxReportsStringId.ReportDesigner_FontOptions_Unit_Point": "Point",
  "ASPxReportsStringId.ReportDesigner_GaugeViewType_Linear": "Linear",
  "ASPxReportsStringId.ReportDesigner_Groups": "Groups",
  "ASPxReportsStringId.ReportDesigner_MasterDetailWizard_ChooseDataMembers_SelectDataFields": "Select data fields",
  "ASPxReportsStringId.ReportDesigner_MasterDetailWizard_SummaryOptions_SelectFieldsAndSummaries": "Select fields and assign summary functions to them",
  "ASPxReportsStringId.ReportDesigner_MasterDetailWizard_SummaryOptions_SummaryFunctions": "Summary Functions",
  "ASPxReportsStringId.ReportDesigner_MenuButtons_RunWizard": "Run Wizard",
  "ASPxReportsStringId.ReportDesigner_Menu_Text": "Menu",
  "ASPxReportsStringId.ReportDesigner_NameUniqueError": "Name is not unique",
  "ASPxReportsStringId.ReportDesigner_ParametersDialog_AddParameter": "Add Parameter",
  "ASPxReportsStringId.ReportDesigner_ParametersDialog_GroupOrientation": "Orientation",
  "ASPxReportsStringId.ReportDesigner_ParametersDialog_GroupTitle": "Title",
  "ASPxReportsStringId.ReportDesigner_PropertyGrid_AutoValueString": "(Auto)",
  "ASPxReportsStringId.ReportDesigner_ScriptEditor_Toolbar_SelectEvent": "Select event...",
  "ASPxReportsStringId.ReportDesigner_StylesEditor_CreateNew": "Create a New Style",
  "ASPxReportsStringId.ReportDesigner_SummaryEditor_Weight": "Weight",
  "ASPxReportsStringId.ReportDesigner_TableActions_DeleteColumn": "Delete Column",
  "ASPxReportsStringId.ReportDesigner_TableActions_DeleteRow": "Delete Row",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertCell": "Insert Cell",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertColumnToLeft": "Insert Column To the Left",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertColumnToRight": "Insert Column To the Right",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertRowBelow": "Insert Row Below",
  "ASPxReportsStringId.ReportDesigner_Tables": "Tables",
  "ASPxReportsStringId.ReportDesigner_TextAlignment_Horizontal": "Horizontal",
  "ASPxReportsStringId.ReportDesigner_TextAlignment_Vertical": "Vertical",
  "ASPxReportsStringId.ReportDesigner_Wizard_AddGroup_Text": "Add Group",
  "ASPxReportsStringId.ReportDesigner_Wizard_AddSummaryFields_Placeholder": "To add a summary field to the report, select a data field (numeric, date-time or boolean) and ensure that it is not used in groups.",
  "ASPxReportsStringId.ReportDesigner_Wizard_ChooseColumns_Description": "Select the columns you want to display within your report.",
  "ASPxReportsStringId.ReportDesigner_Wizard_ChooseColumns_Title": "Choose Columns to Display in Your Report",
  "ASPxReportsStringId.ReportDesigner_Wizard_ColorScheme_Description": "Choose a report color scheme.",
  "ASPxReportsStringId.ReportDesigner_Wizard_CreateNewDataSource": "No, I'd like to create a new SQL data source",
  "ASPxReportsStringId.ReportDesigner_Wizard_DataSourceHeader": "Data Source Wizard",
  "ASPxReportsStringId.ReportDesigner_Wizard_Header": "Report Wizard",
  "ASPxReportsStringId.ReportDesigner_Wizard_Height": "Height:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_BottomMargin": "Bottom:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_LeftMargin": "Left:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_Orientation": "Orientation:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_Paper": "Paper",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_RightMargin": "Right:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_Size": "Size:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_TopMargin": "Top:",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportComplete_Title": "The Report is Complete",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Landscape": "Landscape",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Outline1": "Outline 1",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Outline2": "Outline 2",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Portrait": "Portrait",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Tabular": "Tabular",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Bold": "Bold",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Caption": "Caption",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Corporate": "Corporate",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Data": "Data",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Formal": "Formal",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Title": "Title",
  "ASPxReportsStringId.ReportDesigner_Wizard_SpecifyPageSettingsColorScheme": "Specify page settings and a report color scheme.",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryFields_Text": "Field",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Average": "Average",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Count": "Count",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Max": "Max",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Min": "Min",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Sum": "Sum",
  "ASPxReportsStringId.ReportDesigner_Wizard_TopMargin": "Top Margin:",
  "ASPxReportsStringId.ReportDesigner_Wizard_Width": "Width:",
  "ASPxReportsStringId.SearchDialog_Cancel": "Cancel",
  "ASPxReportsStringId.SearchDialog_Case": "Match case",
  "ASPxReportsStringId.SearchDialog_Down": "Down",
  "ASPxReportsStringId.SearchDialog_EnterText": "Enter the text to find in the document.",
  "ASPxReportsStringId.SearchDialog_FindNext": "Find Next",
  "ASPxReportsStringId.SearchDialog_FindWhat": "Find&nbsp;what",
  "ASPxReportsStringId.SearchDialog_Finished": "Finished searching the document.",
  "ASPxReportsStringId.SearchDialog_Header": "Search",
  "ASPxReportsStringId.SearchDialog_SearchButton": "Search",
  "ASPxReportsStringId.SearchDialog_Up": "Up",
  "ASPxReportsStringId.SearchDialog_WholeWord": "Match whole word only",
  "ASPxReportsStringId.SidePanel_Collapse": "Collapse",
  "ASPxReportsStringId.SidePanel_Open": "Open",
  "ASPxReportsStringId.ToolBarItemText_Design": "Design",
  "ASPxReportsStringId.ToolBarItemText_FirstPage": "First Page",
  "ASPxReportsStringId.ToolBarItemText_LastPage": "Last Page",
  "ASPxReportsStringId.ToolBarItemText_NextPage": "Next Page",
  "ASPxReportsStringId.ToolBarItemText_OfLabel": "of",
  "ASPxReportsStringId.ToolBarItemText_PageLabel": "Page",
  "ASPxReportsStringId.ToolBarItemText_Preview": "Preview",
  "ASPxReportsStringId.ToolBarItemText_PreviousPage": "Previous Page",
  "ASPxReportsStringId.ToolBarItemText_PrintPage": "Print the current page",
  "ASPxReportsStringId.ToolBarItemText_PrintReport": "Print the report",
  "ASPxReportsStringId.ToolBarItemText_SaveToDisk": "Export a report and save it to the disk",
  "ASPxReportsStringId.ToolBarItemText_SaveToWindow": "Export a report and show it in a new window",
  "ASPxReportsStringId.ToolBarItemText_Search": "Display the search window",
  "ASPxReportsStringId.WebDocumentViewer_0Pages": "0 pages",
  "ASPxReportsStringId.WebDocumentViewer_AriaLabelZoomCombobox": "Zoom",
  "ASPxReportsStringId.WebDocumentViewer_CustomDocumentOperationsDenied_Error": "The requested document operation cannot be performed.",
  "ASPxReportsStringId.WebDocumentViewer_DocumentCreationError": "Cannot create a document for the current report",
  "ASPxReportsStringId.WebDocumentViewer_DrillThroughError": "Drill through operation failed",
  "ASPxReportsStringId.WebDocumentViewer_ExportError": "An error occurred during the export",
  "ASPxReportsStringId.WebDocumentViewer_ExportToText": "Export To",
  "ASPxReportsStringId.WebDocumentViewer_InitializationError": "The report preview initialization has failed",
  "ASPxReportsStringId.WebDocumentViewer_SearchError": "An error occurred during search",
  "ASPxReportsStringId.WebDocumentViewer_SearchResultText": "Search result",
  "ChartDesignerStringIDs.AnnotationFreePosition": "Free Position",
  "ChartDesignerStringIDs.AnnotationRelativePosition": "Relative Position",
  "ChartDesignerStringIDs.AreaFullStackedSeries2D": "Full-Stacked Area 2D",
  "ChartDesignerStringIDs.AreaFullStackedSeries3D": "Full-Stacked Area 3D",
  "ChartDesignerStringIDs.AreaSeries2D": "Area 2D",
  "ChartDesignerStringIDs.AreaSeries3D": "Area 3D",
  "ChartDesignerStringIDs.AreaStackedSeries2D": "Stacked Area 2D",
  "ChartDesignerStringIDs.AreaStackedSeries3D": "Stacked Area 3D",
  "ChartDesignerStringIDs.AreaStepFullStackedSeries2D": "Full-Stacked Step Area 2D",
  "ChartDesignerStringIDs.AreaStepSeries2D": "Step Area 2D",
  "ChartDesignerStringIDs.Auto": "Auto",
  "ChartDesignerStringIDs.AxisCategoryTitle": "Axis Options",
  "ChartDesignerStringIDs.AxisOptions_AppearanceGroup": "Appearance",
  "ChartDesignerStringIDs.AxisOptions_AxisAlignment": "Alignment",
  "ChartDesignerStringIDs.AxisOptions_AxisKind": "Position",
  "ChartDesignerStringIDs.AxisOptions_AxisKindNoneCaption": "None",
  "ChartDesignerStringIDs.AxisOptions_AxisKindNoneDescription": "Do not display the axis.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_BottomCaption": "Show At Bottom",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_BottomDescription": "Show the axis at the bottom of a diagram.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_CircularAxisYVisibleCaption": "Show Axis",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_CircularAxisYVisibleDescription": "Show the Axis Y.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_LeftCaption": "Show On Left",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_LeftDescription": "Show the axis on the left of a diagram.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_RightCaption": "Show On Right",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_RightDescription": "Show the axis on the right of a diagram.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_TopCaption": "Show On Top",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_TopDescription": "Show the axis on the top of a diagram.",
  "ChartDesignerStringIDs.AxisOptions_AxisLabelNoneCaption": "None",
  "ChartDesignerStringIDs.AxisOptions_AxisLabelNoneDescription": "Turn off axis labels.",
  "ChartDesignerStringIDs.AxisOptions_AxisReverse": "Reverse",
  "ChartDesignerStringIDs.AxisOptions_CircularXLabelOrientation_NormalCaption": "Show Labels",
  "ChartDesignerStringIDs.AxisOptions_CircularXLabelOrientation_NormalDescription": "Show axis labels.",
  "ChartDesignerStringIDs.AxisOptions_CircularYLabelOrientation_NormalCaption": "Show Labels",
  "ChartDesignerStringIDs.AxisOptions_CircularYLabelOrientation_NormalDescription": "Show axis labels.",
  "ChartDesignerStringIDs.AxisOptions_DateTimeFormat": "Format:",
  "ChartDesignerStringIDs.AxisOptions_DateTimeMeasureUnit": "Measure Unit:",
  "ChartDesignerStringIDs.AxisOptions_ElementsGroup": "Elements",
  "ChartDesignerStringIDs.AxisOptions_GeneralGroup": "General",
  "ChartDesignerStringIDs.AxisOptions_GridlinesStaticText": "Grid Lines",
  "ChartDesignerStringIDs.AxisOptions_Interlaced": "Interlaced",
  "ChartDesignerStringIDs.AxisOptions_LabelsOrientation": "Labels",
  "ChartDesignerStringIDs.AxisOptions_MajorVisible": "Major",
  "ChartDesignerStringIDs.AxisOptions_MinorVisible": "Minor",
  "ChartDesignerStringIDs.AxisOptions_RangeGroup": "Range",
  "ChartDesignerStringIDs.AxisOptions_TickMarksStaticText": "Tickmarks",
  "ChartDesignerStringIDs.AxisOptions_TitleContent": "Text:",
  "ChartDesignerStringIDs.AxisOptions_TitleGroup": "Axis Title",
  "ChartDesignerStringIDs.AxisOptions_TitlePosition": "Title",
  "ChartDesignerStringIDs.AxisOptions_TitlePosition_NoneCaption": "None",
  "ChartDesignerStringIDs.AxisOptions_TitlePosition_NoneDescription": "Turn off the axis title.",
  "ChartDesignerStringIDs.AxisOptions_TitleVisibility": "Title Visibility",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_NormalCaption": "Show Labels",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_NormalDescription": "Show axis labels.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated45Caption": "45 Degrees",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated45Description": "Show axis labels rotated at 45 degrees.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated90Caption": "90 Degrees",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated90Description": "Show axis labels rotated at 90 degrees.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus45Caption": "-45 Degrees",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus45Description": "Show axis labels rotated at -45 degrees.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus90Caption": "-90 Degrees",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus90Description": "Show axis labels rotated at -90 degrees.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_StaggeredCaption": "Staggered",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_StaggeredDescription": "Show axis labels in staggered order.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_BottomCaption": "Bottom",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_BottomDescription": "Show the title at the bottom of an axis.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_CenterCaption": "Center",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_CenterDescription": "Show the title in the center of an axis.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_LeftCaption": "Left",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_LeftDescription": "Show the title on the left of an axis.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_RightCaption": "Right",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_DescriptionCaption": "Show axis labels.",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_NormalCaption": "Show Labels",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_Rotated90Caption": "90 Degrees",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_Rotated90Description": "Show axis labels rotated at 90 degrees.",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_RotatedMinus90Caption": "-90 Degrees",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_RotatedMinus90Description": "Show axis labels rotated at -90 degrees.",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_CenterCaption": "Center",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_CenterDescription": "Show the title in the center of an axis.",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_TopCaption": "Top",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_TopDescription": "Show the title on the top of an axis.",
  "ChartDesignerStringIDs.AxisPageCategoryTitle": "Axis",
  "ChartDesignerStringIDs.Bar2DModelGradient": "Gradient",
  "ChartDesignerStringIDs.BarFullStackedSeries2D": "Full-Stacked Bar 2D",
  "ChartDesignerStringIDs.BarItemMenu_ChartTitle": "Chart Title",
  "ChartDesignerStringIDs.BarItemMenu_ConstantLine": "Constant Line",
  "ChartDesignerStringIDs.BarItemMenu_SecondaryAxisX": "Secondary Axis X",
  "ChartDesignerStringIDs.BarItemMenu_SecondaryAxisY": "Secondary Axis Y",
  "ChartDesignerStringIDs.BarItemMenu_Series": "Series...",
  "ChartDesignerStringIDs.BarItemMenu_SeriesElements": "Series Elements",
  "ChartDesignerStringIDs.BarItemMenu_StackedBarTotalLabel": "Stacked Bar Total Label",
  "ChartDesignerStringIDs.BarItemMenu_Strip": "Strip",
  "ChartDesignerStringIDs.BarItemMenu_Title": "Title",
  "ChartDesignerStringIDs.BarSeries3D": "Bar 3D (Manhattan Bar)",
  "ChartDesignerStringIDs.BarSideBySideFullStackedSeries2D": "Side-By-Side Full Stacked Bar 2D",
  "ChartDesignerStringIDs.BarSideBySideSeries2D": "Side-by-Side Bar 2D",
  "ChartDesignerStringIDs.BarSideBySideSeries3D": "Side-by-Side Bar 3D",
  "ChartDesignerStringIDs.BarSideBySideStackedSeries2D": "Side-by-Side Stacked Bar 2D",
  "ChartDesignerStringIDs.BarStackedSeries2D": "Stacked Bar 2D",
  "ChartDesignerStringIDs.BubbleSeries2D": "Bubble 2D",
  "ChartDesignerStringIDs.BubbleSeries3D": "Bubble 3D",
  "ChartDesignerStringIDs.CancelButtonCaption": "Cancel",
  "ChartDesignerStringIDs.CandleStickSeries2D": "Candle Stick 2D",
  "ChartDesignerStringIDs.ChangeChartType": "Change Chart Type",
  "ChartDesignerStringIDs.ChartAnnotationOptions_General": "General",
  "ChartDesignerStringIDs.ChartAnnotationOptions_Text": "Text",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Boolean": "Boolean",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_DateTime": "Date Time",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Decimal": "Decimal",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Double": "Double",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Guid": "Guid",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Int32": "Int32",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_None": "None",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_String": "String",
  "ChartDesignerStringIDs.ChartDesignerDeleteCalculatedField": "Delete",
  "ChartDesignerStringIDs.ChartDesignerWindowTitle": "Chart Designer",
  "ChartDesignerStringIDs.ChartStructureDockPanelTitle": "Chart Structure",
  "ChartDesignerStringIDs.ChartTitleOptionsRibbonCategoryTitle": "Title Options",
  "ChartDesignerStringIDs.ChartTitleOptions_General": "General",
  "ChartDesignerStringIDs.ChartTitleOptions_Position": "Position",
  "ChartDesignerStringIDs.ChartTitleOptions_SelectedTitle": "Title",
  "ChartDesignerStringIDs.ChartTitleOptions_Text": "Text:",
  "ChartDesignerStringIDs.ChartViewGallery_Area": "Area Series",
  "ChartDesignerStringIDs.ChartViewGallery_BarSeries": "Bar Series",
  "ChartDesignerStringIDs.ChartViewGallery_Financial": "Financial Series",
  "ChartDesignerStringIDs.ChartViewGallery_LineSeries": "Line Series",
  "ChartDesignerStringIDs.ChartViewGallery_Pie": "Pie Series",
  "ChartDesignerStringIDs.ChartViewGallery_PointBubble": "Point and Bubble Series",
  "ChartDesignerStringIDs.ChartViewGallery_Polar": "Polar Series",
  "ChartDesignerStringIDs.ChartViewGallery_Radar": "Radar Series",
  "ChartDesignerStringIDs.ChartViewGallery_RangeSeries": "Range Series",
  "ChartDesignerStringIDs.ChooseDataSource": "Choose a datasource:",
  "ChartDesignerStringIDs.CircularAreaZoomInAnimation": "Zoom In",
  "ChartDesignerStringIDs.CircularLineZoomInAnimation": "Zoom In",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeConstantLineValueCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeConstantLineValueMessage": "The entered value has an incorrect type. Must be DateTime",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge1Caption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge1Message": "The entered value has an incorrect type. Must be DateTime",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge2Caption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge2Message": "The entered value has an incorrect type. Must be DateTime",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMaxLimitCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMaxLimitMessage": "The entered value has an incorrect type. Must be DateTime",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMinLimitCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMinLimitMessage": "The entered value has an incorrect type. Must be DateTime",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericConstantLineValueCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericConstantLineValueMessage": "The entered value has an incorrect type. Must be Numerical",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge1Caption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge1Message": "The entered value has an incorrect type. Must be Numerical",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge2Caption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge2Message": "The entered value has an incorrect type. Must be Numerical",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMaxLimitCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMaxLimitMessage": "The entered value has an incorrect type. Must be Numerical",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMinLimitCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMinLimitMessage": "The entered value has an incorrect type. Must be Numerical",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanConstantLineValueCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanScaleBreakEdge1Caption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanScaleBreakEdge2Caption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanStripMaxLimitCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanStripMinLimitCaption": "Incorrect Value Format",
  "ChartDesignerStringIDs.ComplexTitleContent": "Complex Content",
  "ChartDesignerStringIDs.ConstantLineCategoryTitle": "Constant Line Options",
  "ChartDesignerStringIDs.ConstantLinePageCategoryTitle": "Constant Line",
  "ChartDesignerStringIDs.ConstantLine_GeneralGroupTitle": "General",
  "ChartDesignerStringIDs.ConstantLine_LegendText": "Text In Legend:",
  "ChartDesignerStringIDs.ConstantLine_LineColor": "Color",
  "ChartDesignerStringIDs.ConstantLine_Thickness": "Thickness:",
  "ChartDesignerStringIDs.ConstantLine_TitleForeground": "Color",
  "ChartDesignerStringIDs.ConstantLine_TitleGroupTitle": "Title",
  "ChartDesignerStringIDs.ConstantLine_TitlePosition": "Title",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarAboveHorizontal": "Right Above",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarAboveVertical": "Right Above",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarBelowHorizontal": "Right Below",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarBelowVertical": "Right Below",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearAboveHorizontal": "Left Above",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearAboveVertical": "Left Above",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearBelowHorizontal": "Left Below",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearBelowVertical": "Left Below",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_None": "None",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionDescription_FarAboveHorizontal": "Show the title above the line on the right.",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionDescription_FarAboveVertical": "Show the title above the line on the right.",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionDescription_NearAboveVertical": "Show the title above the line on the left.",
  "ChartDesignerStringIDs.ConstantLine_TitleText": "Text:",
  "ChartDesignerStringIDs.ConstantLine_Value": "Value:",
  "ChartDesignerStringIDs.DashStyle_Dot": "Dot",
  "ChartDesignerStringIDs.DashStyle_Solid": "Solid",
  "ChartDesignerStringIDs.DataEditor_ArgumentColumnHeader": "Argument",
  "ChartDesignerStringIDs.DataEditor_CloseValueColumnHeader": "Close",
  "ChartDesignerStringIDs.DataEditor_HighValueColumnHeader": "High",
  "ChartDesignerStringIDs.DataEditor_LowValueColumnHeader": "Low",
  "ChartDesignerStringIDs.DataEditor_MaxColumnHeader": "Max",
  "ChartDesignerStringIDs.DataEditor_MinColumnHeader": "Min",
  "ChartDesignerStringIDs.DataEditor_OpenValueColumnHeader": "Open",
  "ChartDesignerStringIDs.DataEditor_Value2ColumnHeader": "Value 2",
  "ChartDesignerStringIDs.DataEditor_ValueColumnHeader": "Value",
  "ChartDesignerStringIDs.DataEditor_WeightValueColumnHeader": "Weight",
  "ChartDesignerStringIDs.DefaultAxisTitleText": "Axis",
  "ChartDesignerStringIDs.DefaultChartTitleContent": "Title",
  "ChartDesignerStringIDs.DefaultConstantLineTitle": "Constant Line",
  "ChartDesignerStringIDs.DefaultPane": "Default Pane",
  "ChartDesignerStringIDs.DefaultSeriesNamePrefix": "Series",
  "ChartDesignerStringIDs.DefaultStripLegendText": "Strip",
  "ChartDesignerStringIDs.Default_ElementsPageTitle": "Elements",
  "ChartDesignerStringIDs.Default_Elements_AddChartTitle": "Add Chart Title",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLine": "Add Constant Line",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLineX": "Add Constant Line To Axis X",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLineXDescription": "Add a constant line to the primary X-axis.",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLineY": "Add Constant Line To Axis Y",
  "ChartDesignerStringIDs.Default_Elements_AddPaneHorizontal": "Add Pane At Right",
  "ChartDesignerStringIDs.Default_Elements_AddPaneHorizontalDescription": "Add a new pane to the right of the current pane and stack them horizontally.",
  "ChartDesignerStringIDs.Default_Elements_AddSecondaryAxisX": "Add Axis X",
  "ChartDesignerStringIDs.Default_Elements_AddSecondaryAxisY": "Add Axis Y",
  "ChartDesignerStringIDs.Default_Elements_AddStripX": "Add Strip To Axis X",
  "ChartDesignerStringIDs.Default_Elements_AddStripXDescription": "Add a strip to the primary X-axis.",
  "ChartDesignerStringIDs.Default_Elements_AddStripY": "Add Strip To Axis Y",
  "ChartDesignerStringIDs.Default_Elements_AddStripYDescription": "Add a strip to the primary Y-axis.",
  "ChartDesignerStringIDs.Default_Elements_AnnotationsGroup": "Annotations",
  "ChartDesignerStringIDs.Default_Elements_AxesElementsGroupTitle": "Axes Elements",
  "ChartDesignerStringIDs.Default_Elements_AxesGroupTitle": "Axes",
  "ChartDesignerStringIDs.Default_Elements_ChartAreaElementsGroupTitle": "Chart Area Elements",
  "ChartDesignerStringIDs.Default_Elements_IndicatorsGroup": "Indicators",
  "ChartDesignerStringIDs.Default_Elements_Legend": "Legend",
  "ChartDesignerStringIDs.Default_Elements_Pane": "Pane",
  "ChartDesignerStringIDs.Default_MainPageTitle": "Chart",
  "ChartDesignerStringIDs.Default_Main_ChangeChartTypeGroupTitle": "Change Chart Type",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramCircleShapeStyleCaption": "Circle",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramPolygonShapeStyleCaption": "Polygon",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramRotationDirectionClockwise": "Clockwise",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramRotationDirectionCounterclockwise": "Counterclockwise",
  "ChartDesignerStringIDs.Default_Main_Diagram3DPerspectiveAngle": "Perspective Angle:",
  "ChartDesignerStringIDs.Default_Main_EnableAxisXNavigationCheckCaption": "Axis X",
  "ChartDesignerStringIDs.Default_Main_EnableAxisYNavigationCheckCaption": "Axis Y",
  "ChartDesignerStringIDs.Default_Main_Palette": "Palette",
  "ChartDesignerStringIDs.Default_Main_PaneOrientationHorizontal": "Horizontal",
  "ChartDesignerStringIDs.Default_Main_PaneOrientationVertical": "Vertical",
  "ChartDesignerStringIDs.Default_Main_SimpleDiagramLayoutDimensionWithoutColon": "Dimension",
  "ChartDesignerStringIDs.Default_Main_SimpleDiagramLayoutDirectionHorizontalCaption": "Horizontal",
  "ChartDesignerStringIDs.Default_Main_SimpleDiagramLayoutDirectionVerticalCaption": "Vertical",
  "ChartDesignerStringIDs.Default_Main_XYDiagramRotated": "Rotated",
  "ChartDesignerStringIDs.DragDropDataMembers_Argument": "Argument",
  "ChartDesignerStringIDs.DragDropDataMembers_Close": "Close",
  "ChartDesignerStringIDs.DragDropDataMembers_Color": "Color",
  "ChartDesignerStringIDs.DragDropDataMembers_High": "High",
  "ChartDesignerStringIDs.DragDropDataMembers_Low": "Low",
  "ChartDesignerStringIDs.DragDropDataMembers_Open": "Open",
  "ChartDesignerStringIDs.DragDropDataMembers_Series": "Series",
  "ChartDesignerStringIDs.DragDropDataMembers_ToolTipHint": "ToolTip Hint",
  "ChartDesignerStringIDs.DragDropDataMembers_Value": "Value",
  "ChartDesignerStringIDs.DragDropDataMembers_Value2": "Value 2",
  "ChartDesignerStringIDs.DragDropDataMembers_Weight": "Weight",
  "ChartDesignerStringIDs.EmptyDiagramHintBar": "The Chart has no data to visualize. Click the Add button to expand the Add menu and select the way to provide data to visualize.",
  "ChartDesignerStringIDs.EmptyDiagramHintRibbon": "There is no data to visualize. To see the chart, switch to the Chart ribbon tab and choose a desired series type from the Add New Series gallery.",
  "ChartDesignerStringIDs.ErrorBarDirection_Both": "Close",
  "ChartDesignerStringIDs.ErrorBarDirection_Minus": "High",
  "ChartDesignerStringIDs.ErrorBarDirection_Plus": "Low",
  "ChartDesignerStringIDs.FibonacciArcs": "Fibonacci Arcs",
  "ChartDesignerStringIDs.FibonacciFans": "Fibonacci Fans",
  "ChartDesignerStringIDs.Font": "Font",
  "ChartDesignerStringIDs.Font_Bold": "Bold",
  "ChartDesignerStringIDs.Font_Family": "Name:",
  "ChartDesignerStringIDs.Font_Italic": "Italic",
  "ChartDesignerStringIDs.Font_Size": "Size:",
  "ChartDesignerStringIDs.Indicator_Arg2ValLevel2Header": "End Point",
  "ChartDesignerStringIDs.Indicator_AxisY": "Axis Y",
  "ChartDesignerStringIDs.Indicator_Color": "Color",
  "ChartDesignerStringIDs.Indicator_ErrorBarsDirection": "Direction:",
  "ChartDesignerStringIDs.Indicator_GeneralGroupCaption": "General",
  "ChartDesignerStringIDs.Indicator_Thickness": "Thickness:",
  "ChartDesignerStringIDs.Indicator_TrendLineExtrapolateToInfinity": "Extrapolate to Infinity",
  "ChartDesignerStringIDs.Indicator_ValueLevel": "Value Level:",
  "ChartDesignerStringIDs.Indicator_ValueLevel1": "Value Level:",
  "ChartDesignerStringIDs.LegendOptionsRibbonCategoryTitle": "Legend Options",
  "ChartDesignerStringIDs.LegendOptions_Layout": "Layout",
  "ChartDesignerStringIDs.LegendOptions_Orientation": "Orientation",
  "ChartDesignerStringIDs.LegendOptions_Orientation_Horizontal": "Horizontal",
  "ChartDesignerStringIDs.LegendOptions_Orientation_HorizontalDescription": "Order legend items from left to right.",
  "ChartDesignerStringIDs.LegendOptions_Orientation_Vertical": "Vertical",
  "ChartDesignerStringIDs.LegendOptions_ReverseItems": "Reverse Items",
  "ChartDesignerStringIDs.LegendOptions_SelectedLegend": "Legend",
  "ChartDesignerStringIDs.LegendPosition": "Position",
  "ChartDesignerStringIDs.Line2DSlideFromLeftAnimation": "Slide From Left",
  "ChartDesignerStringIDs.LineFullStackedSeries2D": "Full-Stacked Line 2D",
  "ChartDesignerStringIDs.LineScatterSeries2D": "Scatter Line 2D",
  "ChartDesignerStringIDs.LineSeries2D": "Line 2D",
  "ChartDesignerStringIDs.LineStackedSeries2D": "Stacked Line 2D",
  "ChartDesignerStringIDs.LineStepSeries2D": "Step Line 2D",
  "ChartDesignerStringIDs.Marker2DModelCircle": "Circle",
  "ChartDesignerStringIDs.Marker2DModelCross": "Cross",
  "ChartDesignerStringIDs.Marker2DModelPlus": "Plus",
  "ChartDesignerStringIDs.Marker2DModelPolygon": "Polygon",
  "ChartDesignerStringIDs.Marker2DModelSquare": "Square",
  "ChartDesignerStringIDs.Marker2DModelStar": "Star",
  "ChartDesignerStringIDs.Marker2DModelTriangle": "Triangle",
  "ChartDesignerStringIDs.NewLegend": "New Legend",
  "ChartDesignerStringIDs.NewPieTotalLabel": "New Pie Total Label",
  "ChartDesignerStringIDs.NewStackedBarTotalLabel": "New Stacked Bar Total Label",
  "ChartDesignerStringIDs.OKButtonCaption": "OK",
  "ChartDesignerStringIDs.OptionsAnnotation_Angle": "Angle",
  "ChartDesignerStringIDs.OptionsAnnotation_Content": "Content",
  "ChartDesignerStringIDs.OptionsAnnotation_RuntimeMoving": "Runtime Moving",
  "ChartDesignerStringIDs.OptionsAnnotation_RuntimeResizing": "Runtime Resizing",
  "ChartDesignerStringIDs.OptionsAnnotation_RuntimeRotation": "Runtime Rotation",
  "ChartDesignerStringIDs.OptionsAnnotation_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsAxisRange_Auto": "Auto",
  "ChartDesignerStringIDs.OptionsAxisRange_MaxValue": "Max Value",
  "ChartDesignerStringIDs.OptionsAxisRange_MinValue": "Min Value",
  "ChartDesignerStringIDs.OptionsAxis_Alignment": "Alignment",
  "ChartDesignerStringIDs.OptionsAxis_GridLinesMinorVisible": "Grid Lines Minor Visible",
  "ChartDesignerStringIDs.OptionsAxis_GridLinesVisible": "Grid Lines Visible",
  "ChartDesignerStringIDs.OptionsAxis_Interlaced": "Interlaced",
  "ChartDesignerStringIDs.OptionsAxis_Logarithmic": "Logarithmic",
  "ChartDesignerStringIDs.OptionsAxis_LogarithmicBase": "Logarithmic Base",
  "ChartDesignerStringIDs.OptionsAxis_Reverse": "Reverse",
  "ChartDesignerStringIDs.OptionsAxis_TickmarksMinorVisible": "Tickmarks Minor Visible",
  "ChartDesignerStringIDs.OptionsAxis_TickmarksVisible": "Tickmarks Visible",
  "ChartDesignerStringIDs.OptionsAxis_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsAxis_VisualRange": "VISUAL RANGE",
  "ChartDesignerStringIDs.OptionsAxis_WholeRange": "WHOLE RANGE",
  "ChartDesignerStringIDs.OptionsChartTitle_Content": "Content",
  "ChartDesignerStringIDs.OptionsChartTitle_Dock": "Dock",
  "ChartDesignerStringIDs.OptionsChartTitle_HorizontalAlignment": "Horizontal Alignment",
  "ChartDesignerStringIDs.OptionsChartTitle_SeriesTitleTextPattern": "Pattern",
  "ChartDesignerStringIDs.OptionsChartTitle_VerticalAlignment": "Vertical Alignment",
  "ChartDesignerStringIDs.OptionsChartTitle_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsChart_AnimationMode": "Animation Mode",
  "ChartDesignerStringIDs.OptionsChart_AutoLayout": "Auto Layout",
  "ChartDesignerStringIDs.OptionsChart_FontFamily": "Font Family",
  "ChartDesignerStringIDs.OptionsChart_FontStyle": "Font Style",
  "ChartDesignerStringIDs.OptionsChart_FontWeight": "Font Weight",
  "ChartDesignerStringIDs.OptionsChart_Palette": "Palette",
  "ChartDesignerStringIDs.OptionsConstantLine_Alignment": "Alignment",
  "ChartDesignerStringIDs.OptionsConstantLine_Brush": "Brush",
  "ChartDesignerStringIDs.OptionsConstantLine_Legend": "Legend",
  "ChartDesignerStringIDs.OptionsConstantLine_LegendText": "Legend Text",
  "ChartDesignerStringIDs.OptionsConstantLine_Value": "Value",
  "ChartDesignerStringIDs.OptionsConstantLine_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsDiagram_DependentAxesYRange": "Dependent Axes Y Range",
  "ChartDesignerStringIDs.OptionsDiagram_Dimension": "Dimension",
  "ChartDesignerStringIDs.OptionsDiagram_EnableAxisXNavigation": "Enable Axis X Navigation",
  "ChartDesignerStringIDs.OptionsDiagram_EnableAxisYNavigation": "Enable Axis Y Navigation",
  "ChartDesignerStringIDs.OptionsDiagram_LayoutDirection": "Layout Direction",
  "ChartDesignerStringIDs.OptionsDiagram_Rotated": "Rotated",
  "ChartDesignerStringIDs.OptionsDiagram_RotationDirection": "Rotation Direction",
  "ChartDesignerStringIDs.OptionsDiagram_RuntimeRotation": "Runtime Rotation",
  "ChartDesignerStringIDs.OptionsDiagram_RuntimeScrolling": "Runtime Scrolling",
  "ChartDesignerStringIDs.OptionsDiagram_RuntimeZooming": "Runtime Zooming",
  "ChartDesignerStringIDs.OptionsDiagram_SeriesPadding": "Series Padding",
  "ChartDesignerStringIDs.OptionsDiagram_ShapeStyle": "Shape Style",
  "ChartDesignerStringIDs.OptionsDiagram_StartAngle": "Start Angle",
  "ChartDesignerStringIDs.OptionsDockPanelTitle": "Options",
  "ChartDesignerStringIDs.OptionsIndicators_Argument1": "Argument 1",
  "ChartDesignerStringIDs.OptionsIndicators_Argument2": "Argument 2",
  "ChartDesignerStringIDs.OptionsIndicators_Direction": "Direction",
  "ChartDesignerStringIDs.OptionsIndicators_ExtrapolateToInfinity": "Extrapolate to Infinity",
  "ChartDesignerStringIDs.OptionsIndicators_Legend": "Legend",
  "ChartDesignerStringIDs.OptionsIndicators_LegendText": "Legend Text",
  "ChartDesignerStringIDs.OptionsIndicators_NegativeError": "Negative Error",
  "ChartDesignerStringIDs.OptionsIndicators_Percent": "Percent",
  "ChartDesignerStringIDs.OptionsIndicators_PointsCount": "Points Count",
  "ChartDesignerStringIDs.OptionsIndicators_PositiveError": "Positive Error",
  "ChartDesignerStringIDs.OptionsIndicators_ShowAdditionalLevels": "Show Additional Levels",
  "ChartDesignerStringIDs.OptionsIndicators_ShowInLegend": "Show In Legend",
  "ChartDesignerStringIDs.OptionsIndicators_ShowLevel0": "Show Level 0",
  "ChartDesignerStringIDs.OptionsIndicators_ShowLevel100": "Show Level 100",
  "ChartDesignerStringIDs.OptionsIndicators_SignalSmoothingPeriod": "Signal Smoothing Period",
  "ChartDesignerStringIDs.OptionsIndicators_StandardDeviationMultiplier": "Standard Deviation Multiplier",
  "ChartDesignerStringIDs.OptionsIndicators_SumPointsCount": "Sum Points Count",
  "ChartDesignerStringIDs.OptionsIndicators_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsLegend_DockTarget": "Dock Target",
  "ChartDesignerStringIDs.OptionsLegend_HorizontalAlignment": "Horizontal Alignment",
  "ChartDesignerStringIDs.OptionsLegend_HorizontalPosition": "Horizontal Position",
  "ChartDesignerStringIDs.OptionsLegend_ItemVisibilityMode": "Item Visibility Mode",
  "ChartDesignerStringIDs.OptionsLegend_Orientation": "Orientation",
  "ChartDesignerStringIDs.OptionsLegend_VerticalPosition": "Vertical Position",
  "ChartDesignerStringIDs.OptionsLegend_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsPane_EnableAxisXNavigation": "Enable Axis X Navigation",
  "ChartDesignerStringIDs.OptionsPane_EnableAxisYNavigation": "Enable Axis Y Navigation",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Content": "Content",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Margin": "Margin",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Padding": "Padding",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_TextPattern": "Text Pattern",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Visibility": "Visibility",
  "ChartDesignerStringIDs.OptionsScaleBreak_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsSeries_AxisX": "Axis X",
  "ChartDesignerStringIDs.OptionsSeries_AxisY": "Axis Y",
  "ChartDesignerStringIDs.OptionsSeries_Closed": "Closed",
  "ChartDesignerStringIDs.OptionsSeries_ColorEach": "Color Each",
  "ChartDesignerStringIDs.OptionsSeries_DisplayName": "Display Name",
  "ChartDesignerStringIDs.OptionsSeries_Group": "Group",
  "ChartDesignerStringIDs.OptionsSeries_InnerIndent": "Inner Indent",
  "ChartDesignerStringIDs.OptionsSeries_InvertedStep": "Inverted Step",
  "ChartDesignerStringIDs.OptionsSeries_LabelsVisibility": "Labels Visibility",
  "ChartDesignerStringIDs.OptionsSeries_Legend": "Legend",
  "ChartDesignerStringIDs.OptionsSeries_LevelLineLength": "Level Line Length",
  "ChartDesignerStringIDs.OptionsSeries_LineTension": "Line Tension",
  "ChartDesignerStringIDs.OptionsSeries_Marker1Size": "Marker 1 Size",
  "ChartDesignerStringIDs.OptionsSeries_Marker2Size": "Marker 2 Size",
  "ChartDesignerStringIDs.OptionsSeries_MarkerSize": "Marker Size",
  "ChartDesignerStringIDs.OptionsSeries_MaxMarkerSize": "Max Marker Size",
  "ChartDesignerStringIDs.OptionsSeries_MaxSize": "Max Size",
  "ChartDesignerStringIDs.OptionsSeries_Pane": "Pane",
  "ChartDesignerStringIDs.OptionsSeries_ShowInLegend": "Show In Legend",
  "ChartDesignerStringIDs.OptionsSeries_ShowOpenClose": "Show Open Close",
  "ChartDesignerStringIDs.OptionsSeries_StackedGroup": "Stacked Group",
  "ChartDesignerStringIDs.OptionsSeries_Transparency": "Transparency",
  "ChartDesignerStringIDs.OptionsSeries_Visible": "Visible",
  "ChartDesignerStringIDs.OptionsSeries_Weight": "Weight",
  "ChartDesignerStringIDs.OptionsStrip_Brush": "Brush",
  "ChartDesignerStringIDs.OptionsStrip_Legend": "Legend",
  "ChartDesignerStringIDs.OptionsStrip_LegendText": "Legend Text",
  "ChartDesignerStringIDs.OptionsStrip_Visible": "Visible",
  "ChartDesignerStringIDs.Options_Title": "TITLE",
  "ChartDesignerStringIDs.PanePrefix": "Pane #",
  "ChartDesignerStringIDs.PatternEditor_CancelButtonText": "Cancel",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Currency": "Currency",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Custom": "Custom",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_DateTime": "DateTime",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Default": "Default",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Number": "Number",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Percent": "Percent",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Special": "Special",
  "ChartDesignerStringIDs.PatternEditor_FormatLabelText": "Format",
  "ChartDesignerStringIDs.PatternEditor_OkButtonText": "OK",
  "ChartDesignerStringIDs.PatternEditor_PatternLabelText": "Pattern",
  "ChartDesignerStringIDs.Pie2DZoomInAnimation": "Zoom In",
  "ChartDesignerStringIDs.PieSeries2D": "Pie 2D",
  "ChartDesignerStringIDs.PieSeries3D": "Pie 3D",
  "ChartDesignerStringIDs.PointSeries2D": "Point 2D",
  "ChartDesignerStringIDs.PointSeries3D": "Point 3D",
  "ChartDesignerStringIDs.PolarAreaSeries2D": "Polar Area 2D",
  "ChartDesignerStringIDs.PolarLineSeries2D": "Polar Line 2D",
  "ChartDesignerStringIDs.PolarPointSeries2D": "Polar Point 2D",
  "ChartDesignerStringIDs.PrimaryAxisXName": "Primary Axis X",
  "ChartDesignerStringIDs.PrimaryAxisYName": "Primary Axis Y",
  "ChartDesignerStringIDs.PropertiesDockPanelTitle": "Properties",
  "ChartDesignerStringIDs.RadarAreaSeries2D": "Radar Area 2D",
  "ChartDesignerStringIDs.RadarLineSeries2D": "Radar Line 2D",
  "ChartDesignerStringIDs.RadarPointSeries2D": "Radar Point 2D",
  "ChartDesignerStringIDs.RangeAreaSeries2D": "Range Area 2D",
  "ChartDesignerStringIDs.RangeBarOverlappedSeries2D": "Overlapped Range Bar 2D",
  "ChartDesignerStringIDs.RangeBarSideBySideSeries2D": "Side-By-Side Range Bar 2D",
  "ChartDesignerStringIDs.RangeControlClientAreaView": "New Area View",
  "ChartDesignerStringIDs.RangeControlClientBarView": "New Bar View",
  "ChartDesignerStringIDs.RangeControlClientLineView": "New Line View",
  "ChartDesignerStringIDs.RangeControlOptions": "New Range Control Options",
  "ChartDesignerStringIDs.Redo": "Redo",
  "ChartDesignerStringIDs.ScaleBreak_CategoryCaption": "Scale Break Options",
  "ChartDesignerStringIDs.ScaleBreak_Edge1": "Edge 1:",
  "ChartDesignerStringIDs.ScaleBreak_Edge2": "Edge 2:",
  "ChartDesignerStringIDs.ScaleBreak_GeneralGroupCaption": "General",
  "ChartDesignerStringIDs.ScaleBreak_PageCaption": "Scale Break",
  "ChartDesignerStringIDs.ScaleOptionsAutomatic": "Automatic",
  "ChartDesignerStringIDs.ScaleOptionsContinuous": "Continuous",
  "ChartDesignerStringIDs.ScaleOptionsManual": "Manual",
  "ChartDesignerStringIDs.SecondaryAxisXPrefix": "Secondary Axis X #",
  "ChartDesignerStringIDs.SecondaryAxisYPrefix": "Secondary Axis Y #",
  "ChartDesignerStringIDs.SeriesDataPanelTitle": "Series Data",
  "ChartDesignerStringIDs.SeriesOptionsRibbonCategoryTitle": "Series Options",
  "ChartDesignerStringIDs.SeriesOptions_ArgumentAxis": "Argument Axis:",
  "ChartDesignerStringIDs.SeriesOptions_ArgumentDataMember": "Argument:",
  "ChartDesignerStringIDs.SeriesOptions_ChartDataSource": "Chart Data Source",
  "ChartDesignerStringIDs.SeriesOptions_CloseValueDataMember": "Close Value:",
  "ChartDesignerStringIDs.SeriesOptions_ColorDataMember": "Color:",
  "ChartDesignerStringIDs.SeriesOptions_ConnectorThickness": "Connector:",
  "ChartDesignerStringIDs.SeriesOptions_DataMembersPageGroup": "Data Members",
  "ChartDesignerStringIDs.SeriesOptions_DataPage": "Data",
  "ChartDesignerStringIDs.SeriesOptions_DataSourceNone": "No Data Source",
  "ChartDesignerStringIDs.SeriesOptions_DataSourcePageGroup": "Data Source",
  "ChartDesignerStringIDs.SeriesOptions_FunnelOptionsGroup": "Funnel",
  "ChartDesignerStringIDs.SeriesOptions_HighValueDataMember": "High Value:",
  "ChartDesignerStringIDs.SeriesOptions_Indent": "Indent:",
  "ChartDesignerStringIDs.SeriesOptions_LabelsGroupTitle": "Labels",
  "ChartDesignerStringIDs.SeriesOptions_LabelsVisibility": "Labels Visibility",
  "ChartDesignerStringIDs.SeriesOptions_Labels_0DegreesCaption": "0 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_0DegreesDescription": "Show data labels without rotation.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_135DegreesCaption": "135 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_135DegreesDescription": "Show data labels rotated at 135 degrees.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_180DegreesCaption": "180 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_180DegreesDescription": "Show data labels rotated at 180 degrees.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_225DegreesCaption": "225 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_225DegreesDescription": "Show data labels rotated at 225 degrees.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_270DegreesCaption": "270 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_270DegreesDescription": "Show data labels rotated at 270 degrees.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_315DegreesCaption": "315 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_315DegreesDescription": "Show data labels rotated at 315 degrees.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_3DTopCaption": "Top",
  "ChartDesignerStringIDs.SeriesOptions_Labels_3DTopDescription": "Show data labels on the top of point markers.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_45DegreesCaption": "45 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_45DegreesDescription": "Show data labels rotated at 45 degrees.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_90DegreesCaption": "90 Degrees",
  "ChartDesignerStringIDs.SeriesOptions_Labels_90DegreesDescription": "Show data labels rotated at 90 degrees.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Area3DEnabledCaption": "Enabled",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Area3DEnabledDescription": "Turn on data labels.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bar3DEnabledCaption": "Enabled",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bar3DEnabledDescription": "Turn on data labels.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bubble2DCenterCaption": "Center",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bubble2DCenterDescription": "Show data labels in the center of bubbles.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_CenteredInBarsCaption": "Center",
  "ChartDesignerStringIDs.SeriesOptions_Labels_CenteredInBarsDescription": "Show data labels in the center of bars.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_EnabledCaption": "Enabled",
  "ChartDesignerStringIDs.SeriesOptions_Labels_EnabledDescription": "Turn on data labels.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_FunnelCenterPointCaption": "Center",
  "ChartDesignerStringIDs.SeriesOptions_Labels_FunnelLeftPointCaption": "Left",
  "ChartDesignerStringIDs.SeriesOptions_Labels_FunnelRightPointCaption": "Right",
  "ChartDesignerStringIDs.SeriesOptions_Labels_InsideSlicesCaption": "Inside",
  "ChartDesignerStringIDs.SeriesOptions_Labels_InsideSlicesDescription": "Show data labels inside pie slices.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Marker3DCenterCaption": "Center",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Marker3DCenterDescription": "Show data labels in the center of point markers.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_NoneCaption": "None",
  "ChartDesignerStringIDs.SeriesOptions_Labels_NoneDescription": "Turn off data labels.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideCaption": "Outside",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideDescription": "Show data labels outside bars.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideSlicesCaption": "Outside",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideSlicesDescription": "Show data labels outside pie slices.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_StackedBarCenteredInBarCaption": "Center",
  "ChartDesignerStringIDs.SeriesOptions_Labels_StackedBarCenteredInBarDescription": "Show data labels in the center of bars.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_TwoColumnsCaption": "Two Columns",
  "ChartDesignerStringIDs.SeriesOptions_Labels_TwoColumnsDescription": "Show data labels in two columns.",
  "ChartDesignerStringIDs.SeriesOptions_LayoutGroup": "Layout",
  "ChartDesignerStringIDs.SeriesOptions_LowValueDataMember": "Low Value:",
  "ChartDesignerStringIDs.SeriesOptions_Main": "Main",
  "ChartDesignerStringIDs.SeriesOptions_MarkersCaption": "Appearance",
  "ChartDesignerStringIDs.SeriesOptions_Model": "Model",
  "ChartDesignerStringIDs.SeriesOptions_NestedDonutGroup": "Group",
  "ChartDesignerStringIDs.SeriesOptions_NestedDonutWeight": "Weight",
  "ChartDesignerStringIDs.SeriesOptions_NoModelString": "None",
  "ChartDesignerStringIDs.SeriesOptions_OpenValueDataMember": "Open Value:",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMaxValueLabelPositionCaption": "Max",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMaxValueLabelPositionDescription": "Show only the label for the maximum value of a data point.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMinValueLabelPositionCaption": "Min",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMinValueLabelPositionDescription": "Show only the label for the minimum value of a data point.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DOneLabelPositionCaption": "Center",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DOneLabelPositionDescription": "Show one label in the center of the range area with both minimum and maximum values.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DTwoLabelsPositionCaption": "Both",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DTwoLabelsPositionDescription": "Show both labels with minimum and maximum values of a data point.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue1LabelPositionCaption": "Value",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue1LabelPositionDescription": "Show only the label for the first value of a data point.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue2LabelPositionCaption": "Value 2",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue2LabelPositionDescription": "Show only the label for the second value of a data point.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMaxValueLabelPositionCaption": "Max",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMaxValueLabelPositionDescription": "Show only the label for the maximum range bar value.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMinValueLabelPositionCaption": "Min",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMinValueLabelPositionDescription": "Show only the label for the minimum range bar value.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarOneLabelPositionCaption": "Center",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarOneLabelPositionDescription": "Show one label in the center of the range bar with both minimum and maximum values.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarTwoLabelsLabelPositionCaption": "Both",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarTwoLabelsLabelPositionDescription": "Show both labels with minimum and maximum values.",
  "ChartDesignerStringIDs.SeriesOptions_SelectedSeries": "Series",
  "ChartDesignerStringIDs.SeriesOptions_SelectedSeries_View": "View",
  "ChartDesignerStringIDs.SeriesOptions_SeriesDataMember": "Series:",
  "ChartDesignerStringIDs.SeriesOptions_SeriesDataSource": "Series Data Source",
  "ChartDesignerStringIDs.SeriesOptions_SeriesLabelsPosition": "Labels",
  "ChartDesignerStringIDs.SeriesOptions_SeriesName": "Name:",
  "ChartDesignerStringIDs.SeriesOptions_SeriesPane": "Pane:",
  "ChartDesignerStringIDs.SeriesOptions_SeriesVisibility": "Visibility",
  "ChartDesignerStringIDs.SeriesOptions_Value2DataMember": "Value 2:",
  "ChartDesignerStringIDs.SeriesOptions_ValueAxis": "Value Axis:",
  "ChartDesignerStringIDs.SeriesOptions_ValueDataMember": "Value:",
  "ChartDesignerStringIDs.SeriesOptions_WeightDataMember": "Weight:",
  "ChartDesignerStringIDs.SeriesTemplate": "Template",
  "ChartDesignerStringIDs.StandardDeviation": "Standard Deviation",
  "ChartDesignerStringIDs.Stock2DExpandAnimation": "Expand",
  "ChartDesignerStringIDs.StockSeries2D": "Stock 2D",
  "ChartDesignerStringIDs.Strip_AxisLabelText": "Text On Axis:",
  "ChartDesignerStringIDs.Strip_Brush": "Color",
  "ChartDesignerStringIDs.Strip_CategoryCaption": "Strip Options",
  "ChartDesignerStringIDs.Strip_GeneralGroupCaption": "General",
  "ChartDesignerStringIDs.Strip_LegendText": "Text In Legend:",
  "ChartDesignerStringIDs.Strip_MaxLimit": "Max Limit:",
  "ChartDesignerStringIDs.Strip_MinLimit": "Min Limit:",
  "ChartDesignerStringIDs.Strip_PageCaption": "Strip",
  "ChartDesignerStringIDs.Strip_TextGroupCaption": "Text",
  "ChartDesignerStringIDs.ThicknessNone": "None",
  "ChartDesignerStringIDs.TreeAdditionalPanelCollection": "Additional Panes",
  "ChartDesignerStringIDs.TreeAnnotationCollection": "Annotations",
  "ChartDesignerStringIDs.TreeAxesSubnode": "Axes",
  "ChartDesignerStringIDs.TreeAxisCustomLabelCollection": "Custom Labels",
  "ChartDesignerStringIDs.TreeChart": "Chart",
  "ChartDesignerStringIDs.TreeConstantLineCollection": "Constant Lines",
  "ChartDesignerStringIDs.TreeDiagramPolarDiagram2D": "Polar Diagram",
  "ChartDesignerStringIDs.TreeDiagramRadarDiagram2D": "Radar Diagram",
  "ChartDesignerStringIDs.TreeDiagramSimpleDiagram2D": "Simple Diagram",
  "ChartDesignerStringIDs.TreeDiagramSimpleDiagram3D": "3D Simple Diagram",
  "ChartDesignerStringIDs.TreeDiagramXYDiagram2D": "Cartesian Diagram",
  "ChartDesignerStringIDs.TreeDiagramXYDiagram3D": "3D Cartesian Diagram",
  "ChartDesignerStringIDs.TreeIndicatorCollection": "Indicators",
  "ChartDesignerStringIDs.TreeLegend": "Legend #",
  "ChartDesignerStringIDs.TreePaneTitleModel": "Title",
  "ChartDesignerStringIDs.TreePanesSubnode": "Panes",
  "ChartDesignerStringIDs.TreePieTotalLabelModel": "Pie Total Label",
  "ChartDesignerStringIDs.TreePrimaryAxisX": "Primary Axis X",
  "ChartDesignerStringIDs.TreePrimaryAxisY": "Primary Axis Y",
  "ChartDesignerStringIDs.TreeSecondaryAxesCollectionX": "Secondary Axes X",
  "ChartDesignerStringIDs.TreeSecondaryAxesCollectionY": "Secondary Axes Y",
  "ChartDesignerStringIDs.TreeSeries": "Series",
  "ChartDesignerStringIDs.TreeSeriesCollection": "Series",
  "ChartDesignerStringIDs.TreeStackedBarTotalLabelModel": "Stacked Bar Total Label",
  "ChartDesignerStringIDs.TreeStripCollectionModel": "Strips",
  "ChartDesignerStringIDs.TreeStripModel": "Strip",
  "ChartDesignerStringIDs.TreeTitle": "Title",
  "ChartDesignerStringIDs.TreeTitleCollection": "Titles",
  "ChartDesignerStringIDs.Undo": "Undo",
  "ChartDesignerStringIDs.ValueLevel_Close": "Close",
  "ChartDesignerStringIDs.ValueLevel_High": "High",
  "ChartDesignerStringIDs.ValueLevel_Low": "Low",
  "ChartDesignerStringIDs.ValueLevel_Open": "Open",
  "ChartDesignerStringIDs.ValueLevel_Value": "Value",
  "DevExpress.XtraPrinting.ActionAfterExport.AskUser": "Ask a User",
  "DevExpress.XtraPrinting.ActionAfterExport.None": "None",
  "DevExpress.XtraPrinting.ActionAfterExport.Open": "Open",
  "DevExpress.XtraPrinting.BarCode.BarCodeGeneratorBase.CalcCheckSum": "Calculate a Checksum",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.Normal": "Normal",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.RotateLeft": "Rotate to the Left",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.RotateRight": "Rotate to the Right",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.UpsideDown": "Upside Down",
  "DevExpress.XtraPrinting.BarCode.CodabarGenerator.StartStopPair": "Start and Stop Symbols",
  "DevExpress.XtraPrinting.BarCode.CodabarGenerator.WideNarrowRatio": "Wide Narrow Ratio",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.AT": "AT",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.BN": "BN",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.CStar": "CStar",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.DE": "DE",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.None": "None",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.A": "A",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.B": "B",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.C": "C",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.None": "None",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetA": "Charset A",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetAuto": "Auto Charset",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetB": "Charset B",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetC": "Charset C",
  "DevExpress.XtraPrinting.BarCode.Code128Generator.CharacterSet": "Character Set",
  "DevExpress.XtraPrinting.BarCode.Code39Generator.WideNarrowRatio": "Wide Narrow Ratio",
  "DevExpress.XtraPrinting.BarCode.CodeMSIGenerator.MSICheckSum": "MSI Checksum",
  "DevExpress.XtraPrinting.BarCode.DataBarGenerator.FNC1Substitute": "FNC1 Functional Character",
  "DevExpress.XtraPrinting.BarCode.DataBarGenerator.SegmentsInRow": "Segments in Row",
  "DevExpress.XtraPrinting.BarCode.DataBarGenerator.Type": "Type",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Expanded": "Expanded",
  "DevExpress.XtraPrinting.BarCode.DataBarType.ExpandedStacked": "Expanded Stacked",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Limited": "Limited",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Omnidirectional": "Omnidirectional",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Stacked": "Stacked",
  "DevExpress.XtraPrinting.BarCode.DataBarType.StackedOmnidirectional": "Stacked Omnidirectional",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Truncated": "Truncated",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.ASCII": "ASCII",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.Binary": "Binary",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.C40": "C40",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.Edifact": "Edifact",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.Text": "Text",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.X12": "X12",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGS1Generator.FNC1Substitute": "FNC1 Functional Character",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGS1Generator.HumanReadableText": "Human-Readable Text",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGenerator.CompactionMode": "Compaction Mode",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGenerator.MatrixSize": "Matrix Size",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix104x104": "104 x 104",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix10x10": "10 x 10",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix120x120": "120 x 120",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix12x12": "12 x 12",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix12x26": "12 x 26",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix12x36": "12 x 36",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix132x132": "132 x 132",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix144x144": "144 x 144",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix14x14": "14 x 14",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix16x16": "16 x 16",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix16x36": "16 x 36",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix16x48": "16 x 48",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix18x18": "18 x 18",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix20x20": "20 x 20",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix22x22": "22 x 22",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix24x24": "24 x 24",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix26x26": "26 x 26",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix32x32": "32 x 32",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix36x36": "36 x 36",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix40x40": "40 x 40",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix44x44": "44 x 44",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix48x48": "48 x 48",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix52x52": "52 x 52",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix64x64": "64 x 64",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix72x72": "72 x 72",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix80x80": "80 x 80",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix88x88": "88 x 88",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix8x18": "8 x 18",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix8x32": "8 x 32",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix96x96": "96 x 96",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.MatrixAuto": "Auto",
  "DevExpress.XtraPrinting.BarCode.EAN128Generator.FNC1Substitute": "FNC1 Functional Character",
  "DevExpress.XtraPrinting.BarCode.EAN128Generator.HumanReadableText": "Human-Readable Text",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level0": "Level 0",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level1": "Level 1",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level2": "Level 2",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level3": "Level 3",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level4": "Level 4",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level5": "Level 5",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level6": "Level 6",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level7": "Level 7",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level8": "Level 8",
  "DevExpress.XtraPrinting.BarCode.ITF14Generator.WideNarrowRatio": "Wide Narrow Ratio",
  "DevExpress.XtraPrinting.BarCode.Industrial2of5Generator.WideNarrowRatio": "Wide Narrow Ratio",
  "DevExpress.XtraPrinting.BarCode.Interleaved2of5Generator.WideNarrowRatio": "Wide Narrow Ratio",
  "DevExpress.XtraPrinting.BarCode.MSICheckSum.DoubleModulo10": "Double Modulo 10",
  "DevExpress.XtraPrinting.BarCode.MSICheckSum.Modulo10": "Modulo 10",
  "DevExpress.XtraPrinting.BarCode.MSICheckSum.None": "None",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.Codabar": "Codabar",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.DataBar": "DataBar",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.DataMatrix": "Data Matrix",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.EAN128": "EAN 128",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.EAN13": "EAN 13",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.EAN8": "EAN 8",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.ITF14": "ITF 14",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.PDF417": "PDF 417",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.PostNet": "PostNet",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.UPCA": "UPC A",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.UPCE1": "UPC E1",
  "DevExpress.XtraPrinting.BarCode.PDF417CompactionMode.Binary": "Binary",
  "DevExpress.XtraPrinting.BarCode.PDF417CompactionMode.Text": "Text",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.Columns": "Columns",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.CompactionMode": "Compaction Mode",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.ErrorCorrectionLevel": "Error Correction Level",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.Rows": "Rows",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.TruncateSymbol": "Truncate Symbol",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.YToXRatio": "Y to X Ratio",
  "DevExpress.XtraPrinting.BarCode.QRCodeCompactionMode.AlphaNumeric": "Alpha Numeric",
  "DevExpress.XtraPrinting.BarCode.QRCodeCompactionMode.Byte": "Byte",
  "DevExpress.XtraPrinting.BarCode.QRCodeCompactionMode.Numeric": "Numeric",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.H": "H",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.L": "L",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.M": "M",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.Q": "Q",
  "DevExpress.XtraPrinting.BarCode.QRCodeGenerator.CompactionMode": "Compaction Mode",
  "DevExpress.XtraPrinting.BarCode.QRCodeGenerator.ErrorCorrectionLevel": "Error Correction Level",
  "DevExpress.XtraPrinting.BarCode.QRCodeGenerator.Version": "Version",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.AutoVersion": "Auto-Select Version",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version1": "Version 1 (21x21)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version10": "Version 10 (57x57)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version11": "Version 11 (61x61)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version12": "Version 12 (65x65)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version13": "Version 13 (69x69)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version14": "Version 14 (73x73)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version15": "Version 15 (77x77)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version16": "Version 16 (81x81)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version17": "Version 17 (85x85)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version18": "Version 18 (89x89)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version19": "Version 19 (93x93)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version2": "Version 2 (25x25)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version20": "Version 20 (97x97)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version21": "Version 21 (101x101)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version22": "Version 22 (105x105)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version23": "Version 23 (109x109)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version24": "Version 24 (113x113)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version25": "Version 25 (117x117)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version26": "Version 26 (121x121)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version27": "Version 27 (125x125)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version28": "Version 28 (129x129)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version29": "Version 29 (133x133)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version3": "Version 3 (29x29)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version30": "Version 30 (137x137)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version31": "Version 31 (141x141)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version32": "Version 32 (145x145)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version33": "Version 33 (149x149)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version34": "Version 34 (153x153)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version35": "Version 35 (157x157)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version36": "Version 36 (161x161)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version37": "Version 37 (165x165)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version38": "Version 38 (169x169)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version39": "Version 39 (173x173)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version4": "Version 4 (33x33)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version40": "Version 40 (177x177)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version5": "Version 5 (37x37)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version6": "Version 6 (41x41)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version7": "Version 7 (45x45)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version8": "Version 8 (49x49)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version9": "Version 9 (53x53)",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.Padding": "Padding",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.Text": "Text",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.TextAlignment": "Text Alignment",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.TextColor": "Text Color",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextAlignment.Center": "Center",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Bottom": "Bottom",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Left": "Left",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Right": "Right",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Top": "Top",
  "DevExpress.XtraPrinting.BarCode.RectangleQRFrameOptions": "Rectangle",
  "DevExpress.XtraPrinting.ChangingPermissions.AnyExceptExtractingPages": "Any Except Extracting Pages",
  "DevExpress.XtraPrinting.ChangingPermissions.CommentingFillingSigning": "Commenting Filling Signing",
  "DevExpress.XtraPrinting.ChangingPermissions.FillingSigning": "Filling Signing",
  "DevExpress.XtraPrinting.ChangingPermissions.InsertingDeletingRotating": "Inserting Deleting Rotating",
  "DevExpress.XtraPrinting.ChangingPermissions.None": "None",
  "DevExpress.XtraPrinting.ColumnLayout.AcrossThenDown": "First Across, then Down",
  "DevExpress.XtraPrinting.ColumnLayout.DownThenAcross": "First Down, then Across",
  "DevExpress.XtraPrinting.CsvExportOptions": "CSV Export Options",
  "DevExpress.XtraPrinting.CsvExportOptions.SkipEmptyColumns": "Skip Empty Columns",
  "DevExpress.XtraPrinting.CsvExportOptions.SkipEmptyRows": "Skip Empty Rows",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Author": "Author",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Category": "Category",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Comments": "Comments",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Subject": "Subject",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Title": "Title",
  "DevExpress.XtraPrinting.DocxExportMode.SingleFile": "Single File",
  "DevExpress.XtraPrinting.DocxExportMode.SingleFilePageByPage": "Single File (Page-by-Page)",
  "DevExpress.XtraPrinting.DocxExportOptions.ExportMode": "Export Mode",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.BackwardDiagonal": "Backward Diagonal",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.ForwardDiagonal": "Forward Diagonal",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.Horizontal": "Horizontal",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.Vertical": "Vertical",
  "DevExpress.XtraPrinting.Drawing.ImageViewMode.Clip": "Clip",
  "DevExpress.XtraPrinting.Drawing.ImageViewMode.Stretch": "Stretch",
  "DevExpress.XtraPrinting.Drawing.ImageViewMode.Zoom": "Zoom",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.Font": "Font",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ForeColor": "Foreground Color",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ImageTiling": "Image Tiling",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ImageTransparency": "Image Transparency",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ImageViewMode": "Image View Mode",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ShowBehind": "Show Behind",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.Text": "Text",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.TextDirection": "Text Direction",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.TextTransparency": "Text Transparency",
  "DevExpress.XtraPrinting.Drawing.Watermark.Id": "Id",
  "DevExpress.XtraPrinting.Drawing.Watermark.PageRange": "Page Range",
  "DevExpress.XtraPrinting.EmailOptions": "E-mail Options",
  "DevExpress.XtraPrinting.EmailOptions.Body": "Body",
  "DevExpress.XtraPrinting.EmailOptions.RecipientAddress": "Recipient Address",
  "DevExpress.XtraPrinting.EmailOptions.RecipientAddressPrefix": "Recipient Address Prefix",
  "DevExpress.XtraPrinting.EmailOptions.RecipientName": "Recipient Name",
  "DevExpress.XtraPrinting.EmailOptions.Subject": "Subject",
  "DevExpress.XtraPrinting.ExportOptions": "Export Options",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.EmptyFirstPageHeaderFooter": "Empty First Page Header/Footer",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.ExportWatermarks": "Export Watermarks",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.KeepRowHeight": "Keep Row Height",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.PageRange": "Page Range",
  "DevExpress.XtraPrinting.GlyphStyle.Star": "Star",
  "DevExpress.XtraPrinting.HtmlExportMode.DifferentFiles": "Different Files",
  "DevExpress.XtraPrinting.HtmlExportMode.SingleFile": "Single File",
  "DevExpress.XtraPrinting.HtmlExportMode.SingleFilePageByPage": "Single File (Page-by-Page)",
  "DevExpress.XtraPrinting.HtmlExportOptions": "HTML Export Options",
  "DevExpress.XtraPrinting.HtmlExportOptions.EmbedImagesInHTML": "Embed Images in HTML",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.CharacterSet": "Character Set",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.ExportMode": "Export Mode",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.InlineCss": "Inline CSS",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.PageBorderColor": "Page Border Color",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.PageBorderWidth": "Page Border Width",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.PageRange": "Page Range",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.RemoveSecondarySymbols": "Remove Secondary Symbols",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.TableLayout": "Table Layout",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.Title": "Title",
  "DevExpress.XtraPrinting.ImageExportMode.DifferentFiles": "Different Files",
  "DevExpress.XtraPrinting.ImageExportMode.SingleFile": "Single File",
  "DevExpress.XtraPrinting.ImageExportMode.SingleFilePageByPage": "Single File (Page-by-Page)",
  "DevExpress.XtraPrinting.ImageExportOptions": "Image Export Options",
  "DevExpress.XtraPrinting.ImageExportOptions.ExportMode": "Export Mode",
  "DevExpress.XtraPrinting.ImageExportOptions.Format": "Format",
  "DevExpress.XtraPrinting.ImageExportOptions.PageBorderColor": "Page Border's Color",
  "DevExpress.XtraPrinting.ImageExportOptions.PageBorderWidth": "Page Border's Width",
  "DevExpress.XtraPrinting.ImageExportOptions.PageRange": "Page Range",
  "DevExpress.XtraPrinting.ImageExportOptions.Resolution": "Resolution",
  "DevExpress.XtraPrinting.ImageItem.Id": "Id",
  "DevExpress.XtraPrinting.MailMessageExportOptions": "Mail Message Export Options",
  "DevExpress.XtraPrinting.MhtExportOptions": "MHT Export Options",
  "DevExpress.XtraPrinting.NativeFormatOptions": "Native Format Options",
  "DevExpress.XtraPrinting.NativeFormatOptions.Compressed": "Compressed",
  "DevExpress.XtraPrinting.NativeFormatOptions.ShowOptionsBeforeSave": "Show Options before Saving",
  "DevExpress.XtraPrinting.PageByPageExportOptionsBase.PageRange": "Page Range",
  "DevExpress.XtraPrinting.PageByPageExportOptionsBase.RasterizationResolution": "Rasterization Resolution",
  "DevExpress.XtraPrinting.PdfACompatibility.None": "None",
  "DevExpress.XtraPrinting.PdfACompatibility.PdfA1b": "PDF/A-1b",
  "DevExpress.XtraPrinting.PdfACompatibility.PdfA2b": "PDF/A-2b",
  "DevExpress.XtraPrinting.PdfACompatibility.PdfA3b": "PDF/A-3b",
  "DevExpress.XtraPrinting.PdfDocumentOptions": "PDF Document Options",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Application": "Application",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Author": "Author",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Keywords": "Keywords",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Subject": "Subject",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Title": "Title",
  "DevExpress.XtraPrinting.PdfExportOptions": "PDF Export Options",
  "DevExpress.XtraPrinting.PdfExportOptions.Attachments": "Attachments",
  "DevExpress.XtraPrinting.PdfExportOptions.Compressed": "Compressed",
  "DevExpress.XtraPrinting.PdfExportOptions.ConvertImagesToJpeg": "Convert Images to Jpeg",
  "DevExpress.XtraPrinting.PdfExportOptions.DocumentOptions": "Document Options",
  "DevExpress.XtraPrinting.PdfExportOptions.ImageQuality": "Image Quality",
  "DevExpress.XtraPrinting.PdfExportOptions.NeverEmbeddedFonts": "Never Embedded Fonts",
  "DevExpress.XtraPrinting.PdfExportOptions.PasswordSecurityOptions": "Security Options",
  "DevExpress.XtraPrinting.PdfExportOptions.ShowPrintDialogOnOpen": "Show Print Dialog on Open",
  "DevExpress.XtraPrinting.PdfExportOptions.SignatureOptions": "Signature Options",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.High": "High",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Highest": "Highest",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Low": "Low",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Lowest": "Lowest",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Medium": "Medium",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions": "Pdf Password Security Options",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions.OpenPassword": "Open Password",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions.PermissionsOptions": "Permissions Options",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions.PermissionsPassword": "Permissions Password",
  "DevExpress.XtraPrinting.PdfPermissionsOptions": "Pdf Permissions Options",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.ChangingPermissions": "Changing Permissions",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.EnableCopying": "Enable Copying",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.EnableScreenReaders": "Enable Screen Readers",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.PrintingPermissions": "Printing Permissions",
  "DevExpress.XtraPrinting.PdfUACompatibility.None": "None",
  "DevExpress.XtraPrinting.PrintPreviewOptions": "Print Preview Options",
  "DevExpress.XtraPrinting.PrintPreviewOptions.ActionAfterExport": "Action After Export",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultDirectory": "Default Directory",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultExportFormat": "Default Export Format",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultFileName": "Default File Name",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultSendFormat": "Default Send Format",
  "DevExpress.XtraPrinting.PrintPreviewOptions.SaveMode": "Save Mode",
  "DevExpress.XtraPrinting.PrintPreviewOptions.ShowOptionsBeforeExport": "Show Options Dialog Before Export",
  "DevExpress.XtraPrinting.PrinterSettingsUsing": "Using Printer Settings",
  "DevExpress.XtraPrinting.PrinterSettingsUsing.UseLandscape": "Use Landscape",
  "DevExpress.XtraPrinting.PrinterSettingsUsing.UsePaperKind": "Use Paper Kind",
  "DevExpress.XtraPrinting.PrintingPermissions.HighResolution": "High Resolution",
  "DevExpress.XtraPrinting.PrintingPermissions.LowResolution": "Low Resolution",
  "DevExpress.XtraPrinting.PrintingPermissions.None": "None",
  "DevExpress.XtraPrinting.Recipient.Address": "Address",
  "DevExpress.XtraPrinting.Recipient.ContactName": "Contact Name",
  "DevExpress.XtraPrinting.Recipient.FieldType": "Field Type",
  "DevExpress.XtraPrinting.Recipient.Prefix": "Prefix",
  "DevExpress.XtraPrinting.RecipientFieldType.BCC": "BCC",
  "DevExpress.XtraPrinting.RecipientFieldType.CC": "CC",
  "DevExpress.XtraPrinting.RtfExportMode.SingleFile": "Single File",
  "DevExpress.XtraPrinting.RtfExportMode.SingleFilePageByPage": "Single File (Page-by-Page)",
  "DevExpress.XtraPrinting.RtfExportOptions": "RTF Export Options",
  "DevExpress.XtraPrinting.RtfExportOptions.ExportMode": "Export Mode",
  "DevExpress.XtraPrinting.SaveMode.UsingDefaultPath": "Using a Default Path",
  "DevExpress.XtraPrinting.SaveMode.UsingSaveFileDialog": "Using a Save File Dialog",
  "DevExpress.XtraPrinting.Shape.FilletShapeBase.Fillet": "Fillet",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Arrow": "Arrow",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.BackslantLine": "Backslant Line",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.BottomArrow": "Bottom Arrow",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Brace": "Brace",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Bracket": "Bracket",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Cross": "Cross",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.EightPointStar": "8-Point Star",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Ellipse": "Ellipse",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.FivePointStar": "5-Point Star",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.FourPointStar": "4-Point Star",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Hexagon": "Hexagon",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.HorizontalLine": "Horizontal Line",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.LeftArrow": "Left Arrow",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Line": "Line",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Octagon": "Octagon",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Pentagon": "Pentagon",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Polygon": "Polygon",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Rectangle": "Rectangle",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.RightArrow": "Right Arrow",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.SixPointStar": "6-Point Star",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.SlantLine": "Slant Line",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Square": "Square",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Star": "Star",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.ThreePointStar": "3-Point Star",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.TopArrow": "Top Arrow",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Triangle": "Triangle",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.VerticalLine": "Vertical Line",
  "DevExpress.XtraPrinting.Shape.ShapeArrow.ArrowHeight": "Arrow Height",
  "DevExpress.XtraPrinting.Shape.ShapeArrow.ArrowWidth": "Arrow Width",
  "DevExpress.XtraPrinting.Shape.ShapeBrace.Fillet": "Fillet",
  "DevExpress.XtraPrinting.Shape.ShapeBrace.TailLength": "Tail's Length",
  "DevExpress.XtraPrinting.Shape.ShapeBracket.TipLength": "Tip's Length",
  "DevExpress.XtraPrinting.Shape.ShapeCross.HorizontalLineWidth": "Horizontal Line Width",
  "DevExpress.XtraPrinting.Shape.ShapeCross.VerticalLineWidth": "Vertical Line Width",
  "DevExpress.XtraPrinting.Shape.ShapePolygon.NumberOfSides": "Number of Sides",
  "DevExpress.XtraPrinting.Shape.ShapeStar.Concavity": "Concavity",
  "DevExpress.XtraPrinting.Shape.ShapeStar.StarPointCount": "Count of Star Points",
  "DevExpress.XtraPrinting.SignatureImageDisplayMode.Hide": "Hide",
  "DevExpress.XtraPrinting.SignatureImageDisplayMode.Show": "Show",
  "DevExpress.XtraPrinting.SizeMode.AutoHeight": "Auto Height",
  "DevExpress.XtraPrinting.SizeMode.AutoSize": "Auto Size",
  "DevExpress.XtraPrinting.SizeMode.Custom": "Custom",
  "DevExpress.XtraPrinting.TextExportMode.Text": "Text",
  "DevExpress.XtraPrinting.TextExportMode.Value": "Value",
  "DevExpress.XtraPrinting.TextExportOptions": "Text Export Options",
  "DevExpress.XtraPrinting.TextExportOptionsBase.Encoding": "Encoding",
  "DevExpress.XtraPrinting.TextExportOptionsBase.QuoteStringsWithSeparators": "Quote Strings with Separators",
  "DevExpress.XtraPrinting.TextExportOptionsBase.Separator": "Separator",
  "DevExpress.XtraPrinting.TextExportOptionsBase.TextExportMode": "Text Export Mode",
  "DevExpress.XtraPrinting.XlDocumentOptions": "Excel Document Options",
  "DevExpress.XtraPrinting.XlDocumentOptions.Application": "Application",
  "DevExpress.XtraPrinting.XlDocumentOptions.Author": "Author",
  "DevExpress.XtraPrinting.XlDocumentOptions.Category": "Category",
  "DevExpress.XtraPrinting.XlDocumentOptions.Comments": "Comments",
  "DevExpress.XtraPrinting.XlDocumentOptions.Company": "Company",
  "DevExpress.XtraPrinting.XlDocumentOptions.Subject": "Subject",
  "DevExpress.XtraPrinting.XlDocumentOptions.Tags": "Tags",
  "DevExpress.XtraPrinting.XlDocumentOptions.Title": "Title",
  "DevExpress.XtraPrinting.XlEncryptionOptions": "Excel Encryption Options",
  "DevExpress.XtraPrinting.XlEncryptionOptions.Password": "Password",
  "DevExpress.XtraPrinting.XlEncryptionOptions.Type": "Type",
  "DevExpress.XtraPrinting.XlEncryptionType.Compatible": "Compatible",
  "DevExpress.XtraPrinting.XlEncryptionType.Strong": "Strong",
  "DevExpress.XtraPrinting.XlExportOptionsBase.IgnoreErrors": "Ignore Errors",
  "DevExpress.XtraPrinting.XlIgnoreErrors.None": "None",
  "DevExpress.XtraPrinting.XlsExportMode.DifferentFiles": "Different Files",
  "DevExpress.XtraPrinting.XlsExportMode.SingleFile": "Single File",
  "DevExpress.XtraPrinting.XlsExportMode.SingleFilePageByPage": "Single File (Page-by-Page)",
  "DevExpress.XtraPrinting.XlsExportOptions": "XLS Export Options",
  "DevExpress.XtraPrinting.XlsExportOptions.DocumentOptions": "Document Options",
  "DevExpress.XtraPrinting.XlsExportOptions.ExportHyperlinks": "Export Hyperlinks",
  "DevExpress.XtraPrinting.XlsExportOptions.ExportMode": "Export Mode",
  "DevExpress.XtraPrinting.XlsExportOptions.PageRange": "Page Range",
  "DevExpress.XtraPrinting.XlsExportOptions.RawDataMode": "Raw Data Mode",
  "DevExpress.XtraPrinting.XlsExportOptions.SheetName": "Sheet Name",
  "DevExpress.XtraPrinting.XlsExportOptions.ShowGridLines": "Show Grid Lines",
  "DevExpress.XtraPrinting.XlsExportOptions.Suppress256ColumnsWarning": "Suppress 256 Columns Warning",
  "DevExpress.XtraPrinting.XlsExportOptions.Suppress65536RowsWarning": "Suppress 65536 Rows Warning",
  "DevExpress.XtraPrinting.XlsExportOptions.WorkbookColorPaletteCompliance": "Workbook Color Palette Compliance",
  "DevExpress.XtraPrinting.XlsxExportMode.DifferentFiles": "Different Files",
  "DevExpress.XtraPrinting.XlsxExportMode.SingleFile": "Single File",
  "DevExpress.XtraPrinting.XlsxExportMode.SingleFilePageByPage": "Single File (Page-by-Page)",
  "DevExpress.XtraPrinting.XlsxExportOptions": "XLSX Export Options",
  "DevExpress.XtraPrinting.XlsxExportOptions.ExportMode": "Export Mode",
  "DevExpress.XtraPrinting.XlsxExportOptions.PageRange": "Page Range",
  "DevExpress.XtraPrinting.XpsDocumentOptions": "XPS Document Options",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Category": "Category",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Creator": "Creator",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Description": "Description",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Keywords": "Keywords",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Subject": "Subject",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Title": "Title",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Version": "Version",
  "DevExpress.XtraPrinting.XpsExportOptions.Compression": "Compression",
  "DevExpress.XtraPrinting.XpsExportOptions.DocumentOptions": "Document Options",
  "DevExpress.XtraReports.Design.DataBinding.Binding": "Binding",
  "DevExpress.XtraReports.Design.DataBinding.FormatString": "Format String",
  "DevExpress.XtraReports.Design.GroupSort.GroupSortReflectItem.ShowFooter": "Show Footer",
  "DevExpress.XtraReports.Design.GroupSort.GroupSortReflectItem.ShowHeader": "Show Header",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings": "Dynamic List",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings.DisplayMember": "Display Member",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings.SortOrder": "Sort Order",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings.ValueMember": "Value Member",
  "DevExpress.XtraReports.Parameters.LookUpSettings.DataAdapter": "Data Adapter",
  "DevExpress.XtraReports.Parameters.LookUpSettings.DataMember": "Data Member",
  "DevExpress.XtraReports.Parameters.LookUpSettings.DataSource": "Data Source",
  "DevExpress.XtraReports.Parameters.Orientation.Horizontal": "Horizontal",
  "DevExpress.XtraReports.Parameters.Orientation.Vertical": "Vertical",
  "DevExpress.XtraReports.Parameters.Parameter": "Parameter",
  "DevExpress.XtraReports.Parameters.Parameter.Description": "Description",
  "DevExpress.XtraReports.Parameters.Parameter.Enabled": "Enabled",
  "DevExpress.XtraReports.Parameters.Parameter.Tag": "Tag",
  "DevExpress.XtraReports.Parameters.Parameter.Type": "Type",
  "DevExpress.XtraReports.Parameters.Parameter.Value": "Value",
  "DevExpress.XtraReports.Parameters.Parameter.Visible": "Visible",
  "DevExpress.XtraReports.Parameters.ParameterType.Boolean": "Boolean",
  "DevExpress.XtraReports.Parameters.ParameterType.DateTime": "DateTime",
  "DevExpress.XtraReports.Parameters.ParameterType.Decimal": "Decimal",
  "DevExpress.XtraReports.Parameters.ParameterType.Double": "Double",
  "DevExpress.XtraReports.Parameters.ParameterType.Float": "Float",
  "DevExpress.XtraReports.Parameters.ParameterType.Int32": "Int32",
  "DevExpress.XtraReports.Parameters.ParameterType.String": "String",
  "DevExpress.XtraReports.Parameters.StaticListLookUpSettings": "Static List",
  "DevExpress.XtraReports.Parameters.StaticListLookUpSettings.LookUpValues": "Look-Up Values",
  "DevExpress.XtraReports.ScriptLanguage.CSharp": "C#",
  "DevExpress.XtraReports.ScriptLanguage.JScript": "JScript .NET",
  "DevExpress.XtraReports.ScriptLanguage.VisualBasic": "Visual Basic",
  "DevExpress.XtraReports.UI.AutoSizeMode.None": "None",
  "DevExpress.XtraReports.UI.Band.Height": "Height",
  "DevExpress.XtraReports.UI.Band.PageBreak": "Page Break",
  "DevExpress.XtraReports.UI.Band.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.BandScripts": "Band Scripts",
  "DevExpress.XtraReports.UI.BottomMarginBand": "Bottom Margin",
  "DevExpress.XtraReports.UI.CalculatedField": "Calculated Field",
  "DevExpress.XtraReports.UI.CalculatedField.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.CalculatedField.DataSource": "Data Source",
  "DevExpress.XtraReports.UI.CalculatedField.DisplayName": "Display Name",
  "DevExpress.XtraReports.UI.CalculatedField.Expression": "Expression",
  "DevExpress.XtraReports.UI.CalculatedField.FieldType": "Field Type",
  "DevExpress.XtraReports.UI.CalculatedField.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.CalculatedFieldScripts": "Calculated Field Scripts",
  "DevExpress.XtraReports.UI.CalculatedFieldScripts.OnGetValue": "Get a Value",
  "DevExpress.XtraReports.UI.ChartImageType.Bitmap": "Bitmap",
  "DevExpress.XtraReports.UI.ChartImageType.Metafile": "Metafile",
  "DevExpress.XtraReports.UI.CheckBoxGlyphOptions.Alignment": "Alignment",
  "DevExpress.XtraReports.UI.CheckBoxGlyphOptions.Size": "Size",
  "DevExpress.XtraReports.UI.CheckBoxGlyphOptions.Style": "Style",
  "DevExpress.XtraReports.UI.CheckBoxGlyphs.Checked": "Checked",
  "DevExpress.XtraReports.UI.CheckBoxGlyphs.Unchecked": "Unchecked",
  "DevExpress.XtraReports.UI.ColumnDirection.AcrossThenDown": "First Across, then Down",
  "DevExpress.XtraReports.UI.ColumnDirection.DownThenAcross": "First Down, then Across",
  "DevExpress.XtraReports.UI.ConditionFormatting.Style": "Style",
  "DevExpress.XtraReports.UI.ConditionFormatting.Visible": "Visible",
  "DevExpress.XtraReports.UI.CrossTab.CornerHeaderDisplayMode.None": "None",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabColumnField": "Column Field",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabDataField": "Data Field",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabDataField.SummaryType": "Summary Type",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabFieldBase.FieldName": "Field Name",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabFieldSortBySummaryInfo.FieldName": "Field Name",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabFieldSortBySummaryInfo.SummaryType": "Summary Type",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabGroupFieldBase.GroupInterval": "Group Interval",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabGroupFieldBase.GroupIntervalNumericRange": "Group Interval Numeric Range",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabGroupFieldBase.SortOrder": "Sort Order",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions": "Cross Tab Layout Options",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions.CornerHeaderDisplayMode": "Corner Header Display Mode",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions.HierarchicalRowLayout": "Hierarchical Row Layout",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions.RowTotalsPosition": "Row Totals Position",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabPrintOptions.AcrossThenDownOffset": "Across Then Down Offset",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabPrintOptions.PrintLayout": "Print Layout",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabPrintOptions.PrintTotalsForSingleValues": "Print Totals For Single Values",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabStyles.DataAreaStyle": "Data Area Style",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabStyles.HeaderAreaStyle": "Header Area Style",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Alphabetical": "Alphabetical",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Date": "Date",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateDay": "Day",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateDayOfWeek": "Day of Week",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateDayOfYear": "Day of Year",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateHour": "Date-Hour",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateHourMinuteSecond": "Date-Hour-Minute-Second",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateMonth": "Month",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateQuarter": "Quarter",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateQuarterYear": "Quarter-Year",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateYear": "Year",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Default": "Default",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Hour": "Hour",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Minute": "Minute",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Numeric": "Numeric",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Second": "Second",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.AbsoluteVariation": "Absolute Variation",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.Default": "Default",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.Index": "Index",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.PercentOfColumn": "Percent of Column",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.PercentOfRow": "Percent of Row",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.PercentVariation": "Percent Variation",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Average": "Average",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Count": "Count",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Max": "Max",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Min": "Min",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.StdDev": "Standard Deviation",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Sum": "Sum",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Var": "Variation",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Varp": "Variation for Entire Population",
  "DevExpress.XtraReports.UI.CrossTab.TotalHeaderPosition.Inner": "Inner",
  "DevExpress.XtraReports.UI.CrossTab.TotalHeaderPosition.Outer": "Outer",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCell.Angle": "Angle",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCell.ColumnAutoWidthMode": "Column Auto Width Mode",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCellCollection.ColumnCount": "Column Count",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCellCollection.RowCount": "Row Count",
  "DevExpress.XtraReports.UI.DetailBand": "Detail",
  "DevExpress.XtraReports.UI.DetailBand.KeepTogetherWithDetailReports": "Keep Together with Detail Reports",
  "DevExpress.XtraReports.UI.DetailBand.MultiColumn": "Multi-Column Options",
  "DevExpress.XtraReports.UI.DetailBand.SortFields": "Sort Fields",
  "DevExpress.XtraReports.UI.DetailReportBand": "Detail Report",
  "DevExpress.XtraReports.UI.DetailReportBand.Level": "Level",
  "DevExpress.XtraReports.UI.DocumentExportMode.Auto": "Auto",
  "DevExpress.XtraReports.UI.EditOptions.Enabled": "Enabled",
  "DevExpress.XtraReports.UI.FormattingRule": "Formatting Rule",
  "DevExpress.XtraReports.UI.FormattingRule.Condition": "Condition",
  "DevExpress.XtraReports.UI.FormattingRule.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.FormattingRule.DataSource": "Data Source",
  "DevExpress.XtraReports.UI.FormattingRule.Formatting": "Formatting",
  "DevExpress.XtraReports.UI.GaugeImageType.Bitmap": "Bitmap",
  "DevExpress.XtraReports.UI.GaugeImageType.Metafile": "Metafile",
  "DevExpress.XtraReports.UI.GroupBand.Level": "Level",
  "DevExpress.XtraReports.UI.GroupBand.RepeatEveryPage": "Repeat Every Page",
  "DevExpress.XtraReports.UI.GroupBand.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.GroupBandScripts.OnBandLevelChanged": "Band Level Changed",
  "DevExpress.XtraReports.UI.GroupField": "Group Field",
  "DevExpress.XtraReports.UI.GroupField.FieldName": "Field Name",
  "DevExpress.XtraReports.UI.GroupField.SortOrder": "Sort Order",
  "DevExpress.XtraReports.UI.GroupFooterBand": "Group Footer",
  "DevExpress.XtraReports.UI.GroupFooterBand.GroupUnion": "Group Union",
  "DevExpress.XtraReports.UI.GroupFooterBand.PrintAtBottom": "Print at Bottom",
  "DevExpress.XtraReports.UI.GroupFooterUnion.None": "None",
  "DevExpress.XtraReports.UI.GroupFooterUnion.WithLastDetail": "With Last Detail",
  "DevExpress.XtraReports.UI.GroupHeaderBand": "Group Header",
  "DevExpress.XtraReports.UI.GroupHeaderBand.GroupFields": "Group Fields",
  "DevExpress.XtraReports.UI.GroupHeaderBand.GroupUnion": "Group Union",
  "DevExpress.XtraReports.UI.GroupHeaderBand.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.GroupHeaderBand.SortingSummary": "Sorting Summary",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts": "Group Header Band Scripts",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts.OnSortingSummaryGetResult": "Sorting Summary Get Result",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts.OnSortingSummaryReset": "Sorting Summary Reset",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts.OnSortingSummaryRowChanged": "Sorting Summary Row Changed",
  "DevExpress.XtraReports.UI.GroupUnion.None": "None",
  "DevExpress.XtraReports.UI.GroupUnion.WholePage": "Whole Page",
  "DevExpress.XtraReports.UI.GroupUnion.WithFirstDetail": "With First Detail",
  "DevExpress.XtraReports.UI.HierarchyPrintOptions.ChildListFieldName": "Child List Field Name",
  "DevExpress.XtraReports.UI.HierarchyPrintOptions.Indent": "Indent",
  "DevExpress.XtraReports.UI.HierarchyPrintOptions.KeepTogetherWithFirstChild": "Keep Together With First Child",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.Both": "Both",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.Left": "Left",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.None": "None",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.Right": "Right",
  "DevExpress.XtraReports.UI.LineDirection.BackSlant": "Back Slant",
  "DevExpress.XtraReports.UI.LineDirection.Horizontal": "Horizontal",
  "DevExpress.XtraReports.UI.LineDirection.Slant": "Slant",
  "DevExpress.XtraReports.UI.LineDirection.Vertical": "Vertical",
  "DevExpress.XtraReports.UI.MultiColumn": "Multi-Column Options",
  "DevExpress.XtraReports.UI.MultiColumn.ColumnCount": "Column Count",
  "DevExpress.XtraReports.UI.MultiColumn.ColumnSpacing": "Column Spacing",
  "DevExpress.XtraReports.UI.MultiColumn.ColumnWidth": "Column Width",
  "DevExpress.XtraReports.UI.MultiColumn.Direction": "Direction",
  "DevExpress.XtraReports.UI.MultiColumn.Layout": "Layout",
  "DevExpress.XtraReports.UI.MultiColumn.Mode": "Mode",
  "DevExpress.XtraReports.UI.MultiColumnMode.None": "None",
  "DevExpress.XtraReports.UI.MultiColumnMode.UseColumnCount": "Use Column Count",
  "DevExpress.XtraReports.UI.MultiColumnMode.UseColumnWidth": "Use Column Width",
  "DevExpress.XtraReports.UI.PageBand.PrintOn": "Print On",
  "DevExpress.XtraReports.UI.PageBreak.AfterBand": "After the Band",
  "DevExpress.XtraReports.UI.PageBreak.BeforeBand": "Before the Band",
  "DevExpress.XtraReports.UI.PageBreak.None": "None",
  "DevExpress.XtraReports.UI.PageFooterBand": "Page Footer",
  "DevExpress.XtraReports.UI.PageHeaderBand": "Page Header",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.Cell": "Cell",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.CustomTotalCell": "Custom Total Cell",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldHeader": "Field Header",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldValue": "Field Value",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldValueGrandTotal": "FieldValueGrandTotal",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldValueTotal": "Field Value Total",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FilterSeparator": "Filter Separator",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.GrandTotalCell": "Grand Total Cell",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.HeaderGroupLine": "Header Group Line",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.Lines": "Lines",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.TotalCell": "Total Cell",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.CellStyle": "Cell Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.CustomTotalCellStyle": "Custom Total Cell Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldHeaderStyle": "Field Header Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldValueGrandTotalStyle": "Field Value Grand Total Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldValueStyle": "Field Value Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldValueTotalStyle": "Field Value Total Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FilterSeparatorStyle": "Filter Separator Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.GrandTotalCellStyle": "Grand Total Cell Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.HeaderGroupLineStyle": "Header Group Line Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.LinesStyle": "Lines Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.TotalCellStyle": "Total Cell Style",
  "DevExpress.XtraReports.UI.PivotGrid.XRPrefilter": "Prefilter",
  "DevExpress.XtraReports.UI.PrintLayout.AcrossOnly": "Across Only",
  "DevExpress.XtraReports.UI.PrintOnPages.AllPages": "All Pages",
  "DevExpress.XtraReports.UI.PrintOnPages.NotWithReportFooter": "Not with Report Footer",
  "DevExpress.XtraReports.UI.PrintOnPages.NotWithReportHeader": "Not with Report Header",
  "DevExpress.XtraReports.UI.PrintOnPages.NotWithReportHeaderAndReportFooter": "Not with Report Header and Report Footer",
  "DevExpress.XtraReports.UI.PrintableComponentContainer": "Printable Component Container",
  "DevExpress.XtraReports.UI.PrintableComponentContainer.ClipContent": "Clip Content",
  "DevExpress.XtraReports.UI.PrintableComponentContainer.WindowControlOptions": "Window Control Options",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.Leave": "Leave",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.Merge": "Merge",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.Suppress": "Suppress",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.SuppressAndShrink": "Suppress and Shrink",
  "DevExpress.XtraReports.UI.ProcessDuplicatesTarget.Tag": "Tag",
  "DevExpress.XtraReports.UI.ProcessDuplicatesTarget.Value": "Value",
  "DevExpress.XtraReports.UI.ReportFooterBand": "Report Footer",
  "DevExpress.XtraReports.UI.ReportFooterBand.PrintAtBottom": "Print at Bottom",
  "DevExpress.XtraReports.UI.ReportHeaderBand": "Report Header",
  "DevExpress.XtraReports.UI.ReportPrintOptions": "Report Print Options",
  "DevExpress.XtraReports.UI.ReportPrintOptions.BlankDetailCount": "Blank Detail Count",
  "DevExpress.XtraReports.UI.ReportPrintOptions.DetailCount": "Detail Count",
  "DevExpress.XtraReports.UI.ReportPrintOptions.DetailCountAtDesignTime": "Detail Count at Design Time",
  "DevExpress.XtraReports.UI.ReportPrintOptions.DetailCountOnEmptyDataSource": "Detail Count when Data Source is Empty",
  "DevExpress.XtraReports.UI.ReportPrintOptions.PrintOnEmptyDataSource": "Print when Data Source is Empty",
  "DevExpress.XtraReports.UI.ReportUnit.HundredthsOfAnInch": "Hundredths of an Inch",
  "DevExpress.XtraReports.UI.ReportUnit.Pixels": "Pixels",
  "DevExpress.XtraReports.UI.ReportUnit.TenthsOfAMillimeter": "Tenths of a Millimeter",
  "DevExpress.XtraReports.UI.RightToLeft.Inherit": "Inherit",
  "DevExpress.XtraReports.UI.RightToLeft.No": "No",
  "DevExpress.XtraReports.UI.RightToLeft.Yes": "Yes",
  "DevExpress.XtraReports.UI.RightToLeftLayout.No": "No",
  "DevExpress.XtraReports.UI.RightToLeftLayout.Yes": "Yes",
  "DevExpress.XtraReports.UI.SnappingMode.None": "None",
  "DevExpress.XtraReports.UI.SnappingMode.SnapLines": "Snap Lines",
  "DevExpress.XtraReports.UI.SnappingMode.SnapToGrid": "Snap to Grid",
  "DevExpress.XtraReports.UI.SortingOptions.FieldName": "Field Name",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Avg": "Average",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Count": "Count",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Custom": "Custom",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DAvg": "Average (Distinct)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DCount": "Count (Distinct)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DStdDev": "Standard Deviation (Distinct)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DStdDevP": "Standard Population Deviation (Distinct)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DSum": "Summary (Distinct)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DVar": "Variance (Distinct)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DVarP": "Population Variance (Distinct)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Max": "Max",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Median": "Median",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Min": "Min",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.StdDev": "Standard Deviation",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.StdDevP": "Standard Population Deviation",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Sum": "Sum",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Var": "Variance",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.VarP": "Population Variance",
  "DevExpress.XtraReports.UI.SparklineImageType.Bitmap": "Bitmap",
  "DevExpress.XtraReports.UI.SparklineImageType.Metafile": "Metafile",
  "DevExpress.XtraReports.UI.StylePriority": "Style Priority",
  "DevExpress.XtraReports.UI.StylePriority.UseBackColor": "Use Background Color",
  "DevExpress.XtraReports.UI.StylePriority.UseBorderColor": "Use Border Color",
  "DevExpress.XtraReports.UI.StylePriority.UseBorderDashStyle": "Use Border Dash Style",
  "DevExpress.XtraReports.UI.StylePriority.UseBorderWidth": "Use Border Width",
  "DevExpress.XtraReports.UI.StylePriority.UseBorders": "Use Borders",
  "DevExpress.XtraReports.UI.StylePriority.UseFont": "Use Font",
  "DevExpress.XtraReports.UI.StylePriority.UseForeColor": "Use Foreground Color",
  "DevExpress.XtraReports.UI.StylePriority.UsePadding": "Use Padding",
  "DevExpress.XtraReports.UI.StylePriority.UseTextAlignment": "Use Text Alignment",
  "DevExpress.XtraReports.UI.StyleUsing": "Using Style",
  "DevExpress.XtraReports.UI.StyleUsing.UseBackColor": "Use Background Color",
  "DevExpress.XtraReports.UI.StyleUsing.UseBorderColor": "Use Border Color",
  "DevExpress.XtraReports.UI.StyleUsing.UseBorderWidth": "Use Border Width",
  "DevExpress.XtraReports.UI.StyleUsing.UseBorders": "Use Borders",
  "DevExpress.XtraReports.UI.StyleUsing.UseFont": "Use Font",
  "DevExpress.XtraReports.UI.StyleUsing.UseForeColor": "Use Foreground Color",
  "DevExpress.XtraReports.UI.StyleUsing.UsePadding": "Use Padding",
  "DevExpress.XtraReports.UI.StyleUsing.UseTextAlignment": "Use Text Alignment",
  "DevExpress.XtraReports.UI.SubreportBase.ReportSource": "Report Source",
  "DevExpress.XtraReports.UI.SubreportBase.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.SubreportBaseScripts.OnEvaluateBinding": "Evaluate Binding",
  "DevExpress.XtraReports.UI.SubreportBaseScripts.OnSizeChanged": "Size Changed",
  "DevExpress.XtraReports.UI.SummaryFunc.Avg": "Average",
  "DevExpress.XtraReports.UI.SummaryFunc.Count": "Count",
  "DevExpress.XtraReports.UI.SummaryFunc.Custom": "Custom",
  "DevExpress.XtraReports.UI.SummaryFunc.DAvg": "Average (Distinct)",
  "DevExpress.XtraReports.UI.SummaryFunc.DCount": "Count (Distinct)",
  "DevExpress.XtraReports.UI.SummaryFunc.DStdDev": "Standard Deviation (Distinct)",
  "DevExpress.XtraReports.UI.SummaryFunc.DStdDevP": "Standard Population Deviation (Distinct)",
  "DevExpress.XtraReports.UI.SummaryFunc.DSum": "Summary (Distinct)",
  "DevExpress.XtraReports.UI.SummaryFunc.DVar": "Variance (Distinct)",
  "DevExpress.XtraReports.UI.SummaryFunc.DVarP": "Population Variance (Distinct)",
  "DevExpress.XtraReports.UI.SummaryFunc.Max": "Max",
  "DevExpress.XtraReports.UI.SummaryFunc.Median": "Median",
  "DevExpress.XtraReports.UI.SummaryFunc.Min": "Min",
  "DevExpress.XtraReports.UI.SummaryFunc.Percentage": "Percentage",
  "DevExpress.XtraReports.UI.SummaryFunc.RecordNumber": "Record Number",
  "DevExpress.XtraReports.UI.SummaryFunc.RunningSum": "Running Summary",
  "DevExpress.XtraReports.UI.SummaryFunc.StdDev": "Standard Deviation",
  "DevExpress.XtraReports.UI.SummaryFunc.StdDevP": "Standard Population Deviation",
  "DevExpress.XtraReports.UI.SummaryFunc.Sum": "Sum",
  "DevExpress.XtraReports.UI.SummaryFunc.Var": "Variance",
  "DevExpress.XtraReports.UI.SummaryFunc.VarP": "Population Variance",
  "DevExpress.XtraReports.UI.SummaryRunning.Group": "Group",
  "DevExpress.XtraReports.UI.SummaryRunning.None": "None",
  "DevExpress.XtraReports.UI.SummaryRunning.Page": "Page",
  "DevExpress.XtraReports.UI.SummaryRunning.Report": "Report",
  "DevExpress.XtraReports.UI.TextFitMode.GrowOnly": "Grow Only",
  "DevExpress.XtraReports.UI.TextFitMode.None": "None",
  "DevExpress.XtraReports.UI.TopMarginBand": "Top Margin",
  "DevExpress.XtraReports.UI.ValueSuppressType.Leave": "Leave",
  "DevExpress.XtraReports.UI.ValueSuppressType.MergeByTag": "Merge based on Tag",
  "DevExpress.XtraReports.UI.ValueSuppressType.MergeByValue": "Merge based on Value",
  "DevExpress.XtraReports.UI.ValueSuppressType.Suppress": "Suppress",
  "DevExpress.XtraReports.UI.ValueSuppressType.SuppressAndShrink": "Suppress and Shrink",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.Both": "Both",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.Bottom": "Bottom",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.None": "None",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.Top": "Top",
  "DevExpress.XtraReports.UI.VerticalHeaderBand.RepeatEveryPage": "Repeat Every Page",
  "DevExpress.XtraReports.UI.WinControlContainer": "Windows Forms Control",
  "DevExpress.XtraReports.UI.WinControlContainer.DrawMethod": "Drawing Method",
  "DevExpress.XtraReports.UI.WinControlContainer.ImageType": "Image Type",
  "DevExpress.XtraReports.UI.WinControlContainer.PrintMode": "Print Mode",
  "DevExpress.XtraReports.UI.WinControlContainer.SyncBounds": "Synchronize Bounds",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPaint": "Use WMPaint Method",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPaintRecursive": "Use WMPaint Recursively",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPrint": "Use WMPrint Method",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPrintRecursive": "Use WMPrint Recursively",
  "DevExpress.XtraReports.UI.WinControlImageType.Bitmap": "Bitmap",
  "DevExpress.XtraReports.UI.WinControlImageType.Metafile": "Metafile",
  "DevExpress.XtraReports.UI.WinControlPrintMode.AsBricks": "As Bricks",
  "DevExpress.XtraReports.UI.WinControlPrintMode.AsImage": "As Image",
  "DevExpress.XtraReports.UI.WinControlPrintMode.Default": "Default",
  "DevExpress.XtraReports.UI.WindowControlOptions": "Window Control Options",
  "DevExpress.XtraReports.UI.XRAccessibleRole.Default": "Default",
  "DevExpress.XtraReports.UI.XRAccessibleRole.Table": "Table",
  "DevExpress.XtraReports.UI.XRAppearanceObject.TextHorizontalAlignment": "Text Horizontal Alignment",
  "DevExpress.XtraReports.UI.XRAppearanceObject.TextVerticalAlignment": "Text Vertical Alignment",
  "DevExpress.XtraReports.UI.XRAppearanceObject.Trimming": "Trimming",
  "DevExpress.XtraReports.UI.XRAppearanceObject.WordWrap": "Word Wrap",
  "DevExpress.XtraReports.UI.XRBarCode": "Barcode",
  "DevExpress.XtraReports.UI.XRBarCode.Alignment": "Alignment",
  "DevExpress.XtraReports.UI.XRBarCode.AutoModule": "Auto Module",
  "DevExpress.XtraReports.UI.XRBarCode.BarCodeOrientation": "Orientation",
  "DevExpress.XtraReports.UI.XRBarCode.BinaryData": "Binary Data",
  "DevExpress.XtraReports.UI.XRBarCode.Module": "Module",
  "DevExpress.XtraReports.UI.XRBarCode.PaddingInfo": "Padding",
  "DevExpress.XtraReports.UI.XRBarCode.ShowText": "Show Text",
  "DevExpress.XtraReports.UI.XRBarCode.Symbology": "Symbology",
  "DevExpress.XtraReports.UI.XRBinding.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.XRBinding.FormatString": "Format String",
  "DevExpress.XtraReports.UI.XRBinding.PropertyName": "Property Name",
  "DevExpress.XtraReports.UI.XRCharacterComb.CellHeight": "Cell Height",
  "DevExpress.XtraReports.UI.XRCharacterComb.CellHorizontalSpacing": "Cell Horizontal Spacing",
  "DevExpress.XtraReports.UI.XRCharacterComb.CellVerticalSpacing": "Cell Vertical Spacing",
  "DevExpress.XtraReports.UI.XRCharacterComb.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRChart": "Chart",
  "DevExpress.XtraReports.UI.XRChart.AnnotationRepository": "Annotation Repository",
  "DevExpress.XtraReports.UI.XRChart.Annotations": "Annotations",
  "DevExpress.XtraReports.UI.XRChart.AppearanceName": "Appearance Name",
  "DevExpress.XtraReports.UI.XRChart.BackColor": "Background Color",
  "DevExpress.XtraReports.UI.XRChart.BackImage": "Background Image",
  "DevExpress.XtraReports.UI.XRChart.DataAdapter": "Data Adapter",
  "DevExpress.XtraReports.UI.XRChart.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.XRChart.DataSource": "Data Source",
  "DevExpress.XtraReports.UI.XRChart.Diagram": "Diagram",
  "DevExpress.XtraReports.UI.XRChart.EmptyChartText": "Empty Chart Text",
  "DevExpress.XtraReports.UI.XRChart.FillStyle": "Fill Style",
  "DevExpress.XtraReports.UI.XRChart.ImageType": "Image Type",
  "DevExpress.XtraReports.UI.XRChart.IndicatorsPaletteName": "Indicators Palette Name",
  "DevExpress.XtraReports.UI.XRChart.Legend": "Legend",
  "DevExpress.XtraReports.UI.XRChart.Legends": "Legends",
  "DevExpress.XtraReports.UI.XRChart.Padding": "Padding",
  "DevExpress.XtraReports.UI.XRChart.PaletteBaseColorNumber": "Palette's Base Color Number",
  "DevExpress.XtraReports.UI.XRChart.PaletteName": "Palette Name",
  "DevExpress.XtraReports.UI.XRChart.Parameters": "Parameters",
  "DevExpress.XtraReports.UI.XRChart.PivotGridDataSourceOptions": "Pivot Grid Data Source Options",
  "DevExpress.XtraReports.UI.XRChart.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRChart.Series": "Series",
  "DevExpress.XtraReports.UI.XRChart.SeriesDataMember": "Series Data Member",
  "DevExpress.XtraReports.UI.XRChart.SeriesNameTemplate": "Series Name Template",
  "DevExpress.XtraReports.UI.XRChart.SeriesSorting": "Series Sorting",
  "DevExpress.XtraReports.UI.XRChart.SeriesTemplate": "Series Template",
  "DevExpress.XtraReports.UI.XRChart.SmallChartText": "Small Chart Text",
  "DevExpress.XtraReports.UI.XRChart.Titles": "Titles",
  "DevExpress.XtraReports.UI.XRChartScripts": "Chart Scripts",
  "DevExpress.XtraReports.UI.XRChartScripts.OnAxisScaleChanged": "Axis Scale Changed",
  "DevExpress.XtraReports.UI.XRChartScripts.OnAxisVisualRangeChanged": "Axis Visual Range Changed",
  "DevExpress.XtraReports.UI.XRChartScripts.OnAxisWholeRangeChanged": "Axis Whole Range Changed",
  "DevExpress.XtraReports.UI.XRChartScripts.OnBoundDataChanged": "Bound Data Changed",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawAxisLabel": "Custom Draw an Axis Label",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawCrosshair": "Custom Draw Crosshair",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawSeries": "Custom Draw a Series",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawSeriesPoint": "Custom Draw a Series Point",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomPaint": "Custom Paint",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomizeStackedBarTotalLabel": "Customize a Stacked Bar Total Label",
  "DevExpress.XtraReports.UI.XRChartScripts.OnPieSeriesPointExploded": "Pie Series Point Exploded",
  "DevExpress.XtraReports.UI.XRChartScripts.OnSmallChartTextShowing": "Small Chart Text Showing",
  "DevExpress.XtraReports.UI.XRCheckBox": "Check Box",
  "DevExpress.XtraReports.UI.XRCheckBox.Checked": "Checked",
  "DevExpress.XtraReports.UI.XRColumnSortOrder.Ascending": "Ascending",
  "DevExpress.XtraReports.UI.XRColumnSortOrder.Descending": "Descending",
  "DevExpress.XtraReports.UI.XRColumnSortOrder.None": "None",
  "DevExpress.XtraReports.UI.XRControl.AnchorVertical": "Anchor Vertically",
  "DevExpress.XtraReports.UI.XRControl.BackColor": "Background Color",
  "DevExpress.XtraReports.UI.XRControl.Bookmark": "Bookmark",
  "DevExpress.XtraReports.UI.XRControl.BookmarkParent": "Parent Bookmark",
  "DevExpress.XtraReports.UI.XRControl.BorderColor": "Border Color",
  "DevExpress.XtraReports.UI.XRControl.BorderDashStyle": "Border Dash Style",
  "DevExpress.XtraReports.UI.XRControl.BorderWidth": "Border Width",
  "DevExpress.XtraReports.UI.XRControl.Borders": "Borders",
  "DevExpress.XtraReports.UI.XRControl.CanGrow": "Can Grow",
  "DevExpress.XtraReports.UI.XRControl.CanShrink": "Can Shrink",
  "DevExpress.XtraReports.UI.XRControl.DataBindings": "Data Bindings",
  "DevExpress.XtraReports.UI.XRControl.Font": "Font",
  "DevExpress.XtraReports.UI.XRControl.ForeColor": "Foreground Color",
  "DevExpress.XtraReports.UI.XRControl.FormattingRules": "Formatting Rules",
  "DevExpress.XtraReports.UI.XRControl.Height": "Height",
  "DevExpress.XtraReports.UI.XRControl.KeepTogether": "Keep Together",
  "DevExpress.XtraReports.UI.XRControl.Left": "Left",
  "DevExpress.XtraReports.UI.XRControl.Location": "Location",
  "DevExpress.XtraReports.UI.XRControl.LockedInUserDesigner": "Locked in the End-User Designer",
  "DevExpress.XtraReports.UI.XRControl.Name": "Name",
  "DevExpress.XtraReports.UI.XRControl.NavigateUrl": "Navigation URL",
  "DevExpress.XtraReports.UI.XRControl.NullValueText": "Null Value Text",
  "DevExpress.XtraReports.UI.XRControl.Padding": "Padding",
  "DevExpress.XtraReports.UI.XRControl.ParentStyleUsing": "Using Parent Style",
  "DevExpress.XtraReports.UI.XRControl.RightToLeft": "Right to Left",
  "DevExpress.XtraReports.UI.XRControl.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRControl.Size": "Size",
  "DevExpress.XtraReports.UI.XRControl.SnapLineMargin": "Snap Line Margin",
  "DevExpress.XtraReports.UI.XRControl.SnapLinePadding": "Snap Line Padding",
  "DevExpress.XtraReports.UI.XRControl.StylePriority": "Style Priority",
  "DevExpress.XtraReports.UI.XRControl.Styles": "Styles",
  "DevExpress.XtraReports.UI.XRControl.Tag": "Tag",
  "DevExpress.XtraReports.UI.XRControl.Target": "Navigation Target",
  "DevExpress.XtraReports.UI.XRControl.Text": "Text",
  "DevExpress.XtraReports.UI.XRControl.TextAlignment": "Text Alignment",
  "DevExpress.XtraReports.UI.XRControl.Top": "Top",
  "DevExpress.XtraReports.UI.XRControl.Visible": "Visible",
  "DevExpress.XtraReports.UI.XRControl.Width": "Width",
  "DevExpress.XtraReports.UI.XRControl.WordWrap": "Word Wrap",
  "DevExpress.XtraReports.UI.XRControl.XRControlStyles.EvenStyle": "Even Style",
  "DevExpress.XtraReports.UI.XRControl.XRControlStyles.OddStyle": "Odd Style",
  "DevExpress.XtraReports.UI.XRControl.XRControlStyles.Style": "Style",
  "DevExpress.XtraReports.UI.XRControl.XlsxFormatString": "Xlsx Format String",
  "DevExpress.XtraReports.UI.XRControlEvents.OnAfterPrint": "After Print",
  "DevExpress.XtraReports.UI.XRControlEvents.OnBeforePrint": "Before Print",
  "DevExpress.XtraReports.UI.XRControlEvents.OnDraw": "Draw",
  "DevExpress.XtraReports.UI.XRControlEvents.OnEvaluateBinding": "Evaluate Binding",
  "DevExpress.XtraReports.UI.XRControlEvents.OnHtmlItemCreated": "HTML Item Created",
  "DevExpress.XtraReports.UI.XRControlEvents.OnLocationChanged": "Location Changed",
  "DevExpress.XtraReports.UI.XRControlEvents.OnParentChanged": "Parent Changed",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewClick": "Click in Preview",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewDoubleClick": "Double-Click in Preview",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewMouseDown": "Mouse Down in Preview",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewMouseMove": "Mouse Move in Preview",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewMouseUp": "Mouse Up in Preview",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPrintOnPage": "Print on Page",
  "DevExpress.XtraReports.UI.XRControlEvents.OnSizeChanged": "Size Changed",
  "DevExpress.XtraReports.UI.XRControlEvents.OnTextChanged": "Text Changed",
  "DevExpress.XtraReports.UI.XRControlParameter.Name": "Name",
  "DevExpress.XtraReports.UI.XRControlScripts": "Control Scripts",
  "DevExpress.XtraReports.UI.XRControlStyle": "Control Style",
  "DevExpress.XtraReports.UI.XRControlStyle.BackColor": "Background Color",
  "DevExpress.XtraReports.UI.XRControlStyle.BorderColor": "Border Color",
  "DevExpress.XtraReports.UI.XRControlStyle.BorderDashStyle": "Border Dash Style",
  "DevExpress.XtraReports.UI.XRControlStyle.BorderWidth": "Border Width",
  "DevExpress.XtraReports.UI.XRControlStyle.Borders": "Borders",
  "DevExpress.XtraReports.UI.XRControlStyle.Font": "Font",
  "DevExpress.XtraReports.UI.XRControlStyle.ForeColor": "Foreground Color",
  "DevExpress.XtraReports.UI.XRControlStyle.Padding": "Padding",
  "DevExpress.XtraReports.UI.XRControlStyle.StyleUsing": "Using Style",
  "DevExpress.XtraReports.UI.XRControlStyle.TextAlignment": "Text Alignment",
  "DevExpress.XtraReports.UI.XRCrossBandBox": "Cross-band Box",
  "DevExpress.XtraReports.UI.XRCrossBandControl.EndBand": "End Band",
  "DevExpress.XtraReports.UI.XRCrossBandControl.EndPoint": "End Point",
  "DevExpress.XtraReports.UI.XRCrossBandControl.StartBand": "Start Band",
  "DevExpress.XtraReports.UI.XRCrossBandControl.StartPoint": "Start Point",
  "DevExpress.XtraReports.UI.XRCrossBandLine": "Cross-band Line",
  "DevExpress.XtraReports.UI.XRCrossBandLine.LineStyle": "Line Style",
  "DevExpress.XtraReports.UI.XRCrossTab.CrossTabStyles": "Styles",
  "DevExpress.XtraReports.UI.XRCrossTab.DataAdapter": "Data Adapter",
  "DevExpress.XtraReports.UI.XRCrossTab.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.XRCrossTab.DataSource": "Data Source",
  "DevExpress.XtraReports.UI.XRCrossTab.Parameters": "Parameters",
  "DevExpress.XtraReports.UI.XRCrossTab.PrintOptions": "Print Options",
  "DevExpress.XtraReports.UI.XRDockStyle.Bottom": "Bottom",
  "DevExpress.XtraReports.UI.XRDockStyle.Fill": "Fill",
  "DevExpress.XtraReports.UI.XRDockStyle.None": "None",
  "DevExpress.XtraReports.UI.XRDockStyle.Top": "Top",
  "DevExpress.XtraReports.UI.XRGauge": "Gauge",
  "DevExpress.XtraReports.UI.XRGauge.ActualValue": "Actual Value",
  "DevExpress.XtraReports.UI.XRGauge.ImageType": "Image Type",
  "DevExpress.XtraReports.UI.XRGauge.Maximum": "Maximum",
  "DevExpress.XtraReports.UI.XRGauge.Minimum": "Minimum",
  "DevExpress.XtraReports.UI.XRGauge.TargetValue": "Target Value",
  "DevExpress.XtraReports.UI.XRGauge.ViewStyle": "View Style",
  "DevExpress.XtraReports.UI.XRGauge.ViewType": "View Type",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary": "Group Sorting Summary",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.Enabled": "Enabled",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.FieldName": "Field Name",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.Function": "Function",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.IgnoreNullValues": "Ignore Null Values",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.SortOrder": "Sort Order",
  "DevExpress.XtraReports.UI.XRLabel": "Label",
  "DevExpress.XtraReports.UI.XRLabel.Angle": "Angle",
  "DevExpress.XtraReports.UI.XRLabel.AutoWidth": "Auto Width",
  "DevExpress.XtraReports.UI.XRLabel.KeepTogether": "Keep Together",
  "DevExpress.XtraReports.UI.XRLabel.Lines": "Lines",
  "DevExpress.XtraReports.UI.XRLabel.Multiline": "Multiline",
  "DevExpress.XtraReports.UI.XRLabel.ProcessDuplicates": "Process Duplicates",
  "DevExpress.XtraReports.UI.XRLabel.ProcessNullValues": "Process Null Values",
  "DevExpress.XtraReports.UI.XRLabel.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRLabel.Summary": "Summary",
  "DevExpress.XtraReports.UI.XRLabel.TextFitMode": "Text Fit Mode",
  "DevExpress.XtraReports.UI.XRLabelScripts": "Label Scripts",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryCalculated": "Summary Calculated",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryGetResult": "Summary Get Result",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryReset": "Summary Reset",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryRowChanged": "Summary Row Changed",
  "DevExpress.XtraReports.UI.XRLine": "Line",
  "DevExpress.XtraReports.UI.XRLine.LineDirection": "Line Direction",
  "DevExpress.XtraReports.UI.XRLine.LineStyle": "Line Style",
  "DevExpress.XtraReports.UI.XRLine.LineWidth": "Line Width",
  "DevExpress.XtraReports.UI.XRLine.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRLineScripts": "Line Scripts",
  "DevExpress.XtraReports.UI.XRPageBreak": "Page Break",
  "DevExpress.XtraReports.UI.XRPageBreak.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRPageBreakScripts.OnEvaluateBinding": "Evaluate Binding",
  "DevExpress.XtraReports.UI.XRPageInfo": "Page Info",
  "DevExpress.XtraReports.UI.XRPageInfo.Format": "Format",
  "DevExpress.XtraReports.UI.XRPageInfo.PageInfo": "Page Information",
  "DevExpress.XtraReports.UI.XRPageInfo.RunningBand": "Running Band",
  "DevExpress.XtraReports.UI.XRPageInfo.StartPageNumber": "Start Page Number",
  "DevExpress.XtraReports.UI.XRPanel": "Panel",
  "DevExpress.XtraReports.UI.XRPdfContent.PageRange": "Page Range",
  "DevExpress.XtraReports.UI.XRPdfSignature.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRPictureBox": "Picture Box",
  "DevExpress.XtraReports.UI.XRPictureBox.Image": "Image",
  "DevExpress.XtraReports.UI.XRPictureBox.ImageUrl": "Image URL",
  "DevExpress.XtraReports.UI.XRPictureBox.Sizing": "Sizing",
  "DevExpress.XtraReports.UI.XRPivotGrid": "Pivot Grid",
  "DevExpress.XtraReports.UI.XRPivotGrid.Appearance": "Appearance",
  "DevExpress.XtraReports.UI.XRPivotGrid.DataAdapter": "Data Adapter",
  "DevExpress.XtraReports.UI.XRPivotGrid.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.XRPivotGrid.DataSource": "Data Source",
  "DevExpress.XtraReports.UI.XRPivotGrid.Fields": "Fields",
  "DevExpress.XtraReports.UI.XRPivotGrid.OLAPConnectionString": "OLAP Connection String",
  "DevExpress.XtraReports.UI.XRPivotGrid.OLAPDataProvider": "OLAP Data Provider",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsChartDataSource": "Options Chart Data Source",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsData": "Data Options",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsDataField": "Data Field Options",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsPrint": "Print Options",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsView": "View Options",
  "DevExpress.XtraReports.UI.XRPivotGrid.Prefilter": "Prefilter",
  "DevExpress.XtraReports.UI.XRPivotGrid.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XRPivotGrid.Styles": "Styles",
  "DevExpress.XtraReports.UI.XRPivotGridScripts": "PivotGrid Scripts",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomCellDisplayText": "Custom Cell Display Text",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomCellValue": "Custom Cell Value",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomColumnWidth": "Custom Column Width",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomFieldSort": "Custom Field Sort",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomFieldValueCells": "Custom Field Value Cells",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomGroupInterval": "Custom Group Interval",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomRowHeight": "Custom Row Height",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomSummary": "Custom Summary",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomUnboundFieldData": "Custom Unbound Field Data",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnFieldValueDisplayText": "Field Value Display Text",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrefilterCriteriaChanged": "Prefilter Criteria Changed",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrintCell": "Print Cell",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrintFieldValue": "Print Field Value",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrintHeader": "Print Header",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnSizeChanged": "Size Changed",
  "DevExpress.XtraReports.UI.XRRichText": "Rich Text",
  "DevExpress.XtraReports.UI.XRRichText.Lines": "Lines",
  "DevExpress.XtraReports.UI.XRRichTextBase.RtfText": "Rich Text",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.BackColor": "Background Color",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.DetectUrls": "Detect URLs",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.Font": "Font",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.Lines": "Lines",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.Multiline": "Multiline",
  "DevExpress.XtraReports.UI.XRShape": "Shape",
  "DevExpress.XtraReports.UI.XRShape.Angle": "Angle",
  "DevExpress.XtraReports.UI.XRShape.FillColor": "Fill Color",
  "DevExpress.XtraReports.UI.XRShape.LineStyle": "Line Style",
  "DevExpress.XtraReports.UI.XRShape.LineWidth": "Line Width",
  "DevExpress.XtraReports.UI.XRShape.Shape": "Shape",
  "DevExpress.XtraReports.UI.XRShape.Stretch": "Stretch",
  "DevExpress.XtraReports.UI.XRSparkline": "Sparkline",
  "DevExpress.XtraReports.UI.XRSparkline.DataAdapter": "Data Adapter",
  "DevExpress.XtraReports.UI.XRSparkline.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.XRSparkline.DataSource": "Data Source",
  "DevExpress.XtraReports.UI.XRSparkline.ImageType": "Image Type",
  "DevExpress.XtraReports.UI.XRSparkline.ValueMember": "Value Member",
  "DevExpress.XtraReports.UI.XRSparkline.View": "View",
  "DevExpress.XtraReports.UI.XRSubreport": "Sub-Report",
  "DevExpress.XtraReports.UI.XRSubreport.ReportSourceUrl": "Report Source URL",
  "DevExpress.XtraReports.UI.XRSummary.FormatString": "Format String",
  "DevExpress.XtraReports.UI.XRSummary.Func": "Function",
  "DevExpress.XtraReports.UI.XRSummary.IgnoreNullValues": "Ignore Null Values",
  "DevExpress.XtraReports.UI.XRSummary.Running": "Running",
  "DevExpress.XtraReports.UI.XRSummaryEvents.OnGetResult": "Get a Result",
  "DevExpress.XtraReports.UI.XRSummaryEvents.OnReset": "Reset",
  "DevExpress.XtraReports.UI.XRSummaryEvents.OnRowChanged": "Row Changed",
  "DevExpress.XtraReports.UI.XRTable": "Table",
  "DevExpress.XtraReports.UI.XRTableCell": "Table Cell",
  "DevExpress.XtraReports.UI.XRTableCell.RowSpan": "Row Span",
  "DevExpress.XtraReports.UI.XRTableOfContents": "Table of Contents",
  "DevExpress.XtraReports.UI.XRTableOfContents.LevelDefault": "Level Default",
  "DevExpress.XtraReports.UI.XRTableOfContents.LevelTitle": "Level Title",
  "DevExpress.XtraReports.UI.XRTableOfContents.MaxNestingLevel": "Max Nesting Level",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevel": "Table of Contents Level",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevel.Indent": "Indent",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevel.LeaderSymbol": "Leader Symbol",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.BackColor": "Back Color",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.Font": "Font",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.ForeColor": "Fore Color",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.Height": "Height",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.Padding": "Padding",
  "DevExpress.XtraReports.UI.XRTableOfContentsTitle": "Table of Contents Title",
  "DevExpress.XtraReports.UI.XRTableOfContentsTitle.Text": "Text",
  "DevExpress.XtraReports.UI.XRTableOfContentsTitle.TextAlignment": "Text Alignment",
  "DevExpress.XtraReports.UI.XRTableRow": "Table Row",
  "DevExpress.XtraReports.UI.XRZipCode": "Zip Code",
  "DevExpress.XtraReports.UI.XRZipCode.SegmentWidth": "Segment Width",
  "DevExpress.XtraReports.UI.XtraReport": "Report",
  "DevExpress.XtraReports.UI.XtraReport.Bookmark": "Bookmark",
  "DevExpress.XtraReports.UI.XtraReport.CalculatedFields": "Calculated Fields",
  "DevExpress.XtraReports.UI.XtraReport.DataSourceSchema": "Data Source's Schema",
  "DevExpress.XtraReports.UI.XtraReport.DefaultPrinterSettingsUsing": "Using Settings of the Default Printer",
  "DevExpress.XtraReports.UI.XtraReport.DesignerOptions": "Designer Options",
  "DevExpress.XtraReports.UI.XtraReport.DisplayName": "Display Name",
  "DevExpress.XtraReports.UI.XtraReport.DrawGrid": "Draw the Grid",
  "DevExpress.XtraReports.UI.XtraReport.DrawWatermark": "Draw the Watermark",
  "DevExpress.XtraReports.UI.XtraReport.ExportOptions": "Export Options",
  "DevExpress.XtraReports.UI.XtraReport.FormattingRuleSheet": "Formatting Rule Sheet",
  "DevExpress.XtraReports.UI.XtraReport.Landscape": "Landscape",
  "DevExpress.XtraReports.UI.XtraReport.Margins": "Margins",
  "DevExpress.XtraReports.UI.XtraReport.PageColor": "Page Color",
  "DevExpress.XtraReports.UI.XtraReport.PageHeight": "Page Height",
  "DevExpress.XtraReports.UI.XtraReport.PageWidth": "Page Width",
  "DevExpress.XtraReports.UI.XtraReport.PaperKind": "Paper Kind",
  "DevExpress.XtraReports.UI.XtraReport.PaperName": "Paper Name",
  "DevExpress.XtraReports.UI.XtraReport.Parameters": "Parameters",
  "DevExpress.XtraReports.UI.XtraReport.PreviewRowCount": "Row Count for Preview",
  "DevExpress.XtraReports.UI.XtraReport.PrinterName": "Printer Name",
  "DevExpress.XtraReports.UI.XtraReport.ReportPrintOptions": "Report Print Options",
  "DevExpress.XtraReports.UI.XtraReport.ReportUnit": "Measure Units",
  "DevExpress.XtraReports.UI.XtraReport.RequestParameters": "Request Parameters",
  "DevExpress.XtraReports.UI.XtraReport.RightToLeftLayout": "Right to Left Layout",
  "DevExpress.XtraReports.UI.XtraReport.ScriptLanguage": "Script Language",
  "DevExpress.XtraReports.UI.XtraReport.ScriptReferences": "Script References",
  "DevExpress.XtraReports.UI.XtraReport.ScriptSecurityPermissions": "Script Security Permissions",
  "DevExpress.XtraReports.UI.XtraReport.Scripts": "Scripts",
  "DevExpress.XtraReports.UI.XtraReport.ShowDesignerHints": "Show Designer's Hints",
  "DevExpress.XtraReports.UI.XtraReport.ShowExportWarnings": "Show Export Warnings",
  "DevExpress.XtraReports.UI.XtraReport.ShowPreviewMarginLines": "Show Margin Lines in Preview",
  "DevExpress.XtraReports.UI.XtraReport.ShowPrintMarginsWarning": "Show Print Margins Warning",
  "DevExpress.XtraReports.UI.XtraReport.ShowPrintStatusDialog": "Show Print Status Dialog",
  "DevExpress.XtraReports.UI.XtraReport.ShowPrintingWarnings": "Show Printing Warnings",
  "DevExpress.XtraReports.UI.XtraReport.SnapGridSize": "Snap Grid Size",
  "DevExpress.XtraReports.UI.XtraReport.SnappingMode": "Snapping Mode",
  "DevExpress.XtraReports.UI.XtraReport.StyleSheet": "Style Sheet",
  "DevExpress.XtraReports.UI.XtraReport.StyleSheetPath": "Style Sheet's Path",
  "DevExpress.XtraReports.UI.XtraReport.VerticalContentSplitting": "Vertical Content Splitting",
  "DevExpress.XtraReports.UI.XtraReport.Watermark": "Watermark",
  "DevExpress.XtraReports.UI.XtraReport.XRLanguage": "Language",
  "DevExpress.XtraReports.UI.XtraReportBase.Bands": "Bands",
  "DevExpress.XtraReports.UI.XtraReportBase.DataAdapter": "Data Adapter",
  "DevExpress.XtraReports.UI.XtraReportBase.DataMember": "Data Member",
  "DevExpress.XtraReports.UI.XtraReportBase.DataSource": "Data Source",
  "DevExpress.XtraReports.UI.XtraReportBase.FilterString": "Filter String",
  "DevExpress.XtraReports.UI.XtraReportBase.SortFields": "Sort Fields",
  "DevExpress.XtraReports.UI.XtraReportBase.XmlDataPath": "XML Data Path",
  "DevExpress.XtraReports.UI.XtraReportScripts": "Report Scripts",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnBandHeightChanged": "Band's Height Changed",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnDataSourceDemanded": "Data Source Demanded",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnDataSourceRowChanged": "Data Source's Row Changed",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnFillEmptySpace": "Fill Empty Space",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnParametersRequestBeforeShow": "Parameters Request Before Show",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnParametersRequestSubmit": "Parameters Submitted",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnParametersRequestValueChanged": "Parameters Changed",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnPrintProgress": "Print Progress",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.Comments": "Comments",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.Note": "Note",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.UnitVAT": "Unit VAT",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.VendorContactName": "Vendor Contact Name",
  "GaugesPresetsStringId.ShapeFull": "Full",
  "GaugesPresetsStringId.ShapeHalf": "Half",
  "GaugesPresetsStringId.ShapeHorizontal": "Horizontal",
  "GaugesPresetsStringId.ShapeQuarterLeft": "QuarterLeft",
  "GaugesPresetsStringId.ShapeQuarterRight": "QuarterRight",
  "GaugesPresetsStringId.ShapeThreeFourth": "ThreeFourth",
  "GaugesPresetsStringId.ShapeVertical": "Vertical",
  "GaugesPresetsStringId.ShapeWide": "Wide",
  "GaugesPresetsStringId.StyleChooserFilterShape": "Shape",
  "GaugesPresetsStringId.StyleChooserFilterTheme": "Theme",
  "GaugesPresetsStringId.ThemeAfricaSunset": "Africa Sunset",
  "GaugesPresetsStringId.ThemeClassic": "Classic",
  "GaugesPresetsStringId.ThemeCleanWhite": "Clean White",
  "GaugesPresetsStringId.ThemeClever": "Clever",
  "GaugesPresetsStringId.ThemeCosmic": "Cosmic",
  "GaugesPresetsStringId.ThemeDarkNight": "Dark Night",
  "GaugesPresetsStringId.ThemeDeepFire": "Deep Fire",
  "GaugesPresetsStringId.ThemeDefault": "Default",
  "GaugesPresetsStringId.ThemeDisco": "Disco",
  "GaugesPresetsStringId.ThemeEco": "Eco",
  "GaugesPresetsStringId.ThemeFlatDark": "Flat Dark",
  "GaugesPresetsStringId.ThemeFlatLight": "Flat Light",
  "GaugesPresetsStringId.ThemeFuture": "Future",
  "GaugesPresetsStringId.ThemeGothicMat": "Gothic Mat",
  "GaugesPresetsStringId.ThemeIceColdZone": "Ice-Cold Zone",
  "GaugesPresetsStringId.ThemeMagicLight": "Magic Light",
  "GaugesPresetsStringId.ThemeMechanical": "Mechanical",
  "GaugesPresetsStringId.ThemeMilitary": "Military",
  "GaugesPresetsStringId.ThemeProgressive": "Progressive",
  "GaugesPresetsStringId.ThemePureDark": "Pure Dark",
  "GaugesPresetsStringId.ThemeRed": "Red",
  "GaugesPresetsStringId.ThemeRetro": "Retro",
  "GaugesPresetsStringId.ThemeShiningDark": "Shining Dark",
  "GaugesPresetsStringId.ThemeSilverBlur": "Silver Blur",
  "GaugesPresetsStringId.ThemeSmart": "Smart",
  "GaugesPresetsStringId.ThemeSportCar": "Sport Car",
  "GaugesPresetsStringId.ThemeWhite": "White",
  "GaugesPresetsStringId.ThemeYellowSubmarine": "Yellow Submarine",
  "GaugesPresetsStringId.ThemeiStyle": "iStyle",
  "ReportStringId.BCForm_Lbl_Binding": "Binding",
  "ReportStringId.BCForm_Lbl_Property": "Property",
  "ReportStringId.BandCollectionEditor_UnboundDetailReport": "Unbound",
  "ReportStringId.BandDsg_QuantityPerPage": "one band per page",
  "ReportStringId.BandDsg_QuantityPerReport": "one band per report",
  "ReportStringId.BindingMapperForm_InvalidBindingWarning": "Invalid binding",
  "ReportStringId.BindingMapperForm_ShowOnlyInvalidBindings": "Show only invalid bindings",
  "ReportStringId.CatAppearance": "Appearance",
  "ReportStringId.CatBehavior": "Behavior",
  "ReportStringId.CatData": "Data",
  "ReportStringId.CatDesign": "Design",
  "ReportStringId.CatElements": "Elements",
  "ReportStringId.CatLayout": "Layout",
  "ReportStringId.CatNavigation": "Navigation",
  "ReportStringId.CatOptions": "Options",
  "ReportStringId.CatPageSettings": "Page Settings",
  "ReportStringId.CatParameters": "Parameters",
  "ReportStringId.CatPrinting": "Printing",
  "ReportStringId.CatReportData": "Report Data",
  "ReportStringId.CatStructure": "Structure",
  "ReportStringId.CatUserDesigner": "User Designer",
  "ReportStringId.Cmd_AlignToGrid": "Align to &Grid",
  "ReportStringId.Cmd_AssignEvenStyleToXRControl": "Assign Even Style to the Control",
  "ReportStringId.Cmd_AssignOddStyleToXRControl": "Assign Odd Style to the Control",
  "ReportStringId.Cmd_AssignStyleToXRControl": "Assign Style to the Control",
  "ReportStringId.Cmd_BandExpandAll": "Expand All Bands",
  "ReportStringId.Cmd_BandMoveDown": "Move Down",
  "ReportStringId.Cmd_BandMoveUp": "Move Up",
  "ReportStringId.Cmd_BottomMargin": "BottomMargin",
  "ReportStringId.Cmd_BringToFront": "&Bring to Front",
  "ReportStringId.Cmd_CloneStyle": "Clone Style",
  "ReportStringId.Cmd_Commands": "Commands",
  "ReportStringId.Cmd_Copy": "Cop&y",
  "ReportStringId.Cmd_CopyGalleryItem": "Copy",
  "ReportStringId.Cmd_Cut": "Cu&t",
  "ReportStringId.Cmd_CutGalleryItem": "Cut",
  "ReportStringId.Cmd_Delete": "&Delete",
  "ReportStringId.Cmd_DeleteFormattingRule": "Delete",
  "ReportStringId.Cmd_DeleteGalleryItem": "Delete",
  "ReportStringId.Cmd_DeleteStyle": "Delete",
  "ReportStringId.Cmd_Detail": "Detail",
  "ReportStringId.Cmd_DetailReport": "DetailReport",
  "ReportStringId.Cmd_EditStyles": "Edit Styles...",
  "ReportStringId.Cmd_GroupFooter": "GroupFooter",
  "ReportStringId.Cmd_GroupHeader": "GroupHeader",
  "ReportStringId.Cmd_InsertBand": "Insert &Band",
  "ReportStringId.Cmd_InsertDetailReport": "Insert Detail Report",
  "ReportStringId.Cmd_InsertUnboundDetailReport": "Unbound",
  "ReportStringId.Cmd_NavigateToControl": "Navigate to Control",
  "ReportStringId.Cmd_PageFooter": "PageFooter",
  "ReportStringId.Cmd_PageHeader": "PageHeader",
  "ReportStringId.Cmd_Paste": "&Paste",
  "ReportStringId.Cmd_PasteGalleryItem": "Paste",
  "ReportStringId.Cmd_Properties": "P&roperties",
  "ReportStringId.Cmd_PurgeStyles": "Delete Unused Styles",
  "ReportStringId.Cmd_RefreshGallery": "Refresh",
  "ReportStringId.Cmd_RenameGalleryItem": "Rename",
  "ReportStringId.Cmd_ReportFooter": "ReportFooter",
  "ReportStringId.Cmd_ReportHeader": "ReportHeader",
  "ReportStringId.Cmd_RtfClear": "Clear",
  "ReportStringId.Cmd_RtfLoad": "Load File...",
  "ReportStringId.Cmd_SendToBack": "&Send to Back",
  "ReportStringId.Cmd_TableConvertToLabels": "&Convert to Labels",
  "ReportStringId.Cmd_TableDelete": "De&lete",
  "ReportStringId.Cmd_TableDeleteCell": "Ce&ll",
  "ReportStringId.Cmd_TableDeleteColumn": "&Column",
  "ReportStringId.Cmd_TableDeleteRow": "&Row",
  "ReportStringId.Cmd_TableInsert": "&Insert",
  "ReportStringId.Cmd_TableInsertCell": "&Cell",
  "ReportStringId.Cmd_TableInsertColumnToLeft": "Column to &Left",
  "ReportStringId.Cmd_TableInsertColumnToRight": "Column to &Right",
  "ReportStringId.Cmd_TableInsertRowAbove": "Row &Above",
  "ReportStringId.Cmd_TableInsertRowBelow": "Row &Below",
  "ReportStringId.Cmd_TopMargin": "TopMargin",
  "ReportStringId.Cmd_ViewCode": "View &Code",
  "ReportStringId.CrossTab_ColumnAreaName": "Columns",
  "ReportStringId.CrossTab_DataAreaName": "Data",
  "ReportStringId.CrossTab_DropFieldFromAnotherDataMember_ToolTip": "Cross Tab cells can only be bound to fields from the assigned data member.",
  "ReportStringId.CrossTab_DropFieldFromAnotherDataSource_ToolTip": "Cross Tab cells can only be bound to fields from the assigned data source.",
  "ReportStringId.CrossTab_DropOntoReservedCell_ToolTip": "This Cross Tab cell is reserved.",
  "ReportStringId.CrossTab_DropReportParameter_ToolTip": "Cross Tab cells cannot be bound to report parameters.",
  "ReportStringId.CrossTab_RowAreaName": "Rows",
  "ReportStringId.DesignerStatus_Height": "Height",
  "ReportStringId.DesignerStatus_Location": "Location",
  "ReportStringId.DesignerStatus_Size": "Size",
  "ReportStringId.DesignerStatus_Width": "Width",
  "ReportStringId.Dlg_SaveFile_Title": "Save '{0}'",
  "ReportStringId.ExpressionEditor_ConditionCaption": "Condition Editor",
  "ReportStringId.ExpressionEditor_Description_Arguments_PageCount": "Returns page count in the report document.",
  "ReportStringId.ExpressionEditor_Description_FieldsPrefix": "Field type is: ",
  "ReportStringId.ExpressionEditor_Description_Function_Argb": "Argb(Alpha, Red, Green, Blue)\n\nReturns a string defining a color using the Alpha, Red, Green, and Blue color channel values.",
  "ReportStringId.ExpressionEditor_Description_Function_Rgb": "Rgb(Red, Green, Blue)\n\nReturns a string defining a color using the Red, Green, and Blue color channel values.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryPercentage": "sumPercentage(Expression)\n\nCalculates the percent ratio of the current data row's value to the total of all values within the specified summary region (group, page or report).",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryRecordNumber": "sumRecordNumber(Expression)\n\nReturns the current record number in the data source within the specified summary region (group, page or report). For instance, if the summary is calculated for a group, then the record number is calculated only within that group, and is reset each time a new group is started.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryRunningSum": "sumRunningSum(Expression)\n\nSummarizes all values printed before the current data row with the current data row's value.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryStdDev": "sumStdDev(Expression)\n\nCalculates the standard deviation of all values within the specified summary region (group, page or report).",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryWAvg": "sumWAvg(Expression, Expression)\n\nCalculates the weighted average of all values within the specified summary region (group, page or report).\nThis summary type returns the result of the following operation: Sum(Expression1 * Expression2) / Sum(Expression2).",
  "ReportStringId.ExpressionEditor_FieldDescription": "Description:",
  "ReportStringId.ExpressionEditor_ItemInfo_Fields": "Fields",
  "ReportStringId.ExpressionEditor_ItemInfo_FunctionSummary": "Summary",
  "ReportStringId.ExpressionEditor_ItemInfo_Values": "Values",
  "ReportStringId.ExpressionEditor_ItemInfo_Variables": "Variables",
  "ReportStringId.ExpressionEditor_ItemInfo_Variables_CurrentRowIndex_Description": "Returns a zero-based index of the current data row in a data source.",
  "ReportStringId.ExpressionEditor_ItemInfo_Variables_RowCount_Description": "Returns the total number of data rows in a data source.",
  "ReportStringId.FRSForm_Msg_MoreThanOneRule": "You selected more than one formatting rule",
  "ReportStringId.FRSForm_Msg_NoRuleSelected": "No formatting rules are selected",
  "ReportStringId.Gallery_Msg_ImportError": "Cannot import gallery items from the specified file",
  "ReportStringId.Gallery_Msg_ImportFromFile": "All gallery items will be overwritten. Do you wish to continue?",
  "ReportStringId.GroupSort_AddGroup": "Add a Group",
  "ReportStringId.GroupSort_AddSort": "Add a Sort",
  "ReportStringId.GroupSort_Delete": "Delete",
  "ReportStringId.GroupSort_MoveDown": "Move Down",
  "ReportStringId.GroupSort_MoveUp": "Move Up",
  "ReportStringId.Msg_Caption": "XtraReports",
  "ReportStringId.Msg_CreateReportInstance": "The currently edited report is a different type than the one you are trying to open.\nDo you want to open the selected report anyway?",
  "ReportStringId.Msg_CreateSomeInstance": "Can't create two instances of a class on a form.",
  "ReportStringId.Msg_CyclicBookmarks": "The report contains cyclic bookmarks.",
  "ReportStringId.Msg_DontSupportMulticolumn": "Detail reports don't support multicolumns.",
  "ReportStringId.Msg_DuplicatedNameUsage": "The report contains an element with this name. Specify a different name.",
  "ReportStringId.Msg_ErrorTitle": "Error",
  "ReportStringId.Msg_FileContentCorrupted": "Can't load the report's layout. The file may be corrupted or contains incorrect information.",
  "ReportStringId.Msg_FileCorrupted": "Can't load the report. The file may be corrupted or the report's assembly is missing.",
  "ReportStringId.Msg_FileNotFound": "File not found.",
  "ReportStringId.Msg_FillDataError": "Error when populating the datasource. The following exception was thrown:",
  "ReportStringId.Msg_GroupSortNoDataSource": "To add a new grouping or sorting level, you must first provide a data source for the report.",
  "ReportStringId.Msg_GroupSortWarning": "The group header or footer is not empty. Do you want to delete this band along with its controls?",
  "ReportStringId.Msg_HierarchyPrintOptions_InvalidFields": "Cannot print report data in hierarchical mode. Invalid fields are assigned to the detail band's HierarchyPrintOptions.",
  "ReportStringId.Msg_HierarchyPrintOptions_SameKeyAndParentFields": "Cannot print report data in hierarchical mode. The same key and parent fields are assigned to the detail band's HierarchyPrintOptions.",
  "ReportStringId.Msg_IncorrectArgument": "Incorrect argument value",
  "ReportStringId.Msg_IncorrectBandType": "Incorrect band type",
  "ReportStringId.Msg_IncorrectPadding": "The padding should be greater than or equal to 0.",
  "ReportStringId.Msg_InvalidCondition": "The condition must be Boolean.",
  "ReportStringId.Msg_InvalidDrillDownControl": "The DrillDownControl property for the '{0}' band is invalid.",
  "ReportStringId.Msg_InvalidExpression": "The specified expression contains invalid symbols (line {0}, character {1}).",
  "ReportStringId.Msg_InvalidExpressionEx": "The specified expression is invalid.",
  "ReportStringId.Msg_InvalidInsertControlOperation": "The {0} control cannot be placed to the {1} container.",
  "ReportStringId.Msg_InvalidLeaderSymbolForXrTocLevel": "Invalid leader symbol.",
  "ReportStringId.Msg_InvalidMethodCall": "This method call is invalid for the object's current state",
  "ReportStringId.Msg_InvalidNameUsage": "This name contains invalid characters. The name should start with a letter and contain letters, numbers and '_' symbol only.",
  "ReportStringId.Msg_InvalidReportSource": "The 'ReportSource' property of a subreport control cannot be set to a descendant of the current report.",
  "ReportStringId.Msg_InvalidXrTocInstance": "No additional instances of Table of Contents can be added to the report.",
  "ReportStringId.Msg_InvalidXrTocInstanceInBand": "No additional instances of Table of Contents can be added to the band.",
  "ReportStringId.Msg_LargeText": "Text is too large.",
  "ReportStringId.Msg_NoBookmarksWereFoundInReportForXrToc": "No bookmarks were found in the report. To create a Table of Contents, specify a bookmark for at least one report element.",
  "ReportStringId.Msg_NoCustomFunction": "Custom function '{0}' not found.",
  "ReportStringId.Msg_NoEmptySummaryArgumentSupported": "A summary function's argument expression cannot be empty.",
  "ReportStringId.Msg_NoNestedAggregateSupported": "A summary function's argument expression cannot contain an aggregate function.",
  "ReportStringId.Msg_NoNestedSummarySupported": "A summary function's argument expression cannot contain a summary function.",
  "ReportStringId.Msg_NotEnoughMemoryToPaint": "Not enough memory to paint. Zoom level will be reset.",
  "ReportStringId.Msg_ParameterBindingValueTypeMismatch": "A parameter binding assigns an incompatible value type to the subreport parameter \"{0}\".",
  "ReportStringId.Msg_PlacingXrTocIntoIncorrectContainer": "Table of Contents can only be placed into Report Header and Report Footer bands.",
  "ReportStringId.Msg_ReportImporting": "Importing report layout. Please, wait...",
  "ReportStringId.Msg_ReservedNameUsage": "This name is reserved. Specify a different name.",
  "ReportStringId.Msg_ScriptCodeIsNotCorrect": "Entered code is incorrect",
  "ReportStringId.Msg_ScriptCompilationError": "Script compilation failed due to an unknown error",
  "ReportStringId.Msg_ScriptError": "Script(s) contain the following errors:\n{0}",
  "ReportStringId.Msg_ScriptExecutionError": "The following error occurred when the script in procedure {0} was executed:\n{1}",
  "ReportStringId.Msg_ScriptLoadingError": "Scripts are compiled but cannot be executed",
  "ReportStringId.Msg_ScriptingPermissionErrorMessage": "You don't have necessary permission to execute the scripts used in this report.\n\nDetails:\n\n{0}",
  "ReportStringId.Msg_SerializationErrorTitle": "Serialization Error",
  "ReportStringId.Msg_ShapeRotationToolTip": "Use Ctrl with the left mouse button to rotate the shape",
  "ReportStringId.Msg_WarningControlsAreOutOfMargin": "Print warning: The following controls are outside the right page margin. This will cause extra pages to be printed - {0}.",
  "ReportStringId.Msg_WarningControlsAreOverlapped": "Export warning: The following controls are overlapped and may be exported to HTML, RTF, DOCX, XLS, XLSX, CSV and Text incorrectly - {0}.",
  "ReportStringId.Msg_WarningFontNameCantBeEmpty": "Font name can't be empty.",
  "ReportStringId.Msg_WarningRemoveBand": "This operation removes the {0} band and all controls within the band. Do you wish to proceed?",
  "ReportStringId.Msg_WarningRemoveCalculatedFields": "This operation will remove all calculated fields from all data tables. Do you wish to proceed?",
  "ReportStringId.Msg_WarningRemoveFormattingRules": "This operation will remove all formatting rules. Do you wish to proceed?",
  "ReportStringId.Msg_WarningRemoveParameters": "This operation will remove all parameters. Do you wish to proceed?",
  "ReportStringId.Msg_WarningUnsavedReports": "Print warning: Save the following reports to preview subreports with recent changes applied - {0}.",
  "ReportStringId.Msg_WrongReportClassName": "An error occurred during deserialization - possible wrong report class name",
  "ReportStringId.NewParameterEditorForm_AddNewParameter": "Add New Parameter",
  "ReportStringId.NewParameterEditorForm_DataAdapter": "Data adapter:",
  "ReportStringId.NewParameterEditorForm_DataMember": "Data member:",
  "ReportStringId.NewParameterEditorForm_DataSource": "Data source:",
  "ReportStringId.NewParameterEditorForm_DisplayMember": "Display member:",
  "ReportStringId.NewParameterEditorForm_ValueMember": "Value member:",
  "ReportStringId.PanelDesignMsg": "Place controls here to keep them together",
  "ReportStringId.ParameterEditor_ParameterListPlaceholder": "No parameters to display.",
  "ReportStringId.ParameterEditor_ParameterSettingsPlaceholder": "Click the Add button to create a parameter.",
  "ReportStringId.PivotGridForm_GroupMain_Caption": "Main",
  "ReportStringId.PivotGridForm_GroupMain_Description": "Main settings(Fields, Layout).",
  "ReportStringId.PivotGridForm_GroupPrinting_Caption": "Printing",
  "ReportStringId.PivotGridForm_GroupPrinting_Description": "Printing option management for the current Pivot Grid.",
  "ReportStringId.PivotGridForm_ItemAppearances_Caption": "Appearances",
  "ReportStringId.PivotGridForm_ItemAppearances_Description": "Modify print appearance of the current Pivot Grid.",
  "ReportStringId.PivotGridForm_ItemFields_Caption": "Fields",
  "ReportStringId.PivotGridForm_ItemFields_Description": "Manage fields.",
  "ReportStringId.PivotGridForm_ItemLayout_Caption": "Layout",
  "ReportStringId.PivotGridForm_ItemLayout_Description": "Customize the current Pivot Grid layout and preview associated data.",
  "ReportStringId.PivotGridForm_ItemSettings_Caption": "Printing Settings",
  "ReportStringId.PivotGridForm_ItemSettings_Description": "Modify print settings for the current Pivot Grid.",
  "ReportStringId.PivotGridFrame_Appearances_DescriptionText": "Select one or more Appearance objects to customize the printing appearance of corresponding visual elements.",
  "ReportStringId.PivotGridFrame_Fields_ColumnsText": "Pivot Grid Fields",
  "ReportStringId.PivotGridFrame_Fields_DescriptionText1": "You can add and delete Pivot Grid fields and modify associated settings.",
  "ReportStringId.PivotGridFrame_Fields_DescriptionText2": "Select and drag field to the Pivot Grid fields panel to create a Pivot Grid field.",
  "ReportStringId.PivotGridFrame_Layouts_DescriptionText": "Modify the Pivot Grid's layout (sort settings, field arrangement) and click the Apply button to apply the modifications to the current Pivot Grid. You can also save the layout to an XML file (the XML file can be loaded and applied to other views at design time and runtime).",
  "ReportStringId.PivotGridFrame_Layouts_SelectorCaption1": "Hide fields &selector",
  "ReportStringId.PivotGridFrame_Layouts_SelectorCaption2": "Show fields &selector",
  "ReportStringId.RepTabCtl_Designer": "Designer",
  "ReportStringId.RepTabCtl_HtmlView": "HTML View",
  "ReportStringId.RepTabCtl_NoReportStatus": "Nothing",
  "ReportStringId.RepTabCtl_Preview": "Preview",
  "ReportStringId.RepTabCtl_ReportStatus": "{0} {{ PaperKind: {1} }}",
  "ReportStringId.RepTabCtl_Scripts": "Scripts",
  "ReportStringId.RibbonXRDesign_AddParameter_Caption": "Add Parameter",
  "ReportStringId.RibbonXRDesign_AddParameter_STipContent": "Create a new parameter to pass dynamic values to your report.",
  "ReportStringId.RibbonXRDesign_AddParameter_STipTitle": "Add Parameter",
  "ReportStringId.RibbonXRDesign_AlignBottom_Caption": "Align Bottoms",
  "ReportStringId.RibbonXRDesign_AlignBottom_STipContent": "Align the bottoms of selected controls.",
  "ReportStringId.RibbonXRDesign_AlignBottom_STipTitle": "Align Bottoms",
  "ReportStringId.RibbonXRDesign_AlignHorizontalCenters_Caption": "Align Middles",
  "ReportStringId.RibbonXRDesign_AlignHorizontalCenters_STipContent": "Align the centers of selected controls horizontally.",
  "ReportStringId.RibbonXRDesign_AlignHorizontalCenters_STipTitle": "Align Middles",
  "ReportStringId.RibbonXRDesign_AlignLeft_Caption": "Align Lefts",
  "ReportStringId.RibbonXRDesign_AlignLeft_STipContent": "Left align selected controls.",
  "ReportStringId.RibbonXRDesign_AlignLeft_STipTitle": "Align Lefts",
  "ReportStringId.RibbonXRDesign_AlignRight_Caption": "Align Rights",
  "ReportStringId.RibbonXRDesign_AlignRight_STipContent": "Right align selected controls.",
  "ReportStringId.RibbonXRDesign_AlignRight_STipTitle": "Align Rights",
  "ReportStringId.RibbonXRDesign_AlignToGrid_Caption": "Align to Grid",
  "ReportStringId.RibbonXRDesign_AlignToGrid_STipContent": "Align the position of selected controls to the grid.",
  "ReportStringId.RibbonXRDesign_AlignToGrid_STipTitle": "Align to Grid",
  "ReportStringId.RibbonXRDesign_AlignTop_Caption": "Align Tops",
  "ReportStringId.RibbonXRDesign_AlignTop_STipContent": "Align the tops of selected controls.",
  "ReportStringId.RibbonXRDesign_AlignTop_STipTitle": "Align Tops",
  "ReportStringId.RibbonXRDesign_AlignVerticalCenters_Caption": "Align Centers",
  "ReportStringId.RibbonXRDesign_AlignVerticalCenters_STipContent": "Align the centers of selected controls vertically.",
  "ReportStringId.RibbonXRDesign_AlignVerticalCenters_STipTitle": "Align Centers",
  "ReportStringId.RibbonXRDesign_BackColor_Caption": "Background Color",
  "ReportStringId.RibbonXRDesign_BackColor_STipContent": "Change text background color.",
  "ReportStringId.RibbonXRDesign_BackColor_STipTitle": "Background Color",
  "ReportStringId.RibbonXRDesign_BandCollapseAll_Caption": "Collapse All",
  "ReportStringId.RibbonXRDesign_BandExpandAll_Caption": "Expand All",
  "ReportStringId.RibbonXRDesign_BarCodeShowText_STipContent": "Display accompanying text in a barcode.",
  "ReportStringId.RibbonXRDesign_BarCodeSymbology_Caption": "Symbology",
  "ReportStringId.RibbonXRDesign_BarCodeSymbology_STipContent": "Symbology",
  "ReportStringId.RibbonXRDesign_BarCodeSymbology_STipTitle": "Symbology",
  "ReportStringId.RibbonXRDesign_BorderBottom_Caption": "Bottom Border",
  "ReportStringId.RibbonXRDesign_BorderBottom_STipTitle": "Bottom Border",
  "ReportStringId.RibbonXRDesign_BorderColor_Caption": "Border Color",
  "ReportStringId.RibbonXRDesign_BorderColor_STipContent": "Change border color.",
  "ReportStringId.RibbonXRDesign_BorderColor_STipTitle": "Border Color",
  "ReportStringId.RibbonXRDesign_BorderLeft_Caption": "Left Border",
  "ReportStringId.RibbonXRDesign_BorderLeft_STipTitle": "Left Border",
  "ReportStringId.RibbonXRDesign_BordersAll_Caption": "All Borders",
  "ReportStringId.RibbonXRDesign_BordersAll_STipTitle": "All Borders",
  "ReportStringId.RibbonXRDesign_BordersNone_Caption": "No Border",
  "ReportStringId.RibbonXRDesign_BordersNone_STipContent": "Remove borders from selected controls.",
  "ReportStringId.RibbonXRDesign_BordersNone_STipTitle": "No Border",
  "ReportStringId.RibbonXRDesign_BringToFront_Caption": "Bring to Front",
  "ReportStringId.RibbonXRDesign_BringToFront_STipContent": "Bring selected controls to the front.",
  "ReportStringId.RibbonXRDesign_BringToFront_STipTitle": "Bring to Front",
  "ReportStringId.RibbonXRDesign_CenterHorizontally_Caption": "Center Horizontally",
  "ReportStringId.RibbonXRDesign_CenterHorizontally_STipContent": "Horizontally center selected controls within a band.",
  "ReportStringId.RibbonXRDesign_CenterHorizontally_STipTitle": "Center Horizontally",
  "ReportStringId.RibbonXRDesign_CenterVertically_Caption": "Center Vertically",
  "ReportStringId.RibbonXRDesign_CenterVertically_STipContent": "Vertically center selected controls within a band.",
  "ReportStringId.RibbonXRDesign_CenterVertically_STipTitle": "Center Vertically",
  "ReportStringId.RibbonXRDesign_CharacterCombCellAutoWidth_STipContent": "Automatically modify cell width based on current font size.",
  "ReportStringId.RibbonXRDesign_CharacterCombCellHeight_STipTitle": "Cell Height",
  "ReportStringId.RibbonXRDesign_CharacterCombCellHorizontalSpacing_Caption": "Horizontal Spacing: ",
  "ReportStringId.RibbonXRDesign_CharacterCombCellHorizontalSpacing_STipTitle": "Cell Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_CharacterCombCellVerticalSpacing_Caption": "Vertical Spacing: ",
  "ReportStringId.RibbonXRDesign_ChartAddDataSource_STipContent": "Set up a data source for a chart.",
  "ReportStringId.RibbonXRDesign_ChartAddImageAnnotation_Caption": "Add Image Annotation",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewArea_Caption": "Area",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewArea_STipTitle": "Area Series",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewBar_Caption": "Bar",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewBar_STipTitle": "Bar Series",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewLine_Caption": "Line",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewRange_Caption": "Range",
  "ReportStringId.RibbonXRDesign_ChartAppearanceName_Caption": "Appearance",
  "ReportStringId.RibbonXRDesign_ChartImageType_Caption": "Image Type",
  "ReportStringId.RibbonXRDesign_ChartLoad_STipTitle": "Load",
  "ReportStringId.RibbonXRDesign_ChartPaletteName_Caption": "Palette",
  "ReportStringId.RibbonXRDesign_ChartPaletteName_STipContent": "Select a palette used to paint a chart's series.",
  "ReportStringId.RibbonXRDesign_ChartPaletteName_STipTitle": "Palette",
  "ReportStringId.RibbonXRDesign_ChartSave_Caption": "Save...",
  "ReportStringId.RibbonXRDesign_ChartSave_STipContent": "Save a chart to an XML file.",
  "ReportStringId.RibbonXRDesign_ChartSave_STipTitle": "Save",
  "ReportStringId.RibbonXRDesign_Close_Caption": "Close",
  "ReportStringId.RibbonXRDesign_Close_STipContent": "Close the current report.",
  "ReportStringId.RibbonXRDesign_Close_STipTitle": "Close",
  "ReportStringId.RibbonXRDesign_ContextPage_Design": "Design",
  "ReportStringId.RibbonXRDesign_ContextPage_Format": "Format",
  "ReportStringId.RibbonXRDesign_ContextPage_Layout": "Layout",
  "ReportStringId.RibbonXRDesign_ContextPage_Text": "Text",
  "ReportStringId.RibbonXRDesign_ContextPage_View": "View",
  "ReportStringId.RibbonXRDesign_Copy_Caption": "Copy",
  "ReportStringId.RibbonXRDesign_Copy_STipContent": "Copy selected controls and place them on the Clipboard.",
  "ReportStringId.RibbonXRDesign_Copy_STipTitle": "Copy",
  "ReportStringId.RibbonXRDesign_Cut_Caption": "Cut",
  "ReportStringId.RibbonXRDesign_Cut_STipContent": "Cut selected controls from the report and place them on the Clipboard.",
  "ReportStringId.RibbonXRDesign_Cut_STipTitle": "Cut",
  "ReportStringId.RibbonXRDesign_DrawGridLines_Caption": "Grid Lines",
  "ReportStringId.RibbonXRDesign_DrawGridLines_STipContent": "Show gridlines on the report surface for exact control placement.",
  "ReportStringId.RibbonXRDesign_DrawWatermark_Caption": "Watermark",
  "ReportStringId.RibbonXRDesign_DrawWatermark_STipContent": "Display the document's watermark on the design surface for a better design experience. Specify watermark settings in the Page tab.",
  "ReportStringId.RibbonXRDesign_Exit_Caption": "Exit",
  "ReportStringId.RibbonXRDesign_Exit_STipContent": "Close the Report Designer.",
  "ReportStringId.RibbonXRDesign_Exit_STipTitle": "Exit",
  "ReportStringId.RibbonXRDesign_FitBoundsToContainer_STipContent": "Modify control size to fully occupy available container space.",
  "ReportStringId.RibbonXRDesign_FitBoundsToText_STipContent": "Modify the size of selected controls to fit bounds to text.",
  "ReportStringId.RibbonXRDesign_FitTextToBounds_STipContent": "Modify the font size of selected controls to fit their entire area.",
  "ReportStringId.RibbonXRDesign_FontBold_Caption": "Bold",
  "ReportStringId.RibbonXRDesign_FontBold_STipContent": "Make the selected text bold.",
  "ReportStringId.RibbonXRDesign_FontBold_STipTitle": "Bold",
  "ReportStringId.RibbonXRDesign_FontItalic_Caption": "Italic",
  "ReportStringId.RibbonXRDesign_FontItalic_STipContent": "Italicize text.",
  "ReportStringId.RibbonXRDesign_FontItalic_STipTitle": "Italic",
  "ReportStringId.RibbonXRDesign_FontName_STipContent": "Change font face.",
  "ReportStringId.RibbonXRDesign_FontName_STipTitle": "Font",
  "ReportStringId.RibbonXRDesign_FontSize_STipContent": "Change font size.",
  "ReportStringId.RibbonXRDesign_FontSize_STipTitle": "Font Size",
  "ReportStringId.RibbonXRDesign_FontStrikeout_Caption": "Strikethrough",
  "ReportStringId.RibbonXRDesign_FontStrikeout_STipContent": "Cross selected text out by drawing a line through it.",
  "ReportStringId.RibbonXRDesign_FontStrikeout_STipTitle": "Strikethrough",
  "ReportStringId.RibbonXRDesign_FontUnderline_Caption": "Underline",
  "ReportStringId.RibbonXRDesign_FontUnderline_STipContent": "Underline selected text.",
  "ReportStringId.RibbonXRDesign_FontUnderline_STipTitle": "Underline",
  "ReportStringId.RibbonXRDesign_ForeColor_Caption": "Foreground Color",
  "ReportStringId.RibbonXRDesign_ForeColor_STipContent": "Change text foreground color.",
  "ReportStringId.RibbonXRDesign_ForeColor_STipTitle": "Foreground Color",
  "ReportStringId.RibbonXRDesign_GaugeImageType_Caption": "Image Type",
  "ReportStringId.RibbonXRDesign_HorizSpaceConcatenate_Caption": "Remove Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HorizSpaceConcatenate_STipContent": "Remove horizontal spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_HorizSpaceConcatenate_STipTitle": "Remove Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HorizSpaceDecrease_Caption": "Decrease Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HorizSpaceDecrease_STipContent": "Decrease horizontal spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_HorizSpaceDecrease_STipTitle": "Decrease Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HorizSpaceIncrease_Caption": "Increase Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HorizSpaceIncrease_STipContent": "Increase horizontal spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_HorizSpaceIncrease_STipTitle": "Increase Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HorizSpaceMakeEqual_Caption": "Apply Equal Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HorizSpaceMakeEqual_STipContent": "Apply equal horizontal spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_HorizSpaceMakeEqual_STipTitle": "Apply Equal Horizontal Spacing",
  "ReportStringId.RibbonXRDesign_HtmlBackward_Caption": "Back",
  "ReportStringId.RibbonXRDesign_HtmlBackward_STipContent": "Move back to the previous page.",
  "ReportStringId.RibbonXRDesign_HtmlBackward_STipTitle": "Back",
  "ReportStringId.RibbonXRDesign_HtmlFind_Caption": "Find",
  "ReportStringId.RibbonXRDesign_HtmlFind_STipContent": "Find text on this page.",
  "ReportStringId.RibbonXRDesign_HtmlFind_STipTitle": "Find",
  "ReportStringId.RibbonXRDesign_HtmlForward_Caption": "Forward",
  "ReportStringId.RibbonXRDesign_HtmlForward_STipContent": "Move forward to the next page.",
  "ReportStringId.RibbonXRDesign_HtmlForward_STipTitle": "Forward",
  "ReportStringId.RibbonXRDesign_HtmlHome_Caption": "Home",
  "ReportStringId.RibbonXRDesign_HtmlHome_STipContent": "Display the home page.",
  "ReportStringId.RibbonXRDesign_HtmlHome_STipTitle": "Home",
  "ReportStringId.RibbonXRDesign_HtmlPageText": "HTML View",
  "ReportStringId.RibbonXRDesign_HtmlRefresh_Caption": "Refresh",
  "ReportStringId.RibbonXRDesign_HtmlRefresh_STipContent": "Refresh this page.",
  "ReportStringId.RibbonXRDesign_HtmlRefresh_STipTitle": "Refresh",
  "ReportStringId.RibbonXRDesign_JustifyCenter_Caption": "Center Text",
  "ReportStringId.RibbonXRDesign_JustifyCenter_STipContent": "Center text between the left and right sides.",
  "ReportStringId.RibbonXRDesign_JustifyCenter_STipTitle": "Center Text",
  "ReportStringId.RibbonXRDesign_JustifyJustify_Caption": "Justify",
  "ReportStringId.RibbonXRDesign_JustifyJustify_STipContent": "Distribute text evenly to the left and right sides.",
  "ReportStringId.RibbonXRDesign_JustifyJustify_STipTitle": "Justify",
  "ReportStringId.RibbonXRDesign_JustifyLeft_Caption": "Align Text Left",
  "ReportStringId.RibbonXRDesign_JustifyLeft_STipContent": "Align text to the left.",
  "ReportStringId.RibbonXRDesign_JustifyLeft_STipTitle": "Align Text Left",
  "ReportStringId.RibbonXRDesign_JustifyRight_Caption": "Align Text Right",
  "ReportStringId.RibbonXRDesign_JustifyRight_STipContent": "Align text to the right.",
  "ReportStringId.RibbonXRDesign_JustifyRight_STipTitle": "Align Text Right",
  "ReportStringId.RibbonXRDesign_LabelAutoWidth_STipContent": "Allow selected controls to modify width to fit content.",
  "ReportStringId.RibbonXRDesign_LabelCanGrow_STipContent": "Allow selected controls to increase height to fit content.",
  "ReportStringId.RibbonXRDesign_LabelCanShrink_Caption": "Can Shrink",
  "ReportStringId.RibbonXRDesign_LabelCanShrink_STipContent": "Allow selected controls to decrease height to fit content.",
  "ReportStringId.RibbonXRDesign_LabelCanShrink_STipTitle": "Can Shrink",
  "ReportStringId.RibbonXRDesign_LabelWordWrap_Caption": "Word Wrap",
  "ReportStringId.RibbonXRDesign_LabelWordWrap_STipContent": "Allow selected controls to wrap label text if it does not fit a line.",
  "ReportStringId.RibbonXRDesign_LabelWordWrap_STipTitle": "Word Wrap",
  "ReportStringId.RibbonXRDesign_Language_Caption": "Language",
  "ReportStringId.RibbonXRDesign_Language_STipTitle": "Language",
  "ReportStringId.RibbonXRDesign_NewReportWizard_Caption": "Create a New Report Using Report Wizard...",
  "ReportStringId.RibbonXRDesign_NewReportWizard_Description": "Launch the Report Wizard to create a new report.",
  "ReportStringId.RibbonXRDesign_NewReportWizard_STipContent": "Launch the Report Wizard to create a new report.",
  "ReportStringId.RibbonXRDesign_NewReportWizard_STipTitle": "Create a New Report using the Report Wizard",
  "ReportStringId.RibbonXRDesign_NewReport_Caption": "New Report",
  "ReportStringId.RibbonXRDesign_NewReport_Description": "Create a new blank report.",
  "ReportStringId.RibbonXRDesign_NewReport_STipContent": "Create a new blank report.",
  "ReportStringId.RibbonXRDesign_NewReport_STipTitle": "New Blank Report",
  "ReportStringId.RibbonXRDesign_OpenFile_Caption": "Open...",
  "ReportStringId.RibbonXRDesign_OpenFile_STipContent": "Open a report.",
  "ReportStringId.RibbonXRDesign_OpenFile_STipTitle": "Open Report",
  "ReportStringId.RibbonXRDesign_PageColor_Caption": "Page Color",
  "ReportStringId.RibbonXRDesign_PageGroup_Alignment": "Alignment",
  "ReportStringId.RibbonXRDesign_PageGroup_Annotations": "Annotations",
  "ReportStringId.RibbonXRDesign_PageGroup_Appearance": "Appearance",
  "ReportStringId.RibbonXRDesign_PageGroup_Arrange": "Arrange",
  "ReportStringId.RibbonXRDesign_PageGroup_Bands": "Bands",
  "ReportStringId.RibbonXRDesign_PageGroup_Behavior": "Behavior",
  "ReportStringId.RibbonXRDesign_PageGroup_Borders": "Borders",
  "ReportStringId.RibbonXRDesign_PageGroup_Chart": "Chart",
  "ReportStringId.RibbonXRDesign_PageGroup_Clipboard": "Clipboard",
  "ReportStringId.RibbonXRDesign_PageGroup_Data": "Data",
  "ReportStringId.RibbonXRDesign_PageGroup_Delete": "Delete",
  "ReportStringId.RibbonXRDesign_PageGroup_Design": "Design",
  "ReportStringId.RibbonXRDesign_PageGroup_Edit": "Edit",
  "ReportStringId.RibbonXRDesign_PageGroup_Font": "Font",
  "ReportStringId.RibbonXRDesign_PageGroup_HtmlNavigation": "Navigation",
  "ReportStringId.RibbonXRDesign_PageGroup_Insert": "Insert",
  "ReportStringId.RibbonXRDesign_PageGroup_Layout": "Layout",
  "ReportStringId.RibbonXRDesign_PageGroup_Merge": "Merge",
  "ReportStringId.RibbonXRDesign_PageGroup_PageSetup": "Page Setup",
  "ReportStringId.RibbonXRDesign_PageGroup_PivotFields": "Fields",
  "ReportStringId.RibbonXRDesign_PageGroup_PivotGrid": "Pivot Grid",
  "ReportStringId.RibbonXRDesign_PageGroup_PivotPrintOptions": "Print Options",
  "ReportStringId.RibbonXRDesign_PageGroup_Report": "Report",
  "ReportStringId.RibbonXRDesign_PageGroup_Scripts": "Scripts",
  "ReportStringId.RibbonXRDesign_PageGroup_Select": "Select",
  "ReportStringId.RibbonXRDesign_PageGroup_Series": "Series",
  "ReportStringId.RibbonXRDesign_PageGroup_Show": "Show",
  "ReportStringId.RibbonXRDesign_PageGroup_SizeAndLayout": "Layout",
  "ReportStringId.RibbonXRDesign_PageGroup_Snapping": "Snapping",
  "ReportStringId.RibbonXRDesign_PageGroup_Sparkline": "Sparkline",
  "ReportStringId.RibbonXRDesign_PageGroup_Styles": "Styles",
  "ReportStringId.RibbonXRDesign_PageGroup_Symbology": "Symbology",
  "ReportStringId.RibbonXRDesign_PageGroup_TextAlignment": "Alignment",
  "ReportStringId.RibbonXRDesign_PageGroup_Theme": "Theme",
  "ReportStringId.RibbonXRDesign_PageGroup_View": "View",
  "ReportStringId.RibbonXRDesign_PageGroup_Zoom": "Zoom",
  "ReportStringId.RibbonXRDesign_PageMargins_Caption": "Margins",
  "ReportStringId.RibbonXRDesign_PageMargins_STipContent": "Set margin sizes for the report. Choose from standard options or click Custom Margins to define your own margins.",
  "ReportStringId.RibbonXRDesign_PageMargins_STipTitle": "Adjust Margins",
  "ReportStringId.RibbonXRDesign_PageOrientation_Caption": "Orientation",
  "ReportStringId.RibbonXRDesign_PageSize_Caption": "Size",
  "ReportStringId.RibbonXRDesign_PageText": "Report Designer",
  "ReportStringId.RibbonXRDesign_PageWatermark_Caption": "Watermark",
  "ReportStringId.RibbonXRDesign_Page_Home": "Home",
  "ReportStringId.RibbonXRDesign_Page_Layout": "Layout",
  "ReportStringId.RibbonXRDesign_Page_Page": "Page",
  "ReportStringId.RibbonXRDesign_Page_Scripts": "Scripts",
  "ReportStringId.RibbonXRDesign_Page_View": "View",
  "ReportStringId.RibbonXRDesign_PaperKind_Caption": "Size",
  "ReportStringId.RibbonXRDesign_Paste_Caption": "Paste",
  "ReportStringId.RibbonXRDesign_Paste_STipContent": "Paste the contents of the Clipboard.",
  "ReportStringId.RibbonXRDesign_Paste_STipTitle": "Paste",
  "ReportStringId.RibbonXRDesign_PivotGridAddField_Caption": "Add Field",
  "ReportStringId.RibbonXRDesign_PivotGridAddField_STipTitle": "Add Field",
  "ReportStringId.RibbonXRDesign_PivotGridColumnAreaOnEveryPage_Caption": "Column Area On Every Page",
  "ReportStringId.RibbonXRDesign_PivotGridColumnHeaders_STipContent": "Print column field headers.",
  "ReportStringId.RibbonXRDesign_PivotGridHorizontalLines_Caption": "Horizontal Lines",
  "ReportStringId.RibbonXRDesign_PivotGridRowAreaOnEveryPage_Caption": "Row Area On Every Page",
  "ReportStringId.RibbonXRDesign_PivotGridRowAreaOnEveryPage_STipContent": "Print row area on every page.",
  "ReportStringId.RibbonXRDesign_PivotGridRowAreaOnEveryPage_STipTitle": "Print Row Area On Every Page",
  "ReportStringId.RibbonXRDesign_PivotGridRunDesigner_Caption": "Run Designer",
  "ReportStringId.RibbonXRDesign_PivotGridRunDesigner_STipTitle": "Run Designer",
  "ReportStringId.RibbonXRDesign_PivotGridVerticalLines_Caption": "Vertical Lines",
  "ReportStringId.RibbonXRDesign_PivotGridVerticalLines_STipContent": "Print vertical grid lines.",
  "ReportStringId.RibbonXRDesign_PivotGridVerticalLines_STipTitle": "Print Vertical Lines",
  "ReportStringId.RibbonXRDesign_Redo_Caption": "Redo",
  "ReportStringId.RibbonXRDesign_Redo_STipContent": "Redo the last operation.",
  "ReportStringId.RibbonXRDesign_Redo_STipTitle": "Redo",
  "ReportStringId.RibbonXRDesign_SaveAll_Caption": "Save All",
  "ReportStringId.RibbonXRDesign_SaveAll_STipContent": "Save all modified reports.",
  "ReportStringId.RibbonXRDesign_SaveAll_STipTitle": "Save All Reports",
  "ReportStringId.RibbonXRDesign_SaveFileAs_Caption": "Save As...",
  "ReportStringId.RibbonXRDesign_SaveFileAs_Description": "Save the current report with a new name.",
  "ReportStringId.RibbonXRDesign_SaveFileAs_STipContent": "Save the current report with a new name.",
  "ReportStringId.RibbonXRDesign_SaveFileAs_STipTitle": "Save Report As",
  "ReportStringId.RibbonXRDesign_SaveFile_Caption": "Save",
  "ReportStringId.RibbonXRDesign_SaveFile_Description": "Save the current report.",
  "ReportStringId.RibbonXRDesign_SaveFile_STipContent": "Save the current report.",
  "ReportStringId.RibbonXRDesign_SaveFile_STipTitle": "Save Report",
  "ReportStringId.RibbonXRDesign_ScriptsCopy_Caption": "Copy",
  "ReportStringId.RibbonXRDesign_ScriptsCut_Caption": "Cut",
  "ReportStringId.RibbonXRDesign_ScriptsPaste_Caption": "Paste",
  "ReportStringId.RibbonXRDesign_ScriptsSelectEvent_STipContent": "Select an available event(s).",
  "ReportStringId.RibbonXRDesign_ScriptsValidate_Caption": "Validate",
  "ReportStringId.RibbonXRDesign_ScriptsValidate_STipContent": "Check whether report scripts contain errors. If errors are found, they will be listed in the Script Errors panel.",
  "ReportStringId.RibbonXRDesign_ScriptsValidate_STipTitle": "Validate Scripts",
  "ReportStringId.RibbonXRDesign_Scripts_Caption": "Scripts",
  "ReportStringId.RibbonXRDesign_Scripts_STipContent": "Show or hide the Script Editor.",
  "ReportStringId.RibbonXRDesign_Scripts_STipTitle": "Show/Hide Scripts",
  "ReportStringId.RibbonXRDesign_SendToBack_Caption": "Send to Back",
  "ReportStringId.RibbonXRDesign_SendToBack_STipContent": "Move selected controls to the back.",
  "ReportStringId.RibbonXRDesign_SendToBack_STipTitle": "Send to Back",
  "ReportStringId.RibbonXRDesign_ShapeStretch_Caption": "Stretch",
  "ReportStringId.RibbonXRDesign_ShapeStretch_STipContent": "Stretch a shape to fill its entire area when rotated.",
  "ReportStringId.RibbonXRDesign_ShapeStretch_STipTitle": "Stretch",
  "ReportStringId.RibbonXRDesign_ShowDesignerTab_STipContent": "Customize the report layout or create a new layout in the Report Designer.",
  "ReportStringId.RibbonXRDesign_ShowDesignerTab_STipTitle": "Report Designer",
  "ReportStringId.RibbonXRDesign_ShowExportWarnings_Caption": "Export-related Warnings",
  "ReportStringId.RibbonXRDesign_ShowExportWarnings_STipContent": "Highlight intersecting report controls to warn you about the possibility of corrupting the document layout when exporting the document to specific formats.",
  "ReportStringId.RibbonXRDesign_ShowPreviewTab_Caption": "Preview",
  "ReportStringId.RibbonXRDesign_ShowPreviewTab_STipTitle": "Print Preview",
  "ReportStringId.RibbonXRDesign_ShowPrintingWarnings_STipContent": "Highlight report controls that overrun the right page margin to warn you about extra pages when printing the document.",
  "ReportStringId.RibbonXRDesign_ShowPrintingWarnings_STipTitle": "Show Printing Warnings",
  "ReportStringId.RibbonXRDesign_ShowScriptsTab_Caption": "Scripts",
  "ReportStringId.RibbonXRDesign_ShowScriptsTab_STipContent": "Execute custom calculations by handling script events.",
  "ReportStringId.RibbonXRDesign_ShowScriptsTab_STipTitle": "Scripts",
  "ReportStringId.RibbonXRDesign_SizeToControlHeight_Caption": "Apply Same Height",
  "ReportStringId.RibbonXRDesign_SizeToControlHeight_STipContent": "Apply the same height to selected controls.",
  "ReportStringId.RibbonXRDesign_SizeToControlHeight_STipTitle": "Apply Same Height",
  "ReportStringId.RibbonXRDesign_SizeToControlWidth_Caption": "Apply Same Width",
  "ReportStringId.RibbonXRDesign_SizeToControlWidth_STipContent": "Apply the same width to selected controls.",
  "ReportStringId.RibbonXRDesign_SizeToControlWidth_STipTitle": "Apply Same Width",
  "ReportStringId.RibbonXRDesign_SizeToControl_Caption": "Apply Same Size",
  "ReportStringId.RibbonXRDesign_SizeToControl_STipContent": "Apply the same size to selected controls.",
  "ReportStringId.RibbonXRDesign_SizeToControl_STipTitle": "Apply Same Size",
  "ReportStringId.RibbonXRDesign_SizeToGrid_Caption": "Fit Bounds to Grid",
  "ReportStringId.RibbonXRDesign_SizeToGrid_STipContent": "Modify the size of selected controls based on grid size.",
  "ReportStringId.RibbonXRDesign_SizeToGrid_STipTitle": "Size to Grid",
  "ReportStringId.RibbonXRDesign_SnapLines_Caption": "Snap Lines",
  "ReportStringId.RibbonXRDesign_SnapLines_STipTitle": "Snap Lines",
  "ReportStringId.RibbonXRDesign_SnapToGrid_Caption": "Snap to Grid",
  "ReportStringId.RibbonXRDesign_SparklineAddDataSource_STipContent": "Set up a data source for a sparkline.",
  "ReportStringId.RibbonXRDesign_SparklineImageType_Caption": "Image Type",
  "ReportStringId.RibbonXRDesign_StatusBar_HtmlDone": "Done",
  "ReportStringId.RibbonXRDesign_StatusBar_HtmlProcessing": "Processing...",
  "ReportStringId.RibbonXRDesign_TableDeleteCell_Caption": "Cell",
  "ReportStringId.RibbonXRDesign_TableDeleteCell_STipContent": "Delete the current cell.",
  "ReportStringId.RibbonXRDesign_TableDeleteColumn_Caption": "Column",
  "ReportStringId.RibbonXRDesign_TableDeleteColumn_STipContent": "Delete the current column.",
  "ReportStringId.RibbonXRDesign_TableDeleteColumn_STipTitle": "Delete Column",
  "ReportStringId.RibbonXRDesign_TableDeleteRow_Caption": "Row",
  "ReportStringId.RibbonXRDesign_TableDeleteRow_STipContent": "Delete the current row.",
  "ReportStringId.RibbonXRDesign_TableDeleteRow_STipTitle": "Delete Row",
  "ReportStringId.RibbonXRDesign_TableDeleteTable_Caption": "Table",
  "ReportStringId.RibbonXRDesign_TableDeleteTable_STipContent": "Delete the entire table.",
  "ReportStringId.RibbonXRDesign_TableDistributeColumnsEvenly_Caption": "Columns",
  "ReportStringId.RibbonXRDesign_TableDistributeColumnsEvenly_STipContent": "Distribute the width of selected columns equally between them.",
  "ReportStringId.RibbonXRDesign_TableDistributeColumnsEvenly_STipTitle": "Distribute Columns Evenly",
  "ReportStringId.RibbonXRDesign_TableDistributeRowsEvenly_Caption": "Rows",
  "ReportStringId.RibbonXRDesign_TableDistributeRowsEvenly_STipContent": "Distribute the height of selected rows equally between them.",
  "ReportStringId.RibbonXRDesign_TableDistributeRowsEvenly_STipTitle": "Distribute Rows Evenly",
  "ReportStringId.RibbonXRDesign_TableInsertColumnToLeft_STipContent": "Add a new column directly to the left of the current column.",
  "ReportStringId.RibbonXRDesign_TableInsertColumnToLeft_STipTitle": "Insert Column to Left",
  "ReportStringId.RibbonXRDesign_TableInsertColumnToRight_STipContent": "Add a new column directly to the right of the current column.",
  "ReportStringId.RibbonXRDesign_TableInsertRowAbove_Caption": "Row Above",
  "ReportStringId.RibbonXRDesign_TableInsertRowAbove_STipTitle": "Insert Row Above",
  "ReportStringId.RibbonXRDesign_TableInsertRowBelow_Caption": "Row Below",
  "ReportStringId.RibbonXRDesign_TableInsertRowBelow_STipTitle": "Insert Row Below",
  "ReportStringId.RibbonXRDesign_TableMergeCells_Caption": "Merge Cells",
  "ReportStringId.RibbonXRDesign_TableMergeCells_STipContent": "Merge selected cells into one cell.",
  "ReportStringId.RibbonXRDesign_TableMergeCells_STipTitle": "Merge Cells",
  "ReportStringId.RibbonXRDesign_TableSelectColumn_Caption": "Column",
  "ReportStringId.RibbonXRDesign_TableSelectColumn_STipTitle": "Select Column",
  "ReportStringId.RibbonXRDesign_TableSelectRow_Caption": "Row",
  "ReportStringId.RibbonXRDesign_TableSelectRow_STipContent": "Select the current row.",
  "ReportStringId.RibbonXRDesign_TableSelectRow_STipTitle": "Select Row",
  "ReportStringId.RibbonXRDesign_TableSelectTable_Caption": "Table",
  "ReportStringId.RibbonXRDesign_TableSelectTable_STipContent": "Select the entire table.",
  "ReportStringId.RibbonXRDesign_TableSelectTable_STipTitle": "Select Table",
  "ReportStringId.RibbonXRDesign_TableSplitCells_Caption": "Split Cells",
  "ReportStringId.RibbonXRDesign_TableSplitCells_STipTitle": "Split Cells",
  "ReportStringId.RibbonXRDesign_ToolboxControlsPage": "Toolbox",
  "ReportStringId.RibbonXRDesign_Undo_Caption": "Undo",
  "ReportStringId.RibbonXRDesign_Undo_STipContent": "Undo the last operation.",
  "ReportStringId.RibbonXRDesign_Undo_STipTitle": "Undo",
  "ReportStringId.RibbonXRDesign_ValidateScripts_Caption": "Validate",
  "ReportStringId.RibbonXRDesign_VertAlignBottom_Caption": "Align Text Bottom",
  "ReportStringId.RibbonXRDesign_VertAlignBottom_STipContent": "Align text to the bottom.",
  "ReportStringId.RibbonXRDesign_VertAlignBottom_STipTitle": "Align Text Bottom",
  "ReportStringId.RibbonXRDesign_VertAlignMiddle_Caption": "Align Text Middle",
  "ReportStringId.RibbonXRDesign_VertAlignMiddle_STipTitle": "Align Text Middle",
  "ReportStringId.RibbonXRDesign_VertSpaceConcatenate_Caption": "Remove Vertical Spacing",
  "ReportStringId.RibbonXRDesign_VertSpaceConcatenate_STipContent": "Remove vertical spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_VertSpaceConcatenate_STipTitle": "Remove Vertical Spacing",
  "ReportStringId.RibbonXRDesign_VertSpaceDecrease_Caption": "Decrease Vertical Spacing",
  "ReportStringId.RibbonXRDesign_VertSpaceDecrease_STipContent": "Decrease vertical spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_VertSpaceDecrease_STipTitle": "Decrease Vertical Spacing",
  "ReportStringId.RibbonXRDesign_VertSpaceIncrease_Caption": "Increase Vertical Spacing",
  "ReportStringId.RibbonXRDesign_VertSpaceIncrease_STipContent": "Increase vertical spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_VertSpaceIncrease_STipTitle": "Increase Vertical Spacing",
  "ReportStringId.RibbonXRDesign_VertSpaceMakeEqual_Caption": "Apply Equal Vertical Spacing",
  "ReportStringId.RibbonXRDesign_VertSpaceMakeEqual_STipContent": "Apply equal vertical spacing between selected controls.",
  "ReportStringId.RibbonXRDesign_VertSpaceMakeEqual_STipTitle": "Apply Equal Vertical Spacing",
  "ReportStringId.RibbonXRDesign_Windows_Caption": "Windows",
  "ReportStringId.RibbonXRDesign_Windows_STipContent": "Change report designer dock panel visibility.",
  "ReportStringId.RibbonXRDesign_Windows_STipTitle": "Show/Hide Windows",
  "ReportStringId.RibbonXRDesign_ZoomExact_Caption": "Exact:",
  "ReportStringId.RibbonXRDesign_ZoomIn_Caption": "Zoom In",
  "ReportStringId.RibbonXRDesign_ZoomIn_STipContent": "Zoom in to get a close-up view of the report.",
  "ReportStringId.RibbonXRDesign_ZoomIn_STipTitle": "Zoom In",
  "ReportStringId.RibbonXRDesign_ZoomOut_Caption": "Zoom Out",
  "ReportStringId.RibbonXRDesign_ZoomOut_STipContent": "Zoom out to view more of the report at a reduced size.",
  "ReportStringId.RibbonXRDesign_ZoomOut_STipTitle": "Zoom Out",
  "ReportStringId.RibbonXRDesign_Zoom_Caption": "Zoom",
  "ReportStringId.RibbonXRDesign_Zoom_STipContent": "Change the zoom level of the Report Designer.",
  "ReportStringId.RibbonXRDesign_Zoom_STipTitle": "Zoom",
  "ReportStringId.SR_Height": "Height",
  "ReportStringId.SR_Horizontal_Pitch": "Horizontal pitch",
  "ReportStringId.SR_Number_Across": "Number Across",
  "ReportStringId.SR_Number_Down": "Number\nDown",
  "ReportStringId.SR_Side_Margins": "Side margins",
  "ReportStringId.SR_Top_Margin": "Top\nmargin",
  "ReportStringId.SR_Vertical_Pitch": "Vertical\npitch",
  "ReportStringId.SR_Width": "Width",
  "ReportStringId.SSForm_Msg_FileFilter": "Report StyleSheet files (*.repss)|*.repss|All files (*.*)|*.*",
  "ReportStringId.SSForm_Msg_InvalidFileFormat": "Invalid file format",
  "ReportStringId.SSForm_Msg_MoreThanOneStyle": "You selected more than one style",
  "ReportStringId.SSForm_Msg_NoStyleSelected": "No styles are selected",
  "ReportStringId.SSForm_Msg_SelectedStylesText": " selected styles...",
  "ReportStringId.SSForm_Msg_StyleNamePreviewPostfix": " style",
  "ReportStringId.STag_Capt_Format": "{0} {1}",
  "ReportStringId.STag_Capt_Tasks": "Tasks",
  "ReportStringId.STag_Name_Bands": "Bands",
  "ReportStringId.STag_Name_Checked": "Checked",
  "ReportStringId.STag_Name_ColumnCount": "Column Count",
  "ReportStringId.STag_Name_ColumnLayout": "Multi-Column Layout",
  "ReportStringId.STag_Name_ColumnMode": "Multi-Column Mode",
  "ReportStringId.STag_Name_ColumnSpacing": "Column Spacing",
  "ReportStringId.STag_Name_ColumnWidth": "Column Width",
  "ReportStringId.STag_Name_DataBinding": "Data Binding",
  "ReportStringId.STag_Name_ExpressionBinding": "Expression",
  "ReportStringId.STag_Name_FieldArea": "Field Area for a New Field",
  "ReportStringId.STag_Name_FormatString": "Format String",
  "ReportStringId.STag_Name_Height": "Height",
  "ReportStringId.STag_Name_MailMerge": "Mail Merge",
  "ReportStringId.STag_Name_PreviewRowCount": "Preview Row Count",
  "ReportStringId.STag_Name_SummaryFunc": "Summary Func",
  "ReportStringId.ScriptEditor_ClickValidate": "Click \"Validate\" to check scripts.",
  "ReportStringId.ScriptEditor_ErrorColumn": "Column",
  "ReportStringId.ScriptEditor_ErrorDescription": "Description",
  "ReportStringId.ScriptEditor_ErrorLine": "Line",
  "ReportStringId.ScriptEditor_NewString": "(New)",
  "ReportStringId.ScriptEditor_ScriptHasBeenChanged": "The error log is unrelated to the actual script, because the script was changed after its last validation.\nTo view actual script errors, click the Validate button again.",
  "ReportStringId.ScriptEditor_ScriptsAreValid": "All scripts are valid.",
  "ReportStringId.ScriptEditor_Validate": "Validate",
  "ReportStringId.SubreportDesigner_EditParameterBindings": "Edit Parameter Bindings...",
  "ReportStringId.UD_Capt_AlignBottoms": "&Bottoms",
  "ReportStringId.UD_Capt_AlignCenters": "&Centers",
  "ReportStringId.UD_Capt_AlignLefts": "&Lefts",
  "ReportStringId.UD_Capt_AlignMiddles": "&Middles",
  "ReportStringId.UD_Capt_AlignRights": "&Rights",
  "ReportStringId.UD_Capt_AlignToGrid": "to &Grid",
  "ReportStringId.UD_Capt_AlignTops": "&Tops",
  "ReportStringId.UD_Capt_BackGroundColor": "Bac&kground Color",
  "ReportStringId.UD_Capt_CenterInFormHorizontally": "&Horizontally",
  "ReportStringId.UD_Capt_CenterInFormVertically": "&Vertically",
  "ReportStringId.UD_Capt_Close": "&Close",
  "ReportStringId.UD_Capt_Copy": "&Copy",
  "ReportStringId.UD_Capt_Cut": "Cu&t",
  "ReportStringId.UD_Capt_Delete": "&Delete",
  "ReportStringId.UD_Capt_Exit": "E&xit",
  "ReportStringId.UD_Capt_FontBold": "&Bold",
  "ReportStringId.UD_Capt_FontItalic": "&Italic",
  "ReportStringId.UD_Capt_FontUnderline": "&Underline",
  "ReportStringId.UD_Capt_ForegroundColor": "For&eground Color",
  "ReportStringId.UD_Capt_FormattingToolbarName": "Formatting Toolbar",
  "ReportStringId.UD_Capt_JustifyCenter": "&Center",
  "ReportStringId.UD_Capt_JustifyJustify": "&Justify",
  "ReportStringId.UD_Capt_JustifyLeft": "&Left",
  "ReportStringId.UD_Capt_JustifyRight": "&Rights",
  "ReportStringId.UD_Capt_LayoutToolbarName": "Layout Toolbar",
  "ReportStringId.UD_Capt_MainMenuName": "Main Menu",
  "ReportStringId.UD_Capt_MakeSameSizeBoth": "&Both",
  "ReportStringId.UD_Capt_MakeSameSizeHeight": "&Height",
  "ReportStringId.UD_Capt_MakeSameSizeSizeToGrid": "Size to Gri&d",
  "ReportStringId.UD_Capt_MakeSameSizeWidth": "&Width",
  "ReportStringId.UD_Capt_MdiCascade": "&Cascade",
  "ReportStringId.UD_Capt_MdiTileHorizontal": "Tile &Horizontal",
  "ReportStringId.UD_Capt_MdiTileVertical": "Tile &Vertical",
  "ReportStringId.UD_Capt_NewReport": "&New",
  "ReportStringId.UD_Capt_NewWizardReport": "New via &Wizard...",
  "ReportStringId.UD_Capt_OpenFile": "&Open...",
  "ReportStringId.UD_Capt_OrderBringToFront": "&Bring to Front",
  "ReportStringId.UD_Capt_OrderSendToBack": "&Send to Back",
  "ReportStringId.UD_Capt_Paste": "&Paste",
  "ReportStringId.UD_Capt_Redo": "&Redo",
  "ReportStringId.UD_Capt_SaveAll": "Save A&ll",
  "ReportStringId.UD_Capt_SaveFile": "&Save",
  "ReportStringId.UD_Capt_SaveFileAs": "Save &As...",
  "ReportStringId.UD_Capt_SelectAll": "Select &All",
  "ReportStringId.UD_Capt_SpacingDecrease": "&Decrease",
  "ReportStringId.UD_Capt_SpacingIncrease": "&Increase",
  "ReportStringId.UD_Capt_SpacingMakeEqual": "Make &Equal",
  "ReportStringId.UD_Capt_SpacingRemove": "&Remove",
  "ReportStringId.UD_Capt_StatusBarName": "Status Bar",
  "ReportStringId.UD_Capt_TabbedInterface": "&Tabbed Interface",
  "ReportStringId.UD_Capt_ToolbarName": "Toolbar",
  "ReportStringId.UD_Capt_Undo": "&Undo",
  "ReportStringId.UD_Capt_Zoom": "Zoom",
  "ReportStringId.UD_Capt_ZoomFactor": "Zoom Factor: {0}%",
  "ReportStringId.UD_Capt_ZoomIn": "Zoom In",
  "ReportStringId.UD_Capt_ZoomOut": "Zoom Out",
  "ReportStringId.UD_Capt_ZoomToolbarName": "Zoom Toolbar",
  "ReportStringId.UD_FormCaption": "Report Designer",
  "ReportStringId.UD_Group_Align": "&Align",
  "ReportStringId.UD_Group_CenterInForm": "&Center in Form",
  "ReportStringId.UD_Group_DockPanelsList": "&Windows",
  "ReportStringId.UD_Group_Edit": "&Edit",
  "ReportStringId.UD_Group_File": "&File",
  "ReportStringId.UD_Group_Font": "&Font",
  "ReportStringId.UD_Group_Format": "Fo&rmat",
  "ReportStringId.UD_Group_HorizontalSpacing": "&Horizontal Spacing",
  "ReportStringId.UD_Group_Justify": "&Justify",
  "ReportStringId.UD_Group_MakeSameSize": "&Make Same Size",
  "ReportStringId.UD_Group_Order": "&Order",
  "ReportStringId.UD_Group_TabButtonsList": "Tab Buttons",
  "ReportStringId.UD_Group_ToolbarsList": "&Toolbars",
  "ReportStringId.UD_Group_VerticalSpacing": "&Vertical Spacing",
  "ReportStringId.UD_Group_View": "&View",
  "ReportStringId.UD_Group_Window": "&Window",
  "ReportStringId.UD_Hint_AlignBottoms": "Align the bottoms of selected controls",
  "ReportStringId.UD_Hint_AlignCenters": "Align the centers of selected controls vertically",
  "ReportStringId.UD_Hint_AlignLefts": "Left align selected controls",
  "ReportStringId.UD_Hint_AlignMiddles": "Align the centers of selected controls horizontally",
  "ReportStringId.UD_Hint_AlignRights": "Right align selected controls",
  "ReportStringId.UD_Hint_AlignToGrid": "Align the positions of selected controls to the grid",
  "ReportStringId.UD_Hint_AlignTops": "Align the tops of selected controls",
  "ReportStringId.UD_Hint_BackGroundColor": "Set the background color of the control",
  "ReportStringId.UD_Hint_CenterInFormHorizontally": "Horizontally center selected controls within a band",
  "ReportStringId.UD_Hint_CenterInFormVertically": "Vertically center selected controls within a band",
  "ReportStringId.UD_Hint_Close": "Close the report",
  "ReportStringId.UD_Hint_Copy": "Copy the control to the clipboard",
  "ReportStringId.UD_Hint_Cut": "Delete the control and copy it to the clipboard",
  "ReportStringId.UD_Hint_Delete": "Delete the control",
  "ReportStringId.UD_Hint_Exit": "Close the designer",
  "ReportStringId.UD_Hint_FontBold": "Make the font bold",
  "ReportStringId.UD_Hint_FontItalic": "Italicize the font",
  "ReportStringId.UD_Hint_FontUnderline": "Underline the font",
  "ReportStringId.UD_Hint_ForegroundColor": "Set the foreground color of the control",
  "ReportStringId.UD_Hint_JustifyCenter": "Align control text to the center",
  "ReportStringId.UD_Hint_JustifyJustify": "Justify control text",
  "ReportStringId.UD_Hint_JustifyLeft": "Align control text to the left",
  "ReportStringId.UD_Hint_JustifyRight": "Align control text to the right",
  "ReportStringId.UD_Hint_MakeSameSizeBoth": "Apply the same size to selected controls",
  "ReportStringId.UD_Hint_MakeSameSizeHeight": "Apply the same height to selected controls",
  "ReportStringId.UD_Hint_MakeSameSizeSizeToGrid": "Size selected controls to the grid",
  "ReportStringId.UD_Hint_MakeSameSizeWidth": "Apply the same width to selected controls",
  "ReportStringId.UD_Hint_MdiCascade": "Cascade all open documents so they overlap one another",
  "ReportStringId.UD_Hint_MdiTileHorizontal": "Arrange all open documents from top to bottom",
  "ReportStringId.UD_Hint_MdiTileVertical": "Arrange all open documents from left to right",
  "ReportStringId.UD_Hint_NewReport": "Create a new blank report",
  "ReportStringId.UD_Hint_NewWizardReport": "Create a new report using the Report Wizard",
  "ReportStringId.UD_Hint_OpenFile": "Open a report",
  "ReportStringId.UD_Hint_OrderBringToFront": "Bring selected controls to the front",
  "ReportStringId.UD_Hint_OrderSendToBack": "Move selected controls to the back",
  "ReportStringId.UD_Hint_Paste": "Add the control from the clipboard",
  "ReportStringId.UD_Hint_Redo": "Redo the last operation",
  "ReportStringId.UD_Hint_SaveAll": "Save all reports",
  "ReportStringId.UD_Hint_SaveFile": "Save the report",
  "ReportStringId.UD_Hint_SaveFileAs": "Save the report with a new name",
  "ReportStringId.UD_Hint_SelectAll": "Select all controls in the document",
  "ReportStringId.UD_Hint_SpacingDecrease": "Decrease the spacing between selected controls",
  "ReportStringId.UD_Hint_SpacingIncrease": "Increase the spacing between selected controls",
  "ReportStringId.UD_Hint_SpacingMakeEqual": "Apply the same spacing between selected controls",
  "ReportStringId.UD_Hint_SpacingRemove": "Remove spacing between selected controls",
  "ReportStringId.UD_Hint_TabbedInterface": "Switch between tabbed and window MDI layout modes",
  "ReportStringId.UD_Hint_Undo": "Undo the last operation",
  "ReportStringId.UD_Hint_ViewBars": "Hide or show the {0}",
  "ReportStringId.UD_Hint_ViewDockPanels": "Hide or show the {0} window",
  "ReportStringId.UD_Hint_ViewTabs": "Switch to the {0} tab",
  "ReportStringId.UD_Hint_Zoom": "Select or input a zoom factor",
  "ReportStringId.UD_Hint_ZoomIn": "Zoom in the design surface",
  "ReportStringId.UD_Hint_ZoomOut": "Zoom out the design surface",
  "ReportStringId.UD_Msg_ConvertBindingsCaption": "Convert",
  "ReportStringId.UD_Msg_ConvertBindings_LinkText": "Learn more about the expressions...",
  "ReportStringId.UD_Msg_ConvertBindings_RememberMyChoice": "Remember my choice and don't ask me again.",
  "ReportStringId.UD_Msg_MdiReportChanged": "\"{0}\" has been changed. Do you want to save changes?",
  "ReportStringId.UD_Msg_ReportChanged": "Report has been changed. Do you want to save changes?",
  "ReportStringId.UD_PropertyGrid_Menu_ItemExpression": "{0} Expression",
  "ReportStringId.UD_PropertyGrid_NotSetText": "(Not set)",
  "ReportStringId.UD_PropertyGrid_TabAppearance": "Appearance",
  "ReportStringId.UD_PropertyGrid_TabBehavior": "Behavior",
  "ReportStringId.UD_PropertyGrid_TabData": "Data",
  "ReportStringId.UD_PropertyGrid_TabFavorites_EmptyText": "Favorite properties are not specified for this report control.",
  "ReportStringId.UD_PropertyGrid_TabMiscellaneous": "Miscellaneous",
  "ReportStringId.UD_PropertyGrid_TabProperties": "Properties",
  "ReportStringId.UD_ReportDesigner": "Report Designer",
  "ReportStringId.UD_ReportGallery_Bands": "Bands",
  "ReportStringId.UD_ReportGallery_Reports": "Reports",
  "ReportStringId.UD_ReportGallery_Styles": "Styles",
  "ReportStringId.UD_SaveFileDialog_DialogFilter": "Report Files (*{0})|*{1}|All Files (*.*)|*.*",
  "ReportStringId.UD_TTip_AlignBottom": "Align Bottoms",
  "ReportStringId.UD_TTip_AlignHorizontalCenters": "Align Middles",
  "ReportStringId.UD_TTip_AlignLeft": "Align Lefts",
  "ReportStringId.UD_TTip_AlignRight": "Align Rights",
  "ReportStringId.UD_TTip_AlignToGrid": "Align to Grid",
  "ReportStringId.UD_TTip_AlignTop": "Align Tops",
  "ReportStringId.UD_TTip_AlignVerticalCenters": "Align Centers",
  "ReportStringId.UD_TTip_BringToFront": "Bring to Front",
  "ReportStringId.UD_TTip_CenterHorizontally": "Center Horizontally",
  "ReportStringId.UD_TTip_CenterVertically": "CenterVertically",
  "ReportStringId.UD_TTip_DataMemberDescription": "Data Member: {0}",
  "ReportStringId.UD_TTip_EditCopy": "Copy",
  "ReportStringId.UD_TTip_EditCut": "Cut",
  "ReportStringId.UD_TTip_EditPaste": "Paste",
  "ReportStringId.UD_TTip_FileOpen": "Open File",
  "ReportStringId.UD_TTip_FileSave": "Save File",
  "ReportStringId.UD_TTip_FormatAlignLeft": "Align Left",
  "ReportStringId.UD_TTip_FormatAlignRight": "Align Right",
  "ReportStringId.UD_TTip_FormatBackColor": "Background Color",
  "ReportStringId.UD_TTip_FormatBold": "Bold",
  "ReportStringId.UD_TTip_FormatCenter": "Center",
  "ReportStringId.UD_TTip_FormatFontName": "Font Name",
  "ReportStringId.UD_TTip_FormatFontSize": "Font Size",
  "ReportStringId.UD_TTip_FormatForeColor": "Foreground Color",
  "ReportStringId.UD_TTip_FormatItalic": "Italic",
  "ReportStringId.UD_TTip_FormatJustify": "Justify",
  "ReportStringId.UD_TTip_FormatUnderline": "Underline",
  "ReportStringId.UD_TTip_HorizSpaceConcatenate": "Remove Horizontal Spacing",
  "ReportStringId.UD_TTip_HorizSpaceDecrease": "Decrease Horizontal Spacing",
  "ReportStringId.UD_TTip_HorizSpaceIncrease": "Increase Horizontal Spacing",
  "ReportStringId.UD_TTip_HorizSpaceMakeEqual": "Apply Equal Horizontal Spacing",
  "ReportStringId.UD_TTip_ItemDescription": "Drag-and-drop this item to create a control bound to it;\n- or -\nDrag this item with the right mouse button or SHIFT\nto select a bound control from the popup menu;\n- or -\nUse the context menu to add a calculated field or parameter.",
  "ReportStringId.UD_TTip_Redo": "Redo",
  "ReportStringId.UD_TTip_SendToBack": "Send to Back",
  "ReportStringId.UD_TTip_SizeToControl": "Apply Same size",
  "ReportStringId.UD_TTip_SizeToControlHeight": "Apply Same Height",
  "ReportStringId.UD_TTip_SizeToControlWidth": "Apply Same Width",
  "ReportStringId.UD_TTip_SizeToGrid": "Size to Grid",
  "ReportStringId.UD_TTip_TableDescription": "Drag-and-drop this item to create a table with its items;\n- or -\nDrag this item with the right mouse button or SHIFT\nto create a 'header' table with field names;\n- or -\nUse the context menu to add a calculated field or parameter.",
  "ReportStringId.UD_TTip_Undo": "Undo",
  "ReportStringId.UD_TTip_VertSpaceConcatenate": "Remove Vertical Spacing",
  "ReportStringId.UD_TTip_VertSpaceDecrease": "Decrease Vertical Spacing",
  "ReportStringId.UD_TTip_VertSpaceIncrease": "Increase Vertical Spacing",
  "ReportStringId.UD_TTip_VertSpaceMakeEqual": "Apply Equal Vertical Spacing",
  "ReportStringId.UD_Title_ErrorList": "Report Design Analyzer",
  "ReportStringId.UD_Title_FieldList": "Field List",
  "ReportStringId.UD_Title_FieldList_AddNewDataSourceText": "Add New Data Source",
  "ReportStringId.UD_Title_FieldList_NonePickerNodeText": "None",
  "ReportStringId.UD_Title_FieldList_ProjectObjectsText": "Project Objects",
  "ReportStringId.UD_Title_GroupAndSort": "Group and Sort",
  "ReportStringId.UD_Title_PropertyGrid": "Properties",
  "ReportStringId.UD_Title_ReportExplorer": "Report Explorer",
  "ReportStringId.UD_Title_ReportExplorer_Components": "Components",
  "ReportStringId.UD_Title_ReportExplorer_FormattingRules": "Formatting Rules",
  "ReportStringId.UD_Title_ReportExplorer_NullControl": "None",
  "ReportStringId.UD_Title_ReportExplorer_Styles": "Styles",
  "ReportStringId.UD_Title_ToolBox": "Toolbox",
  "ReportStringId.UD_XtraReportsPointerItemCaption": "Pointer",
  "ReportStringId.UD_XtraReportsToolboxCategoryName": "Standard Controls",
  "ReportStringId.Verb_About": "About",
  "ReportStringId.Verb_AddFieldToArea": "Add Field to Area",
  "ReportStringId.Verb_Bind": "Bind",
  "ReportStringId.Verb_Delete": "Delete...",
  "ReportStringId.Verb_EditBands": "Edit and Reorder Bands...",
  "ReportStringId.Verb_EditBindings": "Edit Bindings...",
  "ReportStringId.Verb_EditGroupFields": "Edit GroupFields...",
  "ReportStringId.Verb_EditText": "Edit Text",
  "ReportStringId.Verb_Export": "Save/Export...",
  "ReportStringId.Verb_FormatString": "Format String...",
  "ReportStringId.Verb_Import": "Open/Import...",
  "ReportStringId.Verb_Insert": "Insert...",
  "ReportStringId.Verb_LoadReportTemplate": "Load Report Template...",
  "ReportStringId.Verb_RTFClear": "Clear",
  "ReportStringId.Verb_RTFLoad": "Load File...",
  "ReportStringId.Verb_ReportWizard": "Design in Report Wizard...",
  "ReportStringId.Verb_RevertCrossTabToPivotGrid": "Revert to Original Pivot Grid",
  "ReportStringId.Verb_RunDesigner": "Run Designer...",
  "ReportStringId.Verb_Save": "Save...",
  "ReportStringId.Verb_SummaryWizard": "Summary...",
  "ReportStringId.WAvgDisplayName": "Weighted average",
  "ReportStringId.Wizard_PageChooseFields_Msg": "You must select report fields before you continue",
  "ReportStringId.Wizard_ReportColorScheme_Blue": "Blue",
  "ReportStringId.Wizard_ReportColorScheme_Coral": "Coral",
  "ReportStringId.Wizard_ReportColorScheme_Cream": "Cream",
  "ReportStringId.Wizard_ReportColorScheme_Custom": "Custom",
  "ReportStringId.Wizard_ReportColorScheme_Grey": "Grey",
  "ReportStringId.Wizard_ReportColorScheme_Mint": "Mint",
  "ReportStringId.Wizard_ReportColorScheme_Raspberry": "Raspberry",
  "ReportStringId.Wizard_ReportColorScheme_Red": "Red",
  "ReportStringId.Wizard_ReportColorScheme_Violet": "Violet",
  "ReportStringId.Wizard_ReportColorScheme_Yellow": "Yellow",
  "ReportStringId.XRSubreport_NameInfo": "Name: {0}\n",
  "ReportStringId.XRSubreport_NullReportSourceInfo": "Null",
  "ReportStringId.XRSubreport_ReportSourceInfo": "Report Source: {0}\n",
  "ReportStringId.XRSubreport_ReportSourceUrlInfo": "Report Source URL: {0}\n",
  "System.Windows.Forms.CheckState.Checked": "Checked",
  "System.Windows.Forms.CheckState.Indeterminate": "Indeterminate",
  "UtilsUIStringId.Cmd_AddCalculatedField": "Add Calculated Field",
  "UtilsUIStringId.Cmd_AddParameter": "Add Parameter...",
  "UtilsUIStringId.Cmd_ClearCalculatedFields": "Remove All Calculated Fields",
  "UtilsUIStringId.Cmd_ClearParameters": "Remove All Parameters",
  "UtilsUIStringId.Cmd_DeleteCalculatedField": "Delete",
  "UtilsUIStringId.Cmd_DeleteParameter": "Delete",
  "UtilsUIStringId.Cmd_EditCalculatedFields": "Edit Calculated Fields...",
  "UtilsUIStringId.Cmd_EditExpression": "Edit Expression...",
  "UtilsUIStringId.Cmd_EditParameters": "Edit Parameters...",
  "UtilsUIStringId.CollectionEditor_Cancel": "Add or remove {0} objects",
  "UtilsUIStringId.FSForm_Cat_Currency": "Currency",
  "UtilsUIStringId.FSForm_Cat_DateTime": "DateTime",
  "UtilsUIStringId.FSForm_Cat_General": "General",
  "UtilsUIStringId.FSForm_Cat_Int32": "Int32",
  "UtilsUIStringId.FSForm_Cat_Number": "Number",
  "UtilsUIStringId.FSForm_Cat_Percent": "Percent",
  "UtilsUIStringId.FSForm_Cat_Special": "Special",
  "UtilsUIStringId.FSForm_Msg_BadSymbol": "Error: Illegal symbol(s)",
  "UtilsUIStringId.Msg_ContainsIllegalSymbols": "Input format string contains illegal symbol(s).",
  "UtilsUIStringId.Msg_ErrorTitle": "Error",
  "UtilsUIStringId.NonePickerNodeText": "None",
  "UtilsUIStringId.ParameterCollectionEditor_Title": "Parameters",
  "UtilsUIStringId.Parameter_Type_Boolean": "Boolean",
  "UtilsUIStringId.Parameter_Type_DateTime": "Date and Time",
  "UtilsUIStringId.Parameter_Type_Decimal": "Number (decimal)",
  "UtilsUIStringId.Parameter_Type_Double": "Number (double-precision floating-point)",
  "UtilsUIStringId.Parameter_Type_Float": "Number (floating-point)",
  "UtilsUIStringId.Parameter_Type_Guid": "Guid",
  "UtilsUIStringId.Parameter_Type_Int16": "Number (16 bit integer)",
  "UtilsUIStringId.Parameter_Type_Int32": "Number (32 bit integer)",
  "UtilsUIStringId.Parameter_Type_Int64": "Number (64 bit integer)",
  "UtilsUIStringId.Parameter_Type_String": "String",
  "UtilsUIStringId.PropGrid_TTip_Alphabetical": "Alphabetical",
  "UtilsUIStringId.PropGrid_TTip_Categorized": "Categorized",
  "UtilsUIStringId.PropGrid_TTip_Properties": "Properties"
}
